import React, { useContext, useEffect, useState } from "react";
import "../Components/Benefits/BenefitsAtlantica.css";
import "react-modern-drawer/dist/index.css";
import Header from "../Components/Header";
import { ThemeDataContext } from "../ContextProviders/theme";
import Ixian from "../Components/Benefits/BenefitsIxian";
import Drawer from "react-modern-drawer";
import { useMediaQuery } from "react-responsive";
import { VscCheck, VscCircleFilled, VscClose } from "react-icons/vsc";
import { useSelector } from "react-redux";
import * as _ from "lodash";
import { ALT, IXI, MAST, MK, LEPTOS } from "../Data/HotelCode";
import { ReactComponent as Alianthos } from "../Assets/Images/Alianthos.svg";
import { ReactComponent as AlianthosW } from "../Assets/Images/Alianthos_White.svg";
import { BsSuitDiamondFill } from "react-icons/bs";
import { FaCheck } from "react-icons/fa";

export default function Benefits({ toggle }) {
    const [Drawer1IsOpen, setDrawer1IsOpen] = React.useState(false);
    const [Drawer2IsOpen, setDrawer2IsOpen] = React.useState(false);
    const [Drawer3IsOpen, setDrawer3IsOpen] = React.useState(false);
    const [Drawer4IsOpen, setDrawer4IsOpen] = React.useState(false);
    const toggleDrawer1 = () => {
        setDrawer1IsOpen((prevState) => !prevState);
    };
    const toggleDrawer2 = () => {
        setDrawer2IsOpen((prevState) => !prevState);
    };
    const toggleDrawer3 = () => {
        setDrawer3IsOpen((prevState) => !prevState);
    };
    const toggleDrawer4 = () => {
        setDrawer4IsOpen((prevState) => !prevState);
    };

    const [barTiers, setBarTiers] = useState([]);
    const programLabel = localStorage.getItem("programLabel");

    const theme = useContext(ThemeDataContext) || {};
    const { tiers } = theme || {};

    const { portalInfo } = useContext(ThemeDataContext) || {};
    const { buttonBackgroundColor } = portalInfo || {};

    const userInfo = JSON.parse(localStorage.getItem("userInfo"));
    const memberInfo = userInfo.memberInfo;

    //console.log({programLabel})
    const [visibleCategory, setVisibleCategory] = useState("All");

    const Marbbenefits = {
        Accomodation: [
            [
                "Accommodation discount for direct reservations only",
                "",
                "5%",
                "10%",
                "15%",
            ],
            ["Welcome gift", "", "", <FaCheck />, <FaCheck />],
            [
                "Offering upon arrival",
                "Welcome drinks",
                "Welcome drinks",
                "VIP Check-in",
                "VIP Check-in",
            ],
            ["In room welcome offer", <FaCheck />, <FaCheck />, "VIP", "VIP"],
            ["Early Check-in *", "", <FaCheck />, <FaCheck />, <FaCheck />],
            [
                "Late Check-out *",
                "",
                <>
                    <FaCheck style={{ marginLeft: "2%" }} />*
                </>,
                "1 hr plus guaranteed",
                "2 hrs plus guaranteed",
            ],
            ["Farewell gift", "", <FaCheck />, <FaCheck />, <FaCheck />],
            ["Turn down Service", "", "", <FaCheck />, <FaCheck />],
            ["Complimentary Room upgrade *", "", "", "", <FaCheck />],
            ["Mini bar daily refilled ****", "", "", <FaCheck />, <FaCheck />],
        ],
        SPA: [["Spa treatments discount", "", "10%", "10%", "15%"]],
        FNB: [
            [
                "One Extra à la carte Dinner **(Pre-booking is required)",
                "",
                "",
                "",
                <FaCheck />,
            ],
            [
                "Food & Beverage discounts (where charges apply)",
                "",
                "10%",
                "10%",
                "10%",
            ],
            [
                "Sparkling wine breakfast in room (once per stay)",
                "",
                "",
                "",
                <FaCheck />,
            ],
            [
                "Complimentary Wine Tasting Session*",
                "",
                <FaCheck />,
                <FaCheck />,
                <FaCheck />,
            ],
            [
                "Complimentary Room Service",
                "",
                "",
                "Once per stay",
                "Once per stay",
            ],
        ],
        Other: [
            ["Laundry Services (*no dry cleaning)", "", "5%", "10%", "10%"],
            ["Land or Sea Excursions discount", "", "5%", "10%", "10%"],
            [
                "Kaiki/Sunset cruise reservation (MarBella bookings on priority, Nido, Avali)",
                "",
                "",
                "",
                <FaCheck />,
            ],
            ["Watersports discount", "", "", "10%", "10%"],
            [
                "60 min free use of non-motorised water sports",
                "",
                "",
                "",
                <FaCheck />,
            ],
            ["Car Hire discount", "", "", "10%", "10%"],
            ["Car Rental (Type C) for a day ***", "", "", "", <FaCheck />],
            [
                "Complimentary Roundtrip Airport Land transfers ***",
                "",
                "",
                "",
                <FaCheck />,
            ],
        ],
    };
    const MarbtierColors = ["#abffe6 ", "#33bfff", "#264dff", "#0019a6"];

    const Flmngbenefits = {
        Accomodation: [
            [
                "Discount by booking on our website (not applicable on special offers)",
                "14%",
                "16%",
                "18%",
            ],
            ["Members Only offers", <FaCheck />, <FaCheck />, <FaCheck />],
            ["Discount in Spa", "5%", "10%", "15%"],
            ["Welcome gift", "", <FaCheck />, <FaCheck />],
            ["Birthday Surprise", <FaCheck />, <FaCheck />, <FaCheck />],
            ["Customize your stay", <FaCheck />, <FaCheck />, <FaCheck />],
            ["Complimentary early check-in", "", <FaCheck />, <FaCheck />],
            ["Complimentary late check-out", "", "", <FaCheck />],
            ["Complimentary room service charge", "", <FaCheck />, <FaCheck />],
            [
                "Complimentary upgrade to next category room on the day of arrival",
                "",
                "",
                <FaCheck />,
            ],
            [
                "Poolside Drink Voucher (once per stay)",
                "",
                <FaCheck />,
                <FaCheck />,
            ],
            ["Complimentary dinner (once per stay)", "", "", <FaCheck />],
        ],
    };
    const FlmngtierColors = ["#FFFFFF", "#4169E1", "#FF69B4"];

    const Pillowbenefits = {
        Accomodation: [
            ["Member Rate for Direct Bookings", "10%", "15%", "20%", "20%"],
            [
                "Members Only offers",
                <FaCheck />,
                <FaCheck />,
                <FaCheck />,
                <FaCheck />,
            ],
            [
                "Welcome Amenity",
                "Bottle of wine and traditional Thessaloniki dessert (Armenonville)",
                "Bottle of wine and traditional Thessaloniki dessert (Armenonville)",
                "Bottle of wine and traditional Thessaloniki dessert (Armenonville)",
                "Bottle of wine and traditional Thessaloniki dessert (Armenonville)",
            ],
            [
                "Complimentary Secure Luggage Storage",
                <FaCheck />,
                <FaCheck />,
                <FaCheck />,
                <FaCheck />,
            ],
            [
                "Late Check-Out after 12.00 (Subject to Availability)",
                "upon availability",
                "till 14.00",
                "till 14.00",
                "till 14.00",
            ],
            [
                "Early Check-In (Subject to Availability)",
                <FaCheck />,
                <FaCheck />,
                <FaCheck />,
                <FaCheck />,
            ],
            ["Private Parking", "", "10%", "20%", "20%"],
            ["Breakfast", "", "10%", "20%", "20%"],
            ["Extra Birthday Points", "", "1000", "1500", "2000"],
            ["Room Upgrade", "", "", "upon availability", "upon availability"],
            ["Welcome Box", "", "", "", <FaCheck />],
        ],
    };
    const PillowtierColors = ["#667372", "#eddf92", "#383f49", "#383f49"];

    const Leptosbenefits = {
        Accomodation: [
            ["Discount on accommodation rates", "5%", "10%", "15%"],
            [
                "Exclusive offers for members only!",
                <FaCheck />,
                <FaCheck />,
                <FaCheck />,
            ],
            [
                "Discount on all SPA treatments (where applicable)",
                "10%",
                "15%",
                "20%",
            ],
            [
                "Welcome drink upon arrival",
                <FaCheck />,
                <FaCheck />,
                "plus Private check in by front office ",
            ],
            [
                "Early check-in, late check-out",
                "upon availability",
                "upon availability",
                "Guaranteed late check-out until 16:00",
            ],
            [
                "Welcome gift upon arrival in the room",
                "A bottle of local wine",
                "A bottle of local wine and a fruit platter",
                "A bottle of Prosecco and a fruit platter",
            ],
        ],
    };
    const LeptostierColors = ["#e4d5b8", "#d6c195", "#c9ac71"];

    const Anatoliabenefits = {
        Accomodation: [
            [
                "The opportunity to earn points",
                <FaCheck />,
                <FaCheck />,
                <FaCheck />,
            ],
            [
                "The opportunity to redeem points",
                <FaCheck />,
                <FaCheck />,
                <FaCheck />,
            ],
            [
                "Best rates guaranteed for direct bookings ",
                <FaCheck />,
                <FaCheck />,
                <FaCheck />,
            ],
            ["Exclusive member offersl", <FaCheck />, <FaCheck />, <FaCheck />],
            [
                "Welcome amenities in room",
                <FaCheck />,
                <FaCheck />,
                <FaCheck />,
            ],
            [
                "Best room available in booked category",
                <FaCheck />,
                <FaCheck />,
                <FaCheck />,
            ],
            [
                "Priority waitlist status ",
                <FaCheck />,
                <FaCheck />,
                <FaCheck />,
            ],
            [
                "Complimentary room upgrade upon check-in* ",
                "",
                <FaCheck />,
                <FaCheck />,
            ],
            ["Free early check-in* ", "", <FaCheck />, <FaCheck />],
            ["Free late checkout till 2:00pm*", "", <FaCheck />, <FaCheck />],
            ["Points  Multiplier", "", "10%", "20%"],
            ["Free daily breakfast ", "", "", <FaCheck />],
            ["Free parking* ", "", "", <FaCheck />],
            ["Exclusive lifetime experiences", "", "", <FaCheck />],
            ["Guaranteed room (48 hour prior notice) ", "", "", <FaCheck />],
            ["Gifts to upgrade your stay", "", "", <FaCheck />],
            ["Personalised In Room Experiences ", "", "", <FaCheck />],
        ],
    };
    const AnatoliatierColors = ["#D5D5D5", "#A2A2A2", "#B1A078"];

    const Louisbenefits = {
        Accomodation: [
            [
                "Award Points earned per euro spent (applies only if reservation is done on Louis Hotels websites.)",
                10,
                11,
                12,
                15,
            ],
            [
                "Earn points from your very first stay",
                <FaCheck />,
                <FaCheck />,
                <FaCheck />,
                <FaCheck />,
            ],
            [
                "Earn points on in-house dining purchases (1 Euro = 10 points)",
                <FaCheck />,
                <FaCheck />,
                <FaCheck />,
                <FaCheck />,
            ],
            [
                "Member-only discounts (applies only if reservation is done on Louis Hotels websites.)",
                "10%",
                "10%",
                "12%",
                "15%",
            ],
            [
                "Point redemption on award points",
                "",
                <FaCheck />,
                <FaCheck />,
                <FaCheck />,
            ],
            [
                "In-room welcome treat upon arrival",
                "",
                <FaCheck />,
                <FaCheck />,
                <FaCheck />,
            ],
            [
                "Best available room in category*",
                "",
                <FaCheck />,
                <FaCheck />,
                <FaCheck />,
            ],
            ["Early check-in*", "", "", <FaCheck />, <FaCheck />],
            ["Late check-out*", "", "", <FaCheck />, <FaCheck />],
            ["Laundry services discount", "", "", "10%", "15%"],
            ["Discounts on spa treatments", "", "", "15%", "20%"],
            ["Discount at on-site restaurants & bars", "", "", "10%", "15%"],
            ["Complimentary Room upgrade *", "", "", <FaCheck />, <FaCheck />],
            [
                "Complimentary return Airport transfers - from/to destination airport or complimentary Spa treatment (30 minutes / max 2 pax)",
                "",
                "",
                "",
                <FaCheck />,
            ],
            ["Guaranteed Room upgrade", "", "", "", <FaCheck />],
            [
                "Complimentary set-menu dinner at a themed restaurant (max 2 pax / food only)**",
                "",
                "",
                "",
                <FaCheck />,
            ],
            [
                "Complimentary Farewell Gift (1 per room)",
                "",
                "",
                "",
                <FaCheck />,
            ],
        ],
    };
    const LouistierColors = ["#f2d2bb", "#666666", "#8d6842", "#000000"];

    const Fzeenbenefits = {
        Accomodation: [
            ["Member rates for direct bookings", "5%", "5%", "5%", "5%"],
            [
                "Redeemable credits from accomodation",
                "10 points",
                "20 points",
                "30 points",
                "40 points",
            ],
            [
                "Online check-in",
                <FaCheck />,
                <FaCheck />,
                <FaCheck />,
                <FaCheck />,
            ],
            [
                "Members offers",
                <FaCheck />,
                <FaCheck />,
                <FaCheck />,
                <FaCheck />,
            ],
            [
                "Signature Gift on arrival",
                <FaCheck />,
                <FaCheck />,
                <FaCheck />,
                <FaCheck />,
            ],
            [
                "Redeemable credits from F ZEEN outlets (Restaurant & Spa & Boutique)",
                "",
                "10 points",
                "15 points",
                "20 points",
            ],
            [
                "Special occasion amenities",
                "",
                <FaCheck />,
                <FaCheck />,
                <FaCheck />,
            ],
            [
                "In room complimentary",
                "",
                "Wine",
                "Wine and meze board",
                "Champagne and fruit platter",
            ],
            [
                "Redeemable credits from F ZEEN outdoor activities (group or private)",
                "",
                "10 points",
                "15 points",
                "20 points",
            ],
            [
                "Complimentary airport transfer",
                "",
                "",
                "Upon arrival",
                "Both ways",
            ],
        ],
    };
    const FzeenColors = ["#D88552", "#8E9497", "#FFD352", "#C1C1C1"];

    const Savaidisbenefits = {
        Accomodation: [
            ["Member rates", "5%", "7%", "10%", "15%"],
            [
                "Welcome snack and drink",
                "",
                "Welcome drink & basic snack",
                "Upgraded welcome experience",
                "Premium & personalized",
            ],
            [
                "Farewell souvenir",
                "Farewell souvenir (small, standard)",
                "Farewell gift (small artisan item)",
                "Farewell gift (artisan product, higher tier)",
                "Farewell gift (signature luxury item)",
            ],
            [
                "Iconic Concierge Service",
                "",
                <FaCheck />,
                <FaCheck />,
                "dedicated contact",
            ],
            [
                "Personalized pre-arrival communication",
                `- Standard confirmation email & welcome message\n- Access to concierge for basic questions`,
                `- Personalized welcome message from the concierge team\n- Simple preference form (arrival time, allergies, special occasions)\n- Suggestions for restaurants or experiences upon request`,
                `- Dedicated pre-arrival contact from the concierge team\n- Detailed preference questionnaire (amenities, dining, activities)\n- Curated recommendations based on guest profile\n- Proposed itinerary outline before arrival`,
                `- Private concierge contact assigned to the guest\n- Full pre-arrival planning call/message\n- Custom itinerary created proactively\n- All in-villa/suite preferences arranged before check-in\n- Celebration planning (anniversaries, birthdays, surprises)`,
            ],
            [
                "Early check-in*",
                "standard fee applies",
                `Reduced fee or small fee waived`,
                `Complimentary`,
                `- Priority access\n- Complimentary`,
            ],
            [
                "Late check-out*",
                "standard fee applies",
                `Reduced fee or small fee waived`,
                `Complimentary`,
                `- Priority access\n- Complimentary`,
            ],
            [
                "Personalized itinerary planning",
                "- Basic recommendations available upon request (restaurants, beaches, simple suggestions)",
                `- Tailored suggestions based on guest preferences\n- Short list of handpicked restaurants / beaches / activities\n- Assistance with reservations upon request`,
                `- Curated day-by-day recommendations for the stay\n- Priority assistance with restaurant & activity bookings\n- Coordination of transfers, experiences, and timings\n- Optimized planning (best times to visit, insider tips)`,
                `- Fully customized itinerary designed before arrival\n- Proactive planning by private concierge\n- Arrangements for special moments (sunset setups, celebrations, surprises)\n- Daily check-ins and real-time adjustments during the stay\n- VIP coordination with partners (experiences, dining, wellness)`,
            ],
            [
                '"Night of Dreamers" private event',
                "",
                "",
                "",
                `The Night of Dreamers held once per season inside one of our villas or luxury suites, the evening includes:\n\n- Curated local wines or signature cocktails\n- Handcrafted bites from local artisans\n- Live soft music or acoustic performance\n- A small curated group of fellow Iconic members\n- Special surprise element (art, poetry, tasting ritual)\n- Personal welcome from the Iconic Selection team`,
            ],
            [
                "In-villa or suite breakfast experience",
                "",
                "",
                "",
                "An exclusive curated breakfast served privately in the guest's villa or suite (once per stay)",
            ],
            ["Complimentary upgrade*", "", "", "", <FaCheck />],
            [
                "Airport transfers",
                "Special discounted rate applied",
                "One-way airport transfer per stay",
                "Round-trip airport transfers per stay",
                "Premium round-trip airport transfer per stay",
            ],
        ],
    };
    const SavaidistierColors = ["#10142c", "#31acc2", "#717171", "#c8a266"];

    const masterCollectionBenefits = {
        Accomodation: [
            ["Nights / Year", "", "20", "40"],
            ["Exclusive Offers", <FaCheck />, <FaCheck />, <FaCheck />],
            ["Member Rates", "5%", "10%", "15%"],
            ["Welcome Treat", "", "", ""],
            ["Late Check Out", "", "", "13:00"],
            ["Early Check In", "", "", ""],

            ["Room Upgrade*", "", "", ""],
        ],
    };
    const masterCollectionColors = ["#efeded", "#957038", "#1b1b1b"];

    const Ellabenefits = {
        Earn: [
            [
                "Direct Bookings: Earn points at all Ella Resorts",
                <FaCheck />,
                <FaCheck />,
                <FaCheck />,
                <FaCheck />,
            ],
            [
                "Direct Bookings: Earn accelerator points",
                "0%",
                "10%",
                "20%",
                "50%",
            ],
            [
                "Indirect Bookings: Earn fixed points",
                <FaCheck />,
                <FaCheck />,
                <FaCheck />,
                <FaCheck />,
            ],
        ],
        ExclusiveSavings: [
            ["Direct Reservation discount", "15%", "15%", "15%", "15%"],
            [
                "Discount on Premium Dining/Venues/Wine Cellar",
                "5%",
                "10%",
                "15%",
                "20%",
            ],
            ["Wellness Treatments", "10%", "10%", "15%", "20%"],
            [
                "Payable Wellness Experiences & Events",
                "10%",
                "10%",
                "15%",
                "20%",
            ],
            ["Wellness Products", "10%", "10%", "10%", "10%"],
            ["Discount on Premium paid Spirits", "10%", "15%", "20%", "25%"],
        ],
        WellnessAddOn: [
            ["Spa Credits", "", "20 \u20AC", "30 \u20AC", "40 \u20AC"],
        ],
        WelcomeOffer: [
            [
                "Welcome offer",
                "Standard",
                "Tier Upgrade",
                "Tier Upgrade",
                "Tier Upgrade",
            ],
            [
                "Mini Bar selections",
                "Standard",
                "Tier Upgrade",
                "Tier Upgrade",
                "Tier Upgrade",
            ],
        ],
        Rooming: [
            [
                "Priority Check-in (web check-in)",
                <FaCheck />,
                <FaCheck />,
                <FaCheck />,
                <FaCheck />,
            ],
            [
                "Early Check-in",
                "Upon availability",
                "Priority Availability",
                "Guaranteed 12:00",
                "Guaranteed 10:00",
            ],
            [
                "Late Check-out",
                "Upon availability",
                "Priority Availability",
                "Guaranteed 14:00",
                "Guaranteed 16:00",
            ],
        ],
        AddedValue: [
            ["Farewell branded gift", "", "", "", <FaCheck />],
            [
                "Special treasure box with healthy products - sweets for children",
                "",
                "",
                "",
                <FaCheck />,
            ],
            ["Small surprises for children", "", "", "", <FaCheck />],
        ],
        FnBAddedValues: [
            [
                "In room dining - upon request - special 3 course menu",
                "",
                "",
                <FaCheck />,
                <FaCheck />,
            ],
            ["Secret Off-Menu Dish", "", <FaCheck />, <FaCheck />, <FaCheck />],
            ["Unlimited a la carte options", "", "", "", <FaCheck />],
            [
                "Free daily access to VIP a la carte breakfast",
                "",
                "",
                <FaCheck />,
                <FaCheck />,
            ],
        ],
        Experiences: [
            ["An Ellascape Experience", "", "", "", <FaCheck />],
            [
                'Exclusive picnic basket "Claim your place under the sun"',
                "",
                "",
                "",
                <FaCheck />,
            ],
        ],
        MilestoneRewards: [
            [
                'One complimentary night when entering "Legacy membership"',
                "",
                "",
                "",
                <FaCheck />,
            ],
            [
                'Two Signature Spa Rituals when entering "Quest membership"',
                "",
                "",
                <FaCheck />,
                "",
            ],
            [
                'Bonus Points when entering "Journey membership"',
                "",
                "10.000 points",
                "",
                "",
            ],
        ],
    };
    const EllatierColors = ["#FBF3E2", "#FBF3E2", "#142D28", "#000000"];

    // useEffect(() => {
    //   if (
    //     programLabel === 'ALT-14F4BCA1-339D-4E6F-92A7-04595936D72B' ||
    //     'ALT-INTG-14F4BCA1-339D-4E6F-92A7-04595936D72B'
    //   ) {
    //     const { tiers } = theme || { tiers: null };
    //     const bTiers =
    //       tiers &&
    //       tiers
    //         .filter((tier) => tier.barPercentage > 0)
    //         .map((tier) => ({
    //           name: tier.description,
    //           color: tier.color,
    //         }));
    //     setBarTiers(bTiers);
    //   } else if (
    //     programLabel === 'IXI-E98241F0-EE89-4B11-8F81-94C0CA0085FA' ||
    //     'IXI-INTG-E98241F0-EE89-4B11-8F81-94C0CA0085FA'
    //   ) {
    //     const bTiers =
    //       Ixian &&
    //       Ixian.map((tier) => ({
    //         name: tier.Name,
    //         apply: tier.Apply,
    //         color: tier.Color,
    //         benefits: tier.Benefits,
    //       }));
    //     setBarTiers(bTiers);
    //   }
    // }, [theme, Ixian]);

    // console.log(barTiers, 'barTiers');

    const Tablet = useMediaQuery({
        query: "(min-width: 768px) ",
    });

    const Mobile = useMediaQuery({
        query: "(min-width: 280px) and (max-width: 767px)",
    });

    const isSidebarVisible = useSelector(
        (state) => state.user.isSidebarVisible,
    );

    const [fullBenefitsList, setFullBenefitsList] = useState([]);
    const [benefitsListByTier, setBenefitsListByTier] = useState([]);

    useEffect(() => {
        const benefitsArray = Ixian.map((e) => e.Benefits);
        const benefits = [];
        benefitsArray.forEach((benefit) =>
            benefit.forEach((benefit) => benefits.push(benefit)),
        );

        const uniq = [...new Set(benefits)];

        setFullBenefitsList(uniq);
    }, []);

    // function GenerateBenefitsListByTier(benefits) {
    //   let array = [];
    //   for (let i = 0; i < benefits.length; i++) {
    //     let array1 = Ixian[i].Benefits;
    //     array.push(array1);
    //   }

    //   console.log(array, 'array');
    //   return array;
    // }

    // useEffect(() => {
    //   setBenefitsListByTier(GenerateBenefitsListByTier(Ixian));
    // }, [Ixian]);

    // const getBulletPoint = () => {
    //   return <VscCircleFilled />;
    // };

    return (
        <>
            <Header />
            <div
                style={{
                    visibility: `${isSidebarVisible ? "hidden" : "visible"}`,
                }}
            >
                <div className="Benefits-heading">
                    <h1>Benefits</h1>
                    <hr className="Benefits-line"></hr>
                    <br />
                    <br />

                    {/* {programLabel === 'IXI-E98241F0-EE89-4B11-8F81-94C0CA0085FA' &&
            Tablet && (
              <>
                <button
                  className='Benefits-button'
                  style={{
                    background: `${tiers[0].color}`,
                  }}
                  onClick={toggleDrawer1}>
                  {barTiers[0]?.name}
                </button>
                <Drawer
                  open={Drawer1IsOpen}
                  onClose={toggleDrawer1}
                  direction='top'
                  style={{ marginTop: '7rem' }}
                  className='Benefits-Drawer'>
                  <div
                    style={{
                      transform: 'translateY(100%)',
                      display: 'block',
                      width: '100%',
                      height: '100px',
                      justifyContent: 'left',
                    }}>
                    {barTiers[0]?.benefits.map((benefit, index) => (
                      <p
                        key={index}
                        style={{ display: 'block', fontSize: '1.25rem' }}>
                        {benefit}
                      </p>
                    ))}
                  </div>
                </Drawer>
                <button
                  className='Benefits-button'
                  style={{
                    background: `${tiers[1].color}`,
                  }}
                  onClick={toggleDrawer2}>
                  {barTiers[1]?.name}
                </button>
                <Drawer
                  open={Drawer2IsOpen}
                  onClose={toggleDrawer2}
                  direction='left'
                  style={{
                    paddingLeft: '1rem',
                    width: '30vw',
                    marginTop: '9rem',
                    overflow: 'scroll',
                  }}
                  className='Benefits-Drawer'>
                  <div
                    style={{
                      transform: 'translateY(30%)',
                      display: 'block',
                      textAlign: 'left',
                    }}>
                    {barTiers[1]?.benefits.map((benefit, index) => (
                      <p
                        style={{
                          lineHeight: '2rem',
                          fontSize: '1.25rem',
                          marginBottom: '1rem',
                        }}
                        key={index}>
                        {benefit}
                      </p>
                    ))}
                  </div>
                </Drawer>
                <button
                  className='Benefits-button'
                  style={{ background: `${tiers[2].color}` }}
                  onClick={toggleDrawer3}>
                  {barTiers[2]?.name}
                </button>
                <Drawer
                  open={Drawer3IsOpen}
                  onClose={toggleDrawer3}
                  direction='bottom'
                  style={{ height: '65.5vh', paddingTop: '2rem' }}
                  className='Benefits-Drawer'>
                  <div
                    style={{
                      transform: 'translateY(0%)',
                      fontSize: '1.25rem',
                      margin: '0',
                      lineheight: '0.5rem',
                      height: '10px',
                      padding: '0',
                    }}>
                    {barTiers[2]?.benefits.map((benefit, index) => (
                      <p>{benefit}</p>
                    ))}
                  </div>
                </Drawer>
                <button
                  className='Benefits-button'
                  style={{ background: `${tiers[3].color}` }}
                  onClick={toggleDrawer4}>
                  {barTiers[3]?.name}
                </button>
                <Drawer
                  open={Drawer4IsOpen}
                  onClose={toggleDrawer4}
                  direction='right'
                  style={{ width: '80vw', marginTop: '12.5rem' }}
                  className='Benefits-Drawer'>
                  <div
                    style={{
                      transform: 'translateY(0%)',
                      fontSize: '1.25rem',
                    }}>
                    {barTiers[3]?.benefits.map((benefit, index) => (
                      <p key={index}>{benefit}</p>
                    ))}
                  </div>
                </Drawer>
              </>
            )} */}
                    {/* {programLabel === 'IXI-E98241F0-EE89-4B11-8F81-94C0CA0085FA' &&
            Mobile && (
              <>
                <button
                  className='Benefits-button'
                  style={{ background: `${tiers[0].color}` }}
                  onClick={toggleDrawer1}>
                  {barTiers[0]?.name}
                </button>
                <Drawer
                  open={Drawer1IsOpen}
                  onClose={toggleDrawer1}
                  direction='top'
                  style={{ marginTop: '1rem' }}
                  className='Benefits-Drawer'>
                  <div className='Benefits-Drawer1'>{barTiers[0]?.apply}</div>
                  <div
                    style={{
                      transform: 'translateY(100%)',
                      display: 'block',
                      width: '100%',
                      height: '100px',
                      justifyContent: 'left',
                    }}>
                    {barTiers[0]?.benefits.map((benefit, index) => (
                      <p
                        key={index}
                        style={{ display: 'block', fontSize: '0.83rem' }}>
                        {benefit}
                      </p>
                    ))}
                  </div>
                </Drawer>
                <button
                  className='Benefits-button'
                  style={{ background: `${tiers[1].color}` }}
                  onClick={toggleDrawer2}>
                  {barTiers[1]?.name}
                </button>
                <Drawer
                  open={Drawer2IsOpen}
                  onClose={toggleDrawer2}
                  direction='left'
                  style={{
                    paddingLeft: '1rem',
                    width: '75vw',
                    overflow: 'scroll',
                    paddingTop: '1.5rem',
                  }}
                  className='Benefits-Drawer'>
                  <div
                    style={{
                      transform: 'translateY(30%)',
                      display: 'block',
                      textAlign: 'left',
                      overflow: 'scroll',
                    }}>
                    {barTiers[1]?.benefits.map((benefit, index) => (
                      <p
                        style={{
                          margin: '0',
                          lineHeight: '2rem',
                          fontSize: '0.83rem',
                        }}
                        key={index}>
                        {benefit}
                      </p>
                    ))}
                  </div>
                </Drawer>
                <button
                  className='Benefits-button'
                  style={{ background: `${tiers[2].color}` }}
                  onClick={toggleDrawer3}>
                  {barTiers[2]?.name}
                </button>
                <Drawer
                  open={Drawer3IsOpen}
                  onClose={toggleDrawer3}
                  direction='bottom'
                  style={{
                    height: '60.5vh',
                    paddingTop: '2rem',
                    overflow: 'scroll',
                  }}
                  className='Benefits-Drawer'>
                  <div
                    style={{
                      transform: 'translateY(0%)',
                      fontSize: '0.83rem',
                      margin: '0',
                      lineheight: '0.5rem',
                      padding: '0',
                    }}>
                    {barTiers[2]?.benefits.map((benefit, index) => (
                      <p>{benefit}</p>
                    ))}
                  </div>
                </Drawer>
                <button
                  className='Benefits-button'
                  style={{ background: `${tiers[3].color}` }}
                  onClick={toggleDrawer4}>
                  {barTiers[3]?.name}
                </button>
                <Drawer
                  open={Drawer4IsOpen}
                  onClose={toggleDrawer4}
                  direction='right'
                  style={{
                    width: '80vw',
                    paddingLeft: '1rem',

                    marginTop: '7rem',
                    textAlign: 'left',
                    overflowY: 'scroll',
                  }}
                  className='Benefits-Drawer'>
                  <div style={{ display: 'block', overflowY: 'scroll' }}>
                    {barTiers[3]?.benefits.map((benefit, index) => (
                      <p
                        style={{
                          fontSize: '0.83rem',
                          marginBottom: '0rem',
                          lineHeight: '2rem',
                        }}
                        key={index}>
                        {benefit}
                      </p>
                    ))}
                  </div>
                </Drawer>
              </>
            )} */}
                </div>
                {/* {programLabel === 'IXI-E98241F0-EE89-4B11-8F81-94C0CA0085FA' && (
          <table className='Benefits-tableContainer'>
            <thead>
              <th>
                <td>{Ixian[0].title}</td>
              </th>
            </thead>
            <tbody>
              <tr className='Benefits-headings'>
                <td
                  id='Benefits-benefits'
                  style={{
                    fontWeight: '600',
                    textAlign: 'center',
                    width: '40%',
                  }}>
                  Benefits at a glance
                </td>
                {Ixian.map((e, index) => (
                  <td
                    key={index}
                    className='Benefits-Tier'
                    style={{
                      textAlign: 'center',
                      fontWeight: '600',
                      width: '40%',
                    }}>
                    {e.Name}
                  </td>
                ))}
              </tr>
              {fullBenefitsList.map((benefit, index) => (
                <tr id='Benefits-benefits' key={index}>
                  <td>{benefit}</td>
                  <td style={{ textAlign: 'center' }}>{getBulletPoint()}</td>
                  <td style={{ textAlign: 'center' }}>{getBulletPoint()}</td>
                  <td style={{ textAlign: 'center' }}>{getBulletPoint()}</td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
        <table className='Benefits-tableContainer'>
          <thead>
            <th
              style={{
                display: 'block',
                justifyContent: 'center',
                width: '100%',
              }}>
              <td className='Benefits-title'>Ixian Grand Club</td>
            </th>
          </thead>

          <tbody>
            <tr className='Benefits-headings'>
              <td
                style={{
                  fontWeight: '600',
                  textAlign: 'center',
                  width: '40%',
                }}>
                Benefits at a glance
              </td>
              <td
                style={{
                  background: `${tiers[0].color}`,
                  fontWeight: '600',
                  textAlign: 'center',
                  className: 'Benefits-Tier',
                }}>
                Level 1
              </td>
              <td
                style={{
                  background: `${tiers[1].color}`,
                  fontWeight: '600',
                  textAlign: 'center',
                  className: 'Benefits-Tier',
                }}>
                Level 2
              </td>
              <td
                style={{
                  background: `${tiers[2].color}`,

                  textAlign: 'center',
                  className: 'Benefits-Tier',
                  color: 'white',
                }}>
                Level 3
              </td>
            </tr>
            <tr>
              <td id='Benefits-benefits'>
                Spend 1€, get 1 loyalty point
              </td>

              <td
                style={{
                  background: `${tiers[0].color}`,
                  textAlign: 'center',
                }}>
                <VscCircleFilled />
              </td>
              <td
                style={{
                  background: `${tiers[1].color}`,
                  textAlign: 'center',
                }}>
                {' '}
                <VscCircleFilled />
              </td>
              <td
                style={{
                  background: `${tiers[2].color}`,
                  textAlign: 'center',
                  color: 'white',
                }}>
                {' '}
                <VscCircleFilled />
              </td>
            </tr>
            <tr>
              <td id='Benefits-benefits'>
                Discount for direct bookings
              </td>

              <td
                style={{
                  background: `${tiers[0].color}`,
                  textAlign: 'center',
                }}>
                5%
              </td>
              <td
                style={{
                  background: `${tiers[1].color}`,
                  textAlign: 'center',
                }}>
                7%
              </td>
              <td
                style={{
                  background: `${tiers[2].color}`,
                  textAlign: 'center',
                  color: 'white',
                }}>
                10%
              </td>
            </tr>
            <tr>
              <td id='Benefits-benefits'>
                A bottle of wine, water and a fruit basket in room upon arrival
                (applies only for online bookings via atlanticahotels.com)
              </td>

              <td
                style={{
                  background: `${tiers[0].color}`,
                  textAlign: 'center',
                }}>
                <VscCircleFilled />
              </td>
              <td
                style={{
                  background: `${tiers[1].color}`,
                  textAlign: 'center',
                }}>
                <VscCircleFilled />
              </td>
              <td
                style={{
                  background: `${tiers[2].color}`,
                  textAlign: 'center',
                  color: 'white',
                }}>
                <VscCircleFilled />
              </td>
            </tr>
            <tr>
              <td id='Benefits-benefits'>
                Late check-out until 14.00 (<i>subject to availability</i>)
              </td>

              <td
                style={{
                  background: `${tiers[0].color}`,
                  textAlign: 'center',
                }}></td>
              <td
                style={{
                  background: `${tiers[1].color}`,
                  textAlign: 'center',
                }}>
                <VscCircleFilled />
              </td>
              <td
                style={{
                  background: `${tiers[2].color}`,
                  textAlign: 'center',
                  color: 'white',
                }}>
                <VscCircleFilled />
              </td>
            </tr>
            <tr>
              <td id='Benefits-benefits'>
                One free a la Carte meal* during stay in the Hotel (
                <i>
                  Applies for Atlantica Hotels which operate A La Carte
                  Restaurants
                </i>
              </td>

              <td
                style={{
                  background: `${tiers[0].color}`,
                  textAlign: 'center',
                }}></td>
              <td
                style={{
                  background: `${tiers[1].color}`,
                  textAlign: 'center',
                }}></td>
              <td
                style={{
                  background: `${tiers[2].color}`,
                  textAlign: 'center',
                  color: 'white',
                }}>
                <VscCircleFilled />
              </td>
            </tr>
            <tr>
              <td id='Benefits-benefits'>
                Late check-out until 18.00 (subject to availability)
              </td>

              <td
                style={{
                  background: `${tiers[0].color}`,
                  textAlign: 'center',
                }}></td>
              <td
                style={{
                  background: `${tiers[1].color}`,
                  textAlign: 'center',
                }}></td>
              <td
                style={{
                  background: `${tiers[2].color}`,
                  textAlign: 'center',
                  color: 'white',
                }}>
                <VscCircleFilled />
              </td>
            </tr>
            <tr>
              <td id='Benefits-benefits'>
                Room Upgrade (subject to availability)
              </td>

              <td
                style={{
                  background: `${tiers[0].color}`,
                  textAlign: 'center',
                }}></td>
              <td
                style={{
                  background: `${tiers[1].color}`,
                  textAlign: 'center',
                }}></td>
              <td
                style={{
                  background: `${tiers[2].color}`,
                  textAlign: 'center',
                  color: 'white',
                }}>
                <VscCircleFilled />
              </td>
            </tr>
          </tbody>
        </table>
        ) */}
                {(programLabel === MAST.PROD || programLabel === MAST.INTG) && (
                    <div className="Benefits-tableContainer-Parent">
                        <table className="Benefits-tableContainer">
                            <thead></thead>
                            <tbody>
                                <tr className="Benefits-headings">
                                    <td
                                        id="Benefits-TierGlance"
                                        style={{
                                            textAlign: "center",
                                            width: "40%",
                                        }}
                                    >
                                        Benefits at a glance
                                    </td>

                                    <td
                                        id="Benefits-Tier"
                                        style={{
                                            background: `${tiers[0].color}`,
                                            textAlign: "center",
                                        }}
                                    >
                                        Member
                                    </td>
                                    <td
                                        id="Benefits-Tier"
                                        style={{
                                            background: `${tiers[1].color}`,
                                            textAlign: "center",
                                        }}
                                    >
                                        Companion
                                    </td>
                                    <td
                                        id="Benefits-Tier"
                                        style={{
                                            background: `${tiers[2].color}`,
                                            textAlign: "center",
                                        }}
                                    >
                                        Partner
                                    </td>
                                    <td
                                        id="Benefits-Tier"
                                        style={{
                                            background: `${tiers[3].color}`,
                                            textAlign: "center",
                                            color: "white",
                                        }}
                                    >
                                        Ambassador
                                    </td>
                                </tr>
                                <tr>
                                    <td id="Benefits-benefits">
                                        Discount for direct bookings
                                    </td>

                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[0].color}`,
                                            textAlign: "center",
                                        }}
                                    >
                                        5%
                                    </td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[1].color}`,
                                            textAlign: "center",
                                        }}
                                    >
                                        5%
                                    </td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[2].color}`,
                                            textAlign: "center",
                                        }}
                                    >
                                        7.5%*
                                    </td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[3].color}`,
                                            textAlign: "center",
                                            color: "white",
                                        }}
                                    >
                                        10%*
                                    </td>
                                </tr>
                                <tr>
                                    <td id="Benefits-benefits">
                                        Discount for spa treatments**
                                    </td>

                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[0].color}`,
                                            textAlign: "center",
                                        }}
                                    ></td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[1].color}`,
                                            textAlign: "center",
                                        }}
                                    >
                                        5%
                                    </td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[2].color}`,
                                            textAlign: "center",
                                        }}
                                    >
                                        7.5%*
                                    </td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[3].color}`,
                                            textAlign: "center",
                                            color: "white",
                                        }}
                                    >
                                        10%*
                                    </td>
                                </tr>
                                <tr>
                                    <td id="Benefits-benefits">
                                        Earn status and redeemable points from
                                        stays and extra room charges
                                    </td>

                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[0].color}`,
                                            textAlign: "center",
                                        }}
                                    >
                                        <VscCircleFilled />
                                    </td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[1].color}`,
                                            textAlign: "center",
                                        }}
                                    >
                                        <VscCircleFilled />
                                    </td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[2].color}`,
                                            textAlign: "center",
                                        }}
                                    >
                                        <VscCircleFilled />
                                    </td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[3].color}`,
                                            textAlign: "center",
                                            color: "white",
                                        }}
                                    >
                                        <VscCircleFilled />
                                    </td>
                                </tr>
                                <tr>
                                    <td id="Benefits-benefits">
                                        Exclusive offers
                                    </td>

                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[0].color}`,
                                            textAlign: "center",
                                        }}
                                    >
                                        <VscCircleFilled />
                                    </td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[1].color}`,
                                            textAlign: "center",
                                        }}
                                    >
                                        <VscCircleFilled />
                                    </td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[2].color}`,
                                            textAlign: "center",
                                        }}
                                    >
                                        <VscCircleFilled />
                                    </td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[3].color}`,
                                            textAlign: "center",
                                            color: "white",
                                        }}
                                    >
                                        <VscCircleFilled />
                                    </td>
                                </tr>
                                <tr>
                                    <td id="Benefits-benefits">
                                        Free upgrade (upon availability)
                                    </td>

                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[0].color}`,
                                            textAlign: "center",
                                        }}
                                    ></td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[1].color}`,
                                            textAlign: "center",
                                        }}
                                    >
                                        <VscCircleFilled />
                                    </td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[2].color}`,
                                            textAlign: "center",
                                        }}
                                    >
                                        <VscCircleFilled />
                                    </td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[3].color}`,
                                            textAlign: "center",
                                            color: "white",
                                        }}
                                    >
                                        <VscCircleFilled />
                                    </td>
                                </tr>
                                <tr>
                                    <td id="Benefits-benefits">
                                        Special farewell gift according to tier
                                    </td>

                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[0].color}`,
                                            textAlign: "center",
                                        }}
                                    ></td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[1].color}`,
                                            textAlign: "center",
                                        }}
                                    >
                                        <VscCircleFilled
                                            style={{ marginLeft: "7%" }}
                                        />
                                        **
                                    </td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[2].color}`,
                                            textAlign: "center",
                                            // color: 'white',
                                        }}
                                    >
                                        <VscCircleFilled
                                            style={{ marginLeft: "7%" }}
                                        />
                                        **
                                    </td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[3].color}`,
                                            textAlign: "center",
                                            color: "white",
                                        }}
                                    >
                                        <VscCircleFilled
                                            style={{ marginLeft: "7%" }}
                                        />
                                        **
                                    </td>
                                </tr>
                                <tr>
                                    <td id="Benefits-benefits">
                                        Complimentary late check out (on
                                        request, upon availability)
                                    </td>

                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[0].color}`,
                                            textAlign: "center",
                                        }}
                                    ></td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[1].color}`,
                                            textAlign: "center",
                                        }}
                                    ></td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[2].color}`,
                                            textAlign: "center",
                                        }}
                                    >
                                        <VscCircleFilled />
                                    </td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[3].color}`,
                                            textAlign: "center",
                                            color: "white",
                                        }}
                                    >
                                        <VscCircleFilled />
                                    </td>
                                </tr>

                                <tr>
                                    <td id="Benefits-benefits">
                                        Complimentary Spa treatment for two**
                                    </td>

                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[0].color}`,
                                            textAlign: "center",
                                        }}
                                    ></td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[1].color}`,
                                            textAlign: "center",
                                        }}
                                    ></td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[2].color}`,
                                            textAlign: "center",
                                        }}
                                    ></td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[3].color}`,
                                            textAlign: "center",
                                            color: "white",
                                        }}
                                    >
                                        <VscCircleFilled />
                                    </td>
                                </tr>
                                <tr>
                                    <td id="Benefits-benefits">
                                        Free Partner status for a person of your
                                        choice
                                    </td>

                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[0].color}`,
                                            textAlign: "center",
                                        }}
                                    ></td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[1].color}`,
                                            textAlign: "center",
                                        }}
                                    ></td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[2].color}`,
                                            textAlign: "center",
                                        }}
                                    ></td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[3].color}`,
                                            textAlign: "center",
                                            color: "white",
                                        }}
                                    >
                                        <VscCircleFilled />
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                        <div>
                            <div className="text-md italic note text-left">
                                * valid for April to October months{" "}
                            </div>
                            <div className="text-md italic note text-left">
                                ** valid for stays at Parga Beach Resort
                            </div>
                        </div>
                    </div>
                )}

                {(programLabel === IXI.PROD || programLabel === IXI.INTG) && (
                    <div className="Benefits-tableContainer-Parent">
                        <table className="Benefits-tableContainer">
                            <thead></thead>
                            <tbody>
                                <tr className="Benefits-headings">
                                    <td
                                        id="Benefits-Tier"
                                        style={{
                                            fontWeight: "600",
                                            textAlign: "center",
                                        }}
                                    >
                                        Benefits at a glance
                                    </td>

                                    <td
                                        id="Benefits-Tier"
                                        style={{
                                            background: `${tiers[0].color}`,

                                            fontWeight: "600",
                                            textAlign: "center",
                                        }}
                                    >
                                        White
                                    </td>
                                    <td
                                        id="Benefits-Tier"
                                        style={{
                                            background: `${tiers[1].color}`,

                                            fontWeight: "600",
                                            textAlign: "center",
                                        }}
                                    >
                                        Blue
                                    </td>
                                    <td
                                        id="Benefits-Tier"
                                        style={{
                                            background: `${tiers[2].color}`,

                                            fontWeight: "600",
                                            textAlign: "center",
                                        }}
                                    >
                                        Silver
                                    </td>
                                    <td
                                        id="Benefits-Tier"
                                        style={{
                                            background: `${tiers[3].color}`,
                                            fontWeight: "600",
                                            textAlign: "center",
                                        }}
                                    >
                                        Gold
                                    </td>
                                </tr>
                                <tr>
                                    <td id="Benefits-benefits">
                                        {fullBenefitsList[0]}
                                    </td>

                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[0].color}`,
                                            textAlign: "center",
                                        }}
                                    >
                                        <VscCircleFilled />
                                    </td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[1].color}`,
                                            textAlign: "center",
                                        }}
                                    >
                                        {" "}
                                        <VscCircleFilled />
                                    </td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[2].color}`,
                                            textAlign: "center",
                                        }}
                                    >
                                        <VscCircleFilled />
                                    </td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[3].color}`,
                                            textAlign: "center",
                                        }}
                                    >
                                        <VscCircleFilled />
                                    </td>
                                </tr>
                                <tr>
                                    <td id="Benefits-benefits">
                                        {fullBenefitsList[1]}
                                    </td>

                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[0].color}`,
                                            textAlign: "center",
                                        }}
                                    >
                                        <VscCircleFilled />
                                    </td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[1].color}`,
                                            textAlign: "center",
                                        }}
                                    >
                                        <VscCircleFilled />
                                    </td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[2].color}`,
                                            textAlign: "center",
                                        }}
                                    >
                                        <VscCircleFilled />
                                    </td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[3].color}`,
                                            textAlign: "center",
                                        }}
                                    >
                                        <VscCircleFilled />
                                    </td>
                                </tr>
                                <tr>
                                    <td id="Benefits-benefits">
                                        {fullBenefitsList[2]}
                                    </td>

                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[0].color}`,
                                            textAlign: "center",
                                        }}
                                    >
                                        <VscCircleFilled />
                                    </td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[1].color}`,
                                            textAlign: "center",
                                        }}
                                    >
                                        <VscCircleFilled />
                                    </td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[2].color}`,
                                            textAlign: "center",
                                        }}
                                    >
                                        <VscCircleFilled />
                                    </td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[3].color}`,
                                            textAlign: "center",
                                        }}
                                    >
                                        <VscCircleFilled />
                                    </td>
                                </tr>
                                <tr>
                                    <td id="Benefits-benefits">
                                        {fullBenefitsList[3]}
                                    </td>

                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[0].color}`,
                                            textAlign: "center",
                                        }}
                                    >
                                        10%
                                    </td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[1].color}`,
                                            textAlign: "center",
                                        }}
                                    >
                                        10%
                                    </td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[2].color}`,
                                            textAlign: "center",
                                        }}
                                    >
                                        15%
                                    </td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[3].color}`,
                                            textAlign: "center",
                                        }}
                                    >
                                        15%
                                    </td>
                                </tr>
                                <tr>
                                    <td id="Benefits-benefits">
                                        {fullBenefitsList[4]}
                                    </td>

                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[0].color}`,
                                            textAlign: "center",
                                        }}
                                    ></td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[1].color}`,
                                            textAlign: "center",
                                        }}
                                    >
                                        {" "}
                                        <VscCircleFilled />
                                    </td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[2].color}`,
                                            textAlign: "center",
                                        }}
                                    >
                                        <VscCircleFilled />
                                    </td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[3].color}`,
                                            textAlign: "center",
                                        }}
                                    >
                                        <VscCircleFilled />
                                    </td>
                                </tr>
                                <tr>
                                    <td id="Benefits-benefits">
                                        {fullBenefitsList[5]}
                                    </td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[0].color}`,
                                            textAlign: "center",
                                        }}
                                    ></td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[1].color}`,
                                            textAlign: "center",
                                        }}
                                    >
                                        5%
                                    </td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[2].color}`,
                                            textAlign: "center",
                                        }}
                                    >
                                        10%
                                    </td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[3].color}`,
                                            textAlign: "center",
                                        }}
                                    >
                                        10%
                                    </td>
                                </tr>
                                <tr>
                                    <td id="Benefits-benefits">
                                        {fullBenefitsList[6]}
                                    </td>

                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[0].color}`,
                                            textAlign: "center",
                                        }}
                                    ></td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[1].color}`,
                                            textAlign: "center",
                                        }}
                                    >
                                        5%
                                    </td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[2].color}`,
                                            textAlign: "center",
                                        }}
                                    >
                                        10%
                                    </td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[3].color}`,
                                            textAlign: "center",
                                        }}
                                    >
                                        10%
                                    </td>
                                </tr>

                                <tr>
                                    <td id="Benefits-benefits">
                                        {fullBenefitsList[7]}
                                    </td>

                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[0].color}`,
                                            textAlign: "center",
                                        }}
                                    ></td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[1].color}`,
                                            textAlign: "center",
                                        }}
                                    >
                                        {" "}
                                        <VscCircleFilled />
                                    </td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[2].color}`,
                                            textAlign: "center",
                                        }}
                                    >
                                        <VscCircleFilled />
                                    </td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[3].color}`,
                                            textAlign: "center",
                                        }}
                                    >
                                        <VscCircleFilled />
                                    </td>
                                </tr>
                                <tr>
                                    <td id="Benefits-benefits">
                                        {fullBenefitsList[8]}
                                    </td>

                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[0].color}`,
                                            textAlign: "center",
                                        }}
                                    ></td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[1].color}`,
                                            textAlign: "center",
                                        }}
                                    ></td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[2].color}`,
                                            textAlign: "center",
                                        }}
                                    >
                                        <VscCircleFilled />
                                    </td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[3].color}`,
                                            textAlign: "center",
                                        }}
                                    >
                                        <VscCircleFilled />
                                    </td>
                                </tr>
                                <tr>
                                    <td id="Benefits-benefits">
                                        {fullBenefitsList[9]}
                                    </td>

                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[0].color}`,
                                            textAlign: "center",
                                        }}
                                    ></td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[1].color}`,
                                            textAlign: "center",
                                        }}
                                    ></td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[2].color}`,
                                            textAlign: "center",
                                        }}
                                    >
                                        <VscCircleFilled />
                                    </td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[3].color}`,
                                            textAlign: "center",
                                        }}
                                    >
                                        <VscCircleFilled />
                                    </td>
                                </tr>
                                <tr>
                                    <td id="Benefits-benefits">
                                        {fullBenefitsList[10]}
                                    </td>

                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[0].color}`,
                                            textAlign: "center",
                                        }}
                                    ></td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[1].color}`,
                                            textAlign: "center",
                                        }}
                                    ></td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[2].color}`,
                                            textAlign: "center",
                                        }}
                                    >
                                        <VscCircleFilled />
                                    </td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[3].color}`,
                                            textAlign: "center",
                                        }}
                                    >
                                        <VscCircleFilled />
                                    </td>
                                </tr>
                                <tr>
                                    <td id="Benefits-benefits">
                                        {fullBenefitsList[11]}
                                    </td>

                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[0].color}`,
                                            textAlign: "center",
                                        }}
                                    ></td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[1].color}`,
                                            textAlign: "center",
                                        }}
                                    ></td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[2].color}`,
                                            textAlign: "center",
                                        }}
                                    >
                                        <VscCircleFilled />
                                    </td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[3].color}`,
                                            textAlign: "center",
                                        }}
                                    >
                                        <VscCircleFilled />
                                    </td>
                                </tr>

                                <tr>
                                    <td id="Benefits-benefits">
                                        {fullBenefitsList[13]}
                                    </td>

                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[0].color}`,
                                            textAlign: "center",
                                        }}
                                    ></td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[1].color}`,
                                            textAlign: "center",
                                        }}
                                    ></td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[2].color}`,
                                            textAlign: "center",
                                        }}
                                    ></td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[3].color}`,
                                            textAlign: "center",
                                        }}
                                    >
                                        <VscCircleFilled />
                                    </td>
                                </tr>
                                <tr>
                                    <td id="Benefits-benefits">
                                        {fullBenefitsList[14]}
                                    </td>

                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[0].color}`,
                                            textAlign: "center",
                                        }}
                                    ></td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[1].color}`,
                                            textAlign: "center",
                                        }}
                                    ></td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[2].color}`,
                                            textAlign: "center",
                                        }}
                                    ></td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[3].color}`,
                                            textAlign: "center",
                                        }}
                                    >
                                        <VscCircleFilled />
                                    </td>
                                </tr>
                                <tr>
                                    <td id="Benefits-benefits">
                                        {fullBenefitsList[15]}
                                    </td>

                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[0].color}`,
                                            textAlign: "center",
                                        }}
                                    ></td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[1].color}`,
                                            textAlign: "center",
                                        }}
                                    ></td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[2].color}`,
                                            textAlign: "center",
                                        }}
                                    ></td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[3].color}`,
                                            textAlign: "center",
                                        }}
                                    >
                                        <VscCircleFilled />
                                    </td>
                                </tr>
                                <tr>
                                    <td id="Benefits-benefits">
                                        {fullBenefitsList[16]}
                                    </td>

                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[0].color}`,
                                            textAlign: "center",
                                        }}
                                    ></td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[1].color}`,
                                            textAlign: "center",
                                        }}
                                    ></td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[2].color}`,
                                            textAlign: "center",
                                        }}
                                    ></td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[3].color}`,
                                            textAlign: "center",
                                        }}
                                    >
                                        <VscCircleFilled />
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                        <br></br>
                        <br></br>
                    </div>
                )}
                {programLabel === MK.PROD && (
                    <div className="Benefits-tableContainer-Parent">
                        <table className="Benefits-tableContainer">
                            <thead></thead>
                            <tbody>
                                <tr className="Benefits-headings">
                                    <td
                                        id="Benefits-Tier"
                                        style={{
                                            fontWeight: "600",
                                            textAlign: "center",
                                            width: "40%",
                                        }}
                                    >
                                        Benefits at a glance
                                    </td>

                                    <td
                                        id="Benefits-Tier"
                                        style={{
                                            background: `${tiers[0].color}`,
                                            fontWeight: "600",
                                            textAlign: "center",
                                        }}
                                    >
                                        White
                                    </td>
                                    <td
                                        id="Benefits-Tier"
                                        style={{
                                            background: `${tiers[1].color}`,
                                            fontWeight: "600",
                                            textAlign: "center",
                                        }}
                                    >
                                        Silver
                                    </td>
                                    <td
                                        id="Benefits-Tier"
                                        style={{
                                            background: `${tiers[2].color}`,
                                            fontWeight: "600",
                                            textAlign: "center",
                                        }}
                                    >
                                        Gold
                                    </td>
                                </tr>
                                <tr>
                                    <td id="Benefits-benefits">
                                        Discount for direct bookings
                                    </td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[0].color}`,
                                            textAlign: "center",
                                        }}
                                    >
                                        10%
                                    </td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[1].color}`,
                                            textAlign: "center",
                                        }}
                                    >
                                        12%
                                    </td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[2].color}`,
                                            textAlign: "center",
                                        }}
                                    >
                                        15%
                                    </td>
                                </tr>
                                <tr>
                                    <td id="Benefits-benefits">
                                        Welcome In-room Amenity & Welcome Gift{" "}
                                    </td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[0].color}`,
                                            textAlign: "center",
                                        }}
                                    >
                                        <BsSuitDiamondFill />
                                    </td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[1].color}`,
                                            textAlign: "center",
                                        }}
                                    >
                                        <BsSuitDiamondFill />
                                    </td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[2].color}`,
                                            textAlign: "center",
                                        }}
                                    >
                                        <BsSuitDiamondFill />
                                    </td>
                                </tr>
                                <tr>
                                    <td id="Benefits-benefits">
                                        Farewell Gift{" "}
                                    </td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[0].color}`,
                                            textAlign: "center",
                                        }}
                                    >
                                        <BsSuitDiamondFill />
                                    </td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[1].color}`,
                                            textAlign: "center",
                                        }}
                                    >
                                        <BsSuitDiamondFill />
                                    </td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[2].color}`,
                                            textAlign: "center",
                                        }}
                                    >
                                        <BsSuitDiamondFill />
                                    </td>
                                </tr>
                                <tr>
                                    <td id="Benefits-benefits">
                                        Discount for Spa treatments{" "}
                                    </td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[0].color}`,
                                            textAlign: "center",
                                        }}
                                    >
                                        5%
                                    </td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[1].color}`,
                                            textAlign: "center",
                                        }}
                                    >
                                        10%
                                    </td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[2].color}`,
                                            textAlign: "center",
                                        }}
                                    >
                                        15%{" "}
                                    </td>
                                </tr>

                                <tr>
                                    <td id="Benefits-benefits">
                                        Discount in Restaurants & Bars for Pnoe{" "}
                                    </td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[0].color}`,
                                            textAlign: "center",
                                        }}
                                    >
                                        5%
                                    </td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[1].color}`,
                                            textAlign: "center",
                                        }}
                                    >
                                        10%{" "}
                                    </td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[2].color}`,
                                            textAlign: "center",
                                        }}
                                    >
                                        15%{" "}
                                    </td>
                                </tr>

                                <tr>
                                    <td id="Benefits-benefits">
                                        Discount for a second visit in A la
                                        carte for Unique Blue
                                    </td>

                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[0].color}`,
                                            textAlign: "center",
                                        }}
                                    >
                                        20%
                                    </td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[1].color}`,
                                            textAlign: "center",
                                        }}
                                    >
                                        20%
                                    </td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[2].color}`,
                                            textAlign: "center",
                                        }}
                                    >
                                        20%
                                    </td>
                                </tr>
                                <tr>
                                    <td id="Benefits-benefits">
                                        Turn down Service for Pnoe
                                    </td>

                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[0].color}`,
                                            textAlign: "center",
                                        }}
                                    >
                                        <BsSuitDiamondFill />
                                    </td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[1].color}`,
                                            textAlign: "center",
                                        }}
                                    >
                                        <BsSuitDiamondFill />
                                    </td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[2].color}`,
                                            textAlign: "center",
                                        }}
                                    >
                                        <BsSuitDiamondFill />
                                    </td>
                                </tr>

                                <tr>
                                    <td id="Benefits-benefits">
                                        Early Check In (upon availability)
                                    </td>

                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[0].color}`,
                                            textAlign: "center",
                                        }}
                                    >
                                        <BsSuitDiamondFill />
                                    </td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[1].color}`,
                                            textAlign: "center",
                                        }}
                                    >
                                        <BsSuitDiamondFill />
                                    </td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[2].color}`,
                                            textAlign: "center",
                                        }}
                                    >
                                        <BsSuitDiamondFill />
                                    </td>
                                </tr>

                                <tr>
                                    <td id="Benefits-benefits">
                                        Late Check out (upon availability)
                                    </td>

                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[0].color}`,
                                            textAlign: "center",
                                        }}
                                    ></td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[1].color}`,
                                            textAlign: "center",
                                        }}
                                    >
                                        <BsSuitDiamondFill />
                                    </td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[2].color}`,
                                            textAlign: "center",
                                        }}
                                    >
                                        <BsSuitDiamondFill />
                                    </td>
                                </tr>
                                <tr>
                                    <td id="Benefits-benefits">
                                        Room Upgrade (subject to availability)
                                    </td>

                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[0].color}`,
                                            textAlign: "center",
                                        }}
                                    ></td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[1].color}`,
                                            textAlign: "center",
                                        }}
                                    >
                                        <BsSuitDiamondFill />{" "}
                                    </td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[2].color}`,
                                            textAlign: "center",
                                        }}
                                    >
                                        <BsSuitDiamondFill />{" "}
                                    </td>
                                </tr>
                                <tr>
                                    <td id="Benefits-benefits">
                                        Discount at Klosti Boutique for Pnoe
                                    </td>

                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[0].color}`,
                                            textAlign: "center",
                                        }}
                                    ></td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[1].color}`,
                                            textAlign: "center",
                                        }}
                                    >
                                        5%
                                    </td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[2].color}`,
                                            textAlign: "center",
                                        }}
                                    >
                                        10%{" "}
                                    </td>
                                </tr>
                                <tr>
                                    <td id="Benefits-benefits">
                                        One complimentary use of tennis court
                                        for Unique Blue
                                    </td>

                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[0].color}`,
                                            textAlign: "center",
                                        }}
                                    ></td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[1].color}`,
                                            textAlign: "center",
                                        }}
                                    >
                                        <BsSuitDiamondFill />
                                    </td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[2].color}`,
                                            textAlign: "center",
                                        }}
                                    >
                                        <BsSuitDiamondFill />
                                    </td>
                                </tr>
                                <tr>
                                    <td id="Benefits-benefits">
                                        Complimentary Access to the Spa area
                                        (once per stay) for Pnoe
                                    </td>

                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[0].color}`,
                                            textAlign: "center",
                                        }}
                                    ></td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[1].color}`,
                                            textAlign: "center",
                                        }}
                                    ></td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[2].color}`,
                                            textAlign: "center",
                                        }}
                                    >
                                        <BsSuitDiamondFill />
                                    </td>
                                </tr>
                                <tr>
                                    <td id="Benefits-benefits">
                                        Turn down Service for Unique Blue
                                    </td>

                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[0].color}`,
                                            textAlign: "center",
                                        }}
                                    ></td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[1].color}`,
                                            textAlign: "center",
                                        }}
                                    ></td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[2].color}`,
                                            textAlign: "center",
                                        }}
                                    >
                                        <BsSuitDiamondFill />
                                    </td>
                                </tr>

                                <tr>
                                    <td id="Benefits-benefits">
                                        Complimentary Mini-Bar (upon arrival)
                                    </td>

                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[0].color}`,
                                            textAlign: "center",
                                        }}
                                    ></td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[1].color}`,
                                            textAlign: "center",
                                        }}
                                    ></td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[2].color}`,
                                            textAlign: "center",
                                        }}
                                    >
                                        <BsSuitDiamondFill />
                                    </td>
                                </tr>

                                <tr>
                                    <td id="Benefits-benefits">
                                        Complimentary A la Carte Dinner for Pnoe
                                    </td>

                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[0].color}`,
                                            textAlign: "center",
                                        }}
                                    ></td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[1].color}`,
                                            textAlign: "center",
                                        }}
                                    ></td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[2].color}`,
                                            textAlign: "center",
                                        }}
                                    >
                                        <BsSuitDiamondFill />
                                    </td>
                                </tr>

                                <tr>
                                    <td id="Benefits-benefits">
                                        Complimentary Transfer (upon arrival,
                                        from and to Heraklion airport/port - for
                                        direct bookings)
                                    </td>

                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[0].color}`,
                                            textAlign: "center",
                                        }}
                                    ></td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[1].color}`,
                                            textAlign: "center",
                                        }}
                                    ></td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[2].color}`,
                                            textAlign: "center",
                                        }}
                                    >
                                        <BsSuitDiamondFill />
                                    </td>
                                </tr>
                            </tbody>
                        </table>

                        <br />
                        <br />
                    </div>
                )}

                {programLabel === "1EA1F505-D95F-4740-9AA9-E33039CBAD95" && (
                    <div className="Benefits-tableContainer-Parent">
                        <table className="Benefits-tableContainer">
                            <thead></thead>
                            <tbody>
                                <tr className="Benefits-headings">
                                    <td
                                        id="Benefits-Tier"
                                        style={{
                                            fontWeight: "600",
                                            textAlign: "center",
                                            width: "40%",
                                        }}
                                    >
                                        Benefits
                                    </td>

                                    <td
                                        id="Benefits-Tier"
                                        style={{
                                            background: `${tiers[0].color}`,
                                            fontWeight: "600",
                                            textAlign: "center",
                                            color: "#fff",
                                        }}
                                    >
                                        Member
                                    </td>
                                    <td
                                        id="Benefits-Tier"
                                        style={{
                                            background: `${tiers[1].color}`,
                                            fontWeight: "600",
                                            textAlign: "center",
                                            color: "#fff",
                                        }}
                                    >
                                        Silver (800)
                                    </td>
                                    <td
                                        id="Benefits-Tier"
                                        style={{
                                            background: `${tiers[2].color}`,
                                            fontWeight: "600",
                                            textAlign: "center",
                                        }}
                                    >
                                        Gold (1600) 4 xρόνια
                                    </td>
                                    <td
                                        id="Benefits-Tier"
                                        style={{
                                            background: `${tiers[3].color}`,
                                            fontWeight: "600",
                                            textAlign: "center",
                                            color: "#fff",
                                        }}
                                    >
                                        Platinum (3000) 5 χρόνια
                                    </td>
                                </tr>
                                <tr>
                                    <td id="Benefits-benefits">
                                        Accomodation Discount
                                    </td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[0].color}`,
                                            textAlign: "center",
                                            color: "#fff",
                                        }}
                                    >
                                        5%
                                    </td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[1].color}`,
                                            textAlign: "center",
                                            color: "#fff",
                                        }}
                                    >
                                        7%
                                    </td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[2].color}`,
                                            textAlign: "center",
                                        }}
                                    >
                                        10%
                                    </td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[3].color}`,
                                            textAlign: "center",
                                            color: "#fff",
                                        }}
                                    >
                                        15%
                                    </td>
                                </tr>
                                <tr>
                                    <td id="Benefits-benefits">
                                        Early Check In or luggage storage (upon
                                        availability)
                                    </td>

                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[0].color}`,
                                            textAlign: "center",
                                            color: "#fff",
                                        }}
                                    ></td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[1].color}`,
                                            textAlign: "center",
                                            color: "#fff",
                                        }}
                                    >
                                        <VscCheck />
                                    </td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[2].color}`,
                                            textAlign: "center",
                                        }}
                                    >
                                        <VscCheck />{" "}
                                    </td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[3].color}`,
                                            textAlign: "center",
                                            color: "#fff",
                                        }}
                                    >
                                        <VscCheck />
                                    </td>
                                </tr>
                                <tr>
                                    <td id="Benefits-benefits">
                                        Late check out or Free luggage storage
                                    </td>

                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[0].color}`,
                                            textAlign: "center",
                                            color: "#fff",
                                        }}
                                    ></td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[1].color}`,
                                            textAlign: "center",
                                            color: "#fff",
                                        }}
                                    ></td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[2].color}`,
                                            textAlign: "center",
                                        }}
                                    >
                                        <VscCheck />{" "}
                                    </td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[3].color}`,
                                            textAlign: "center",
                                            color: "#fff",
                                        }}
                                    >
                                        <VscCheck />
                                    </td>
                                </tr>
                                <tr>
                                    <td id="Benefits-benefits">
                                        Transfer from/to airport-port{" "}
                                    </td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[0].color}`,
                                            textAlign: "center",
                                            color: "#fff",
                                        }}
                                    >
                                        {/* <BsSuitDiamondFill /> */}
                                        {/*<VscCircleFilled />*/}
                                    </td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[1].color}`,
                                            textAlign: "center",
                                            color: "#fff",
                                        }}
                                    >
                                        7%
                                    </td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[2].color}`,
                                            textAlign: "center",
                                        }}
                                    >
                                        10%
                                    </td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[3].color}`,
                                            textAlign: "center",
                                            color: "#fff",
                                        }}
                                    >
                                        free
                                    </td>
                                </tr>
                                <tr>
                                    <td id="Benefits-benefits">
                                        Upgrade apartment (upon availability ){" "}
                                    </td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[0].color}`,
                                            textAlign: "center",
                                            color: "#fff",
                                        }}
                                    ></td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[1].color}`,
                                            textAlign: "center",
                                            color: "#fff",
                                        }}
                                    ></td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[2].color}`,
                                            textAlign: "center",
                                        }}
                                    >
                                        Β class apartments
                                    </td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[3].color}`,
                                            textAlign: "center",
                                            color: "#fff",
                                        }}
                                    >
                                        A class apartments
                                    </td>
                                </tr>
                                <tr>
                                    <td id="Benefits-benefits">
                                        Discount On activities{" "}
                                    </td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[0].color}`,
                                            textAlign: "center",
                                            color: "#fff",
                                        }}
                                    >
                                        {" "}
                                    </td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[1].color}`,
                                            textAlign: "center",
                                            color: "#fff",
                                        }}
                                    ></td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[2].color}`,
                                            textAlign: "center",
                                        }}
                                    >
                                        10%{" "}
                                    </td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[3].color}`,
                                            textAlign: "center",
                                            color: "#fff",
                                        }}
                                    >
                                        15%
                                    </td>
                                </tr>
                                <tr>
                                    <td id="Benefits-benefits">
                                        Welcome basket with greek products
                                    </td>

                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[0].color}`,
                                            textAlign: "center",
                                            color: "#fff",
                                        }}
                                    ></td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[1].color}`,
                                            textAlign: "center",
                                            color: "#fff",
                                        }}
                                    ></td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[2].color}`,
                                            textAlign: "center",
                                        }}
                                    ></td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[3].color}`,
                                            textAlign: "center",
                                            color: "#fff",
                                        }}
                                    >
                                        <VscCheck />
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                        <br></br>
                        <div className="notes">
                            <span className="text-md italic note">
                                *Direct bookings only{" "}
                            </span>
                            <br></br>

                            <span className="text-md italic note">
                                ** > 5 Nights
                            </span>
                            <br></br>
                            <span className="text-md italic note">
                                *** ≥ 7 nights for one way
                            </span>
                            <br></br>
                        </div>
                        <br />
                        <br />
                    </div>
                )}

                {programLabel === "02883039-B641-4E7E-B17A-E763F7F2F6AE" && (
                    <div className="Benefits-tableContainer-Parent">
                        <table className="Benefits-tableContainer">
                            <thead></thead>
                            <tbody>
                                <tr className="Benefits-headings">
                                    <td
                                        id="Benefits-Tier"
                                        style={{
                                            fontWeight: "600",
                                            textAlign: "center",
                                            width: "40%",
                                        }}
                                    >
                                        Benefits at a glance
                                    </td>

                                    <td
                                        id="Benefits-Tier"
                                        style={{
                                            background: `${tiers[0].color}`,
                                            fontWeight: "600",
                                            textAlign: "center",
                                            color: "#fff",
                                        }}
                                    >
                                        Bronze
                                    </td>
                                    <td
                                        id="Benefits-Tier"
                                        style={{
                                            background: `${tiers[1].color}`,
                                            fontWeight: "600",
                                            textAlign: "center",
                                            color: "#fff",
                                        }}
                                    >
                                        Silver
                                    </td>
                                    <td
                                        id="Benefits-Tier"
                                        style={{
                                            background: `${tiers[2].color}`,
                                            fontWeight: "600",
                                            textAlign: "center",
                                        }}
                                    >
                                        Gold
                                    </td>
                                    <td
                                        id="Benefits-Tier"
                                        style={{
                                            background: `${tiers[3].color}`,
                                            fontWeight: "600",
                                            textAlign: "center",
                                            color: "#fff",
                                        }}
                                    >
                                        Platinum
                                    </td>
                                </tr>
                                <tr>
                                    <td id="Benefits-benefits">
                                        Discount for Hotel Direct Bookings*//**
                                    </td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[0].color}`,
                                            textAlign: "center",
                                            color: "#fff",
                                        }}
                                    >
                                        5%
                                    </td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[1].color}`,
                                            textAlign: "center",
                                            color: "#fff",
                                        }}
                                    >
                                        6%
                                    </td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[2].color}`,
                                            textAlign: "center",
                                        }}
                                    >
                                        8%
                                    </td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[3].color}`,
                                            textAlign: "center",
                                            color: "#fff",
                                        }}
                                    >
                                        10%
                                    </td>
                                </tr>
                                <tr>
                                    <td id="Benefits-benefits">
                                        Discount for Spa Treatments
                                    </td>

                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[0].color}`,
                                            textAlign: "center",
                                            color: "#fff",
                                        }}
                                    >
                                        20'
                                    </td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[1].color}`,
                                            textAlign: "center",
                                            color: "#fff",
                                        }}
                                    >
                                        15%
                                    </td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[2].color}`,
                                            textAlign: "center",
                                        }}
                                    >
                                        20%{" "}
                                    </td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[3].color}`,
                                            textAlign: "center",
                                            color: "#fff",
                                        }}
                                    >
                                        25%
                                    </td>
                                </tr>
                                <tr>
                                    <td id="Benefits-benefits">
                                        Special farewell gift according to tier
                                    </td>

                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[0].color}`,
                                            textAlign: "center",
                                            color: "#fff",
                                        }}
                                    >
                                        {" "}
                                        <VscClose />
                                    </td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[1].color}`,
                                            textAlign: "center",
                                            color: "#fff",
                                        }}
                                    >
                                        <VscClose />{" "}
                                    </td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[2].color}`,
                                            textAlign: "center",
                                        }}
                                    >
                                        <VscClose />{" "}
                                    </td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[3].color}`,
                                            textAlign: "center",
                                            color: "#fff",
                                        }}
                                    >
                                        <VscClose />
                                    </td>
                                </tr>
                                <tr>
                                    <td id="Benefits-benefits">
                                        Complimentary Welcome Drink{" "}
                                    </td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[0].color}`,
                                            textAlign: "center",
                                            color: "#fff",
                                        }}
                                    >
                                        {/* <BsSuitDiamondFill /> */}
                                        {/*<VscCircleFilled />*/}
                                        <VscClose />
                                    </td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[1].color}`,
                                            textAlign: "center",
                                            color: "#fff",
                                        }}
                                    >
                                        <VscClose />
                                    </td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[2].color}`,
                                            textAlign: "center",
                                        }}
                                    >
                                        <VscClose />
                                    </td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[3].color}`,
                                            textAlign: "center",
                                            color: "#fff",
                                        }}
                                    >
                                        <VscClose />
                                    </td>
                                </tr>
                                <tr>
                                    <td id="Benefits-benefits">
                                        Personalised Concierge Service{" "}
                                    </td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[0].color}`,
                                            textAlign: "center",
                                            color: "#fff",
                                        }}
                                    ></td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[1].color}`,
                                            textAlign: "center",
                                            color: "#fff",
                                        }}
                                    >
                                        <VscClose />
                                    </td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[2].color}`,
                                            textAlign: "center",
                                        }}
                                    >
                                        <VscClose />
                                    </td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[3].color}`,
                                            textAlign: "center",
                                            color: "#fff",
                                        }}
                                    >
                                        <VscClose />
                                    </td>
                                </tr>
                                <tr>
                                    <td id="Benefits-benefits">
                                        Early Check In (upon request and
                                        availability){" "}
                                    </td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[0].color}`,
                                            textAlign: "center",
                                            color: "#fff",
                                        }}
                                    >
                                        {" "}
                                    </td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[1].color}`,
                                            textAlign: "center",
                                            color: "#fff",
                                        }}
                                    >
                                        <VscClose />
                                    </td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[2].color}`,
                                            textAlign: "center",
                                        }}
                                    >
                                        <VscClose />{" "}
                                    </td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[3].color}`,
                                            textAlign: "center",
                                            color: "#fff",
                                        }}
                                    >
                                        <VscClose />
                                    </td>
                                </tr>
                                <tr>
                                    <td id="Benefits-benefits">
                                        Late Check Out (upon request and
                                        availability)
                                    </td>

                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[0].color}`,
                                            textAlign: "center",
                                            color: "#fff",
                                        }}
                                    ></td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[1].color}`,
                                            textAlign: "center",
                                            color: "#fff",
                                        }}
                                    >
                                        <VscClose />
                                    </td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[2].color}`,
                                            textAlign: "center",
                                        }}
                                    >
                                        <VscClose />
                                    </td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[3].color}`,
                                            textAlign: "center",
                                            color: "#fff",
                                        }}
                                    >
                                        <VscClose />
                                    </td>
                                </tr>
                                <tr>
                                    <td id="Benefits-benefits">
                                        Priority/ Private Check In (Guest
                                        Relation)
                                    </td>

                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[0].color}`,
                                            textAlign: "center",
                                            color: "#fff",
                                        }}
                                    ></td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[1].color}`,
                                            textAlign: "center",
                                            color: "#fff",
                                        }}
                                    ></td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[2].color}`,
                                            textAlign: "center",
                                        }}
                                    >
                                        <VscClose />
                                    </td>

                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[3].color}`,
                                            textAlign: "center",
                                            color: "#fff",
                                        }}
                                    >
                                        <VscClose />
                                    </td>
                                </tr>

                                <tr>
                                    <td id="Benefits-benefits">
                                        Complimentary Bottle of wine upon
                                        arrival
                                    </td>

                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[0].color}`,
                                            textAlign: "center",
                                            color: "#fff",
                                        }}
                                    ></td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[1].color}`,
                                            textAlign: "center",
                                            color: "#fff",
                                        }}
                                    ></td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[2].color}`,
                                            textAlign: "center",
                                        }}
                                    >
                                        <VscClose />
                                    </td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[3].color}`,
                                            textAlign: "center",
                                            color: "#fff",
                                        }}
                                    >
                                        <VscClose />
                                    </td>
                                </tr>

                                <tr>
                                    <td id="Benefits-benefits">
                                        Priority Bookings on Themed Restaurants*
                                    </td>

                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[0].color}`,
                                            textAlign: "center",
                                            color: "#fff",
                                        }}
                                    ></td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[1].color}`,
                                            textAlign: "center",
                                            color: "#fff",
                                        }}
                                    ></td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[2].color}`,
                                            textAlign: "center",
                                        }}
                                    >
                                        <VscClose />
                                    </td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[3].color}`,
                                            textAlign: "center",
                                            color: "#fff",
                                        }}
                                    >
                                        <VscClose />
                                    </td>
                                </tr>
                                <tr>
                                    <td id="Benefits-benefits">
                                        Free Mini Bar - Daily Refill*
                                    </td>

                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[0].color}`,
                                            textAlign: "center",
                                            color: "#fff",
                                        }}
                                    ></td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[1].color}`,
                                            textAlign: "center",
                                            color: "#fff",
                                        }}
                                    ></td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[2].color}`,
                                            textAlign: "center",
                                        }}
                                    >
                                        <VscClose />{" "}
                                    </td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[3].color}`,
                                            textAlign: "center",
                                            color: "#fff",
                                        }}
                                    >
                                        <VscClose />
                                    </td>
                                </tr>
                                <tr>
                                    <td id="Benefits-benefits">
                                        Turn Down Service*
                                    </td>

                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[0].color}`,
                                            textAlign: "center",
                                            color: "#fff",
                                        }}
                                    ></td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[1].color}`,
                                            textAlign: "center",
                                            color: "#fff",
                                        }}
                                    ></td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[2].color}`,
                                            textAlign: "center",
                                        }}
                                    ></td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[3].color}`,
                                            textAlign: "center",
                                            color: "#fff",
                                        }}
                                    >
                                        <VscClose />
                                    </td>
                                </tr>
                                <tr>
                                    <td id="Benefits-benefits">
                                        Room Upgrade (upon check in and subject
                                        to availability)*
                                    </td>

                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[0].color}`,
                                            textAlign: "center",
                                            color: "#fff",
                                        }}
                                    ></td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[1].color}`,
                                            textAlign: "center",
                                            color: "#fff",
                                        }}
                                    ></td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[2].color}`,
                                            textAlign: "center",
                                        }}
                                    ></td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[3].color}`,
                                            textAlign: "center",
                                            color: "#fff",
                                        }}
                                    >
                                        <VscClose />
                                    </td>
                                </tr>
                                <tr>
                                    <td id="Benefits-benefits">
                                        Free Airport Transfer* // ***
                                    </td>

                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[0].color}`,
                                            textAlign: "center",
                                            color: "#fff",
                                        }}
                                    ></td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[1].color}`,
                                            textAlign: "center",
                                            color: "#fff",
                                        }}
                                    ></td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[2].color}`,
                                            textAlign: "center",
                                        }}
                                    ></td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[3].color}`,
                                            textAlign: "center",
                                            color: "#fff",
                                        }}
                                    >
                                        <VscClose />
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                        <br></br>
                        <div className="notes">
                            <span className="text-md italic note">
                                *Direct bookings only{" "}
                            </span>
                            <br></br>

                            <span className="text-md italic note">
                                ** > 5 Nights
                            </span>
                            <br></br>
                            <span className="text-md italic note">
                                *** ≥ 7 nights for one way
                            </span>
                            <br></br>
                        </div>
                        <br />
                        <br />
                    </div>
                )}

                {programLabel === "3CD7C43F-AEF1-4D37-8338-31467B8B3E1E" && (
                    <div className="Benefits-tableContainer-Parent">
                        <table className="Benefits-tableContainer">
                            <thead></thead>
                            <tbody>
                                <tr className="Benefits-headings">
                                    <td
                                        id="Benefits-Tier"
                                        style={{
                                            fontWeight: "600",
                                            textAlign: "center",
                                            width: "40%",
                                        }}
                                    >
                                        Benefits at a glance
                                    </td>

                                    <td
                                        id="Benefits-Tier"
                                        style={{
                                            background: `${tiers[0].color}`,
                                            fontWeight: "600",
                                            textAlign: "center",
                                            color: "#fff",
                                        }}
                                    >
                                        AZURE
                                    </td>
                                    <td
                                        id="Benefits-Tier"
                                        style={{
                                            background: `${tiers[1].color}`,
                                            fontWeight: "600",
                                            textAlign: "center",
                                            color: "#fff",
                                        }}
                                    >
                                        SAPPHIRE
                                    </td>
                                    <td
                                        id="Benefits-Tier"
                                        style={{
                                            background: `${tiers[2].color}`,
                                            fontWeight: "600",
                                            textAlign: "center",
                                        }}
                                    >
                                        PEARL
                                    </td>
                                    <td
                                        id="Benefits-Tier"
                                        style={{
                                            background: `${tiers[3].color}`,
                                            fontWeight: "600",
                                            textAlign: "center",
                                            color: "#fff",
                                        }}
                                    >
                                        DIAMOND
                                    </td>
                                </tr>
                                <tr>
                                    <td id="Benefits-benefits">
                                        Discount for direct bookings 1
                                    </td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[0].color}`,
                                            textAlign: "center",
                                            color: "#fff",
                                        }}
                                    >
                                        5%
                                    </td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[1].color}`,
                                            textAlign: "center",
                                            color: "#fff",
                                        }}
                                    >
                                        5%
                                    </td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[2].color}`,
                                            textAlign: "center",
                                        }}
                                    >
                                        10%
                                    </td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[3].color}`,
                                            textAlign: "center",
                                            color: "#fff",
                                        }}
                                    >
                                        15%
                                    </td>
                                </tr>
                                <tr>
                                    <td id="Benefits-benefits">
                                        Exclusive benefits for direct bookings 2{" "}
                                    </td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[0].color}`,
                                            textAlign: "center",
                                            color: "#fff",
                                        }}
                                    >
                                        {/* <BsSuitDiamondFill /> */}
                                        <VscCircleFilled />
                                    </td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[1].color}`,
                                            textAlign: "center",
                                            color: "#fff",
                                        }}
                                    >
                                        <VscCircleFilled />
                                    </td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[2].color}`,
                                            textAlign: "center",
                                        }}
                                    >
                                        <VscCircleFilled />
                                    </td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[3].color}`,
                                            textAlign: "center",
                                            color: "#fff",
                                        }}
                                    >
                                        <VscCircleFilled />
                                    </td>
                                </tr>
                                <tr>
                                    <td id="Benefits-benefits">
                                        Welcome offer in the room upon arrival{" "}
                                    </td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[0].color}`,
                                            textAlign: "center",
                                            color: "#fff",
                                        }}
                                    >
                                        <VscCircleFilled />
                                    </td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[1].color}`,
                                            textAlign: "center",
                                            color: "#fff",
                                        }}
                                    >
                                        <VscCircleFilled />
                                    </td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[2].color}`,
                                            textAlign: "center",
                                        }}
                                    >
                                        <VscCircleFilled />
                                    </td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[3].color}`,
                                            textAlign: "center",
                                            color: "#fff",
                                        }}
                                    >
                                        <VscCircleFilled />
                                    </td>
                                </tr>
                                <tr>
                                    <td id="Benefits-benefits">
                                        Earn points / Exclusive members-only
                                        offers{" "}
                                    </td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[0].color}`,
                                            textAlign: "center",
                                            color: "#fff",
                                        }}
                                    >
                                        {" "}
                                        <VscCircleFilled />
                                    </td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[1].color}`,
                                            textAlign: "center",
                                            color: "#fff",
                                        }}
                                    >
                                        <VscCircleFilled />
                                    </td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[2].color}`,
                                            textAlign: "center",
                                        }}
                                    >
                                        <VscCircleFilled />{" "}
                                    </td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[3].color}`,
                                            textAlign: "center",
                                            color: "#fff",
                                        }}
                                    >
                                        <VscCircleFilled />
                                    </td>
                                </tr>
                                <tr>
                                    <td id="Benefits-benefits">
                                        Discount in Ammos boutique
                                    </td>

                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[0].color}`,
                                            textAlign: "center",
                                            color: "#fff",
                                        }}
                                    >
                                        5%
                                    </td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[1].color}`,
                                            textAlign: "center",
                                            color: "#fff",
                                        }}
                                    >
                                        10%
                                    </td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[2].color}`,
                                            textAlign: "center",
                                        }}
                                    >
                                        15%
                                    </td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[3].color}`,
                                            textAlign: "center",
                                            color: "#fff",
                                        }}
                                    >
                                        20%
                                    </td>
                                </tr>
                                <tr>
                                    <td id="Benefits-benefits">
                                        Discount in Amarylis Spa ( on selected
                                        treatments )
                                    </td>

                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[0].color}`,
                                            textAlign: "center",
                                            color: "#fff",
                                        }}
                                    >
                                        5%
                                    </td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[1].color}`,
                                            textAlign: "center",
                                            color: "#fff",
                                        }}
                                    >
                                        10%
                                    </td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[2].color}`,
                                            textAlign: "center",
                                        }}
                                    >
                                        15%
                                    </td>

                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[3].color}`,
                                            textAlign: "center",
                                            color: "#fff",
                                        }}
                                    >
                                        20%
                                    </td>
                                </tr>

                                <tr>
                                    <td id="Benefits-benefits">
                                        Farewell gift for direct bookings
                                        /according to your tier
                                    </td>

                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[0].color}`,
                                            textAlign: "center",
                                            color: "#fff",
                                        }}
                                    >
                                        {" "}
                                        <VscCircleFilled />
                                    </td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[1].color}`,
                                            textAlign: "center",
                                            color: "#fff",
                                        }}
                                    >
                                        <VscCircleFilled />
                                    </td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[2].color}`,
                                            textAlign: "center",
                                        }}
                                    >
                                        <VscCircleFilled />
                                    </td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[3].color}`,
                                            textAlign: "center",
                                            color: "#fff",
                                        }}
                                    >
                                        <VscCircleFilled />
                                    </td>
                                </tr>

                                <tr>
                                    <td id="Benefits-benefits">
                                        Discount in our Food & Beverage Outlets
                                    </td>

                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[0].color}`,
                                            textAlign: "center",
                                            color: "#fff",
                                        }}
                                    ></td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[1].color}`,
                                            textAlign: "center",
                                            color: "#fff",
                                        }}
                                    >
                                        5%
                                    </td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[2].color}`,
                                            textAlign: "center",
                                        }}
                                    >
                                        10%
                                    </td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[3].color}`,
                                            textAlign: "center",
                                            color: "#fff",
                                        }}
                                    >
                                        15%
                                    </td>
                                </tr>
                                <tr>
                                    <td id="Benefits-benefits">
                                        eCheck-in / Customize your stay 3
                                    </td>

                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[0].color}`,
                                            textAlign: "center",
                                            color: "#fff",
                                        }}
                                    ></td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[1].color}`,
                                            textAlign: "center",
                                            color: "#fff",
                                        }}
                                    >
                                        <VscCircleFilled />{" "}
                                    </td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[2].color}`,
                                            textAlign: "center",
                                        }}
                                    >
                                        <VscCircleFilled />{" "}
                                    </td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[3].color}`,
                                            textAlign: "center",
                                            color: "#fff",
                                        }}
                                    >
                                        <VscCircleFilled />
                                    </td>
                                </tr>
                                <tr>
                                    <td id="Benefits-benefits">
                                        Free reward nights
                                    </td>

                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[0].color}`,
                                            textAlign: "center",
                                            color: "#fff",
                                        }}
                                    ></td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[1].color}`,
                                            textAlign: "center",
                                            color: "#fff",
                                        }}
                                    >
                                        <VscCircleFilled />{" "}
                                    </td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[2].color}`,
                                            textAlign: "center",
                                        }}
                                    >
                                        <VscCircleFilled />{" "}
                                    </td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[3].color}`,
                                            textAlign: "center",
                                            color: "#fff",
                                        }}
                                    >
                                        <VscCircleFilled />
                                    </td>
                                </tr>
                                <tr>
                                    <td id="Benefits-benefits">
                                        Best room available (in booked category)
                                    </td>

                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[0].color}`,
                                            textAlign: "center",
                                            color: "#fff",
                                        }}
                                    ></td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[1].color}`,
                                            textAlign: "center",
                                            color: "#fff",
                                        }}
                                    >
                                        <VscCircleFilled />{" "}
                                    </td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[2].color}`,
                                            textAlign: "center",
                                        }}
                                    >
                                        <VscCircleFilled />{" "}
                                    </td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[3].color}`,
                                            textAlign: "center",
                                            color: "#fff",
                                        }}
                                    >
                                        <VscCircleFilled />
                                    </td>
                                </tr>
                                <tr>
                                    <td id="Benefits-benefits">
                                        Private & Priority express check-in
                                    </td>

                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[0].color}`,
                                            textAlign: "center",
                                            color: "#fff",
                                        }}
                                    ></td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[1].color}`,
                                            textAlign: "center",
                                            color: "#fff",
                                        }}
                                    >
                                        <VscCircleFilled />{" "}
                                    </td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[2].color}`,
                                            textAlign: "center",
                                        }}
                                    >
                                        <VscCircleFilled />{" "}
                                    </td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[3].color}`,
                                            textAlign: "center",
                                            color: "#fff",
                                        }}
                                    >
                                        <VscCircleFilled />
                                    </td>
                                </tr>
                                <tr>
                                    <td id="Benefits-benefits">
                                        Complimentary early check-in 4
                                    </td>

                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[0].color}`,
                                            textAlign: "center",
                                            color: "#fff",
                                        }}
                                    ></td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[1].color}`,
                                            textAlign: "center",
                                            color: "#fff",
                                        }}
                                    >
                                        <VscCircleFilled />{" "}
                                    </td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[2].color}`,
                                            textAlign: "center",
                                        }}
                                    >
                                        <VscCircleFilled />{" "}
                                    </td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[3].color}`,
                                            textAlign: "center",
                                            color: "#fff",
                                        }}
                                    >
                                        <VscCircleFilled />
                                    </td>
                                </tr>

                                <tr>
                                    <td id="Benefits-benefits">
                                        Reserved sunbeds at the beach
                                    </td>

                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[0].color}`,
                                            textAlign: "center",
                                            color: "#fff",
                                        }}
                                    ></td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[1].color}`,
                                            textAlign: "center",
                                            color: "#fff",
                                        }}
                                    ></td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[2].color}`,
                                            textAlign: "center",
                                        }}
                                    >
                                        <VscCircleFilled />{" "}
                                    </td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[3].color}`,
                                            textAlign: "center",
                                            color: "#fff",
                                        }}
                                    >
                                        <VscCircleFilled />
                                    </td>
                                </tr>
                                <tr>
                                    <td id="Benefits-benefits">
                                        A special discount for car rental/bike
                                        tours / hiking tours
                                    </td>

                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[0].color}`,
                                            textAlign: "center",
                                            color: "#fff",
                                        }}
                                    ></td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[1].color}`,
                                            textAlign: "center",
                                            color: "#fff",
                                        }}
                                    ></td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[2].color}`,
                                            textAlign: "center",
                                        }}
                                    >
                                        <VscCircleFilled />
                                    </td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[3].color}`,
                                            textAlign: "center",
                                            color: "#fff",
                                        }}
                                    >
                                        <VscCircleFilled />
                                    </td>
                                </tr>

                                <tr>
                                    <td id="Benefits-benefits">
                                        No blackout dates for free reward nights
                                    </td>

                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[0].color}`,
                                            textAlign: "center",
                                            color: "#fff",
                                        }}
                                    ></td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[1].color}`,
                                            textAlign: "center",
                                            color: "#fff",
                                        }}
                                    ></td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[2].color}`,
                                            textAlign: "center",
                                        }}
                                    ></td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[3].color}`,
                                            textAlign: "center",
                                            color: "#fff",
                                        }}
                                    >
                                        <VscCircleFilled />
                                    </td>
                                </tr>

                                <tr>
                                    <td id="Benefits-benefits">
                                        Complimentary late check-out 4
                                    </td>

                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[0].color}`,
                                            textAlign: "center",
                                            color: "#fff",
                                        }}
                                    ></td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[1].color}`,
                                            textAlign: "center",
                                            color: "#fff",
                                        }}
                                    ></td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[2].color}`,
                                            textAlign: "center",
                                        }}
                                    ></td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[3].color}`,
                                            textAlign: "center",
                                            color: "#fff",
                                        }}
                                    >
                                        <VscCircleFilled />
                                    </td>
                                </tr>

                                <tr>
                                    <td id="Benefits-benefits">
                                        Airport transfer (round trip)
                                    </td>

                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[0].color}`,
                                            textAlign: "center",
                                            color: "#fff",
                                        }}
                                    ></td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[1].color}`,
                                            textAlign: "center",
                                            color: "#fff",
                                        }}
                                    ></td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[2].color}`,
                                            textAlign: "center",
                                        }}
                                    ></td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[3].color}`,
                                            textAlign: "center",
                                            color: "#fff",
                                        }}
                                    >
                                        <VscCircleFilled />
                                    </td>
                                </tr>
                                <tr>
                                    <td id="Benefits-benefits">Welcome gift</td>

                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[0].color}`,
                                            textAlign: "center",
                                            color: "#fff",
                                        }}
                                    ></td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[1].color}`,
                                            textAlign: "center",
                                            color: "#fff",
                                        }}
                                    ></td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[2].color}`,
                                            textAlign: "center",
                                        }}
                                    ></td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[3].color}`,
                                            color: "#fff",
                                            textAlign: "center",
                                        }}
                                    >
                                        <VscCircleFilled />
                                    </td>
                                </tr>
                                <tr>
                                    <td id="Benefits-benefits">
                                        A la carte dinner complimentary
                                        accompanied with the Hotel Manager{" "}
                                    </td>

                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[0].color}`,
                                            textAlign: "center",
                                            color: "#fff",
                                        }}
                                    ></td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[1].color}`,
                                            textAlign: "center",
                                            color: "#fff",
                                        }}
                                    ></td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[2].color}`,
                                            textAlign: "center",
                                        }}
                                    ></td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[3].color}`,
                                            textAlign: "center",
                                            color: "#fff",
                                        }}
                                    >
                                        <VscCircleFilled />
                                    </td>
                                </tr>
                                <tr>
                                    <td id="Benefits-benefits">
                                        Coplimentary Gazepo with special service{" "}
                                    </td>

                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[0].color}`,
                                            textAlign: "center",
                                            color: "#fff",
                                        }}
                                    ></td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[1].color}`,
                                            textAlign: "center",
                                            color: "#fff",
                                        }}
                                    ></td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[2].color}`,
                                            textAlign: "center",
                                        }}
                                    ></td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[3].color}`,
                                            textAlign: "center",
                                            color: "#fff",
                                        }}
                                    >
                                        <VscCircleFilled />
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                        <br></br>
                        <div className="notes">
                            <span className="text-md italic note">
                                1.Direct bookings are considered those made
                                directly with the hotel via its website, or by
                                email, or by phone.{" "}
                            </span>
                            <br></br>

                            <span className="text-md italic note">
                                2. Exclusive benefits for direct bookings apply
                                with the following conditions: Breakfast in the
                                room: Applies for stays of 3 or more nights in
                                any room type except bookings of the Special
                                Value Half Board Package. Executive Suites
                                receive a floating breakfast once per stay. All
                                other room types receive Continental breakfast
                                once per stay. Welcome set menu -dinner: Applies
                                for stays of 3 or more nights in Junior Suites &
                                Executive Suites. Once per stay. Drinks
                                excluded. Elite Experience in Amaryllis Spa:
                                Applies to all members staying in Executive
                                Suites and includes a Spa experience for two
                            </span>
                            <br></br>

                            <span className="text-md italic note">
                                3. Prior to arrival via portal.
                            </span>
                            <br></br>

                            <span className="text-md italic note">
                                4. Upon availability.
                            </span>
                            <br></br>

                            <span className="text-md italic note">
                                All above discounts are not cumulative with any
                                other discount valid during the period of stay .
                            </span>
                            <br></br>
                            <span className="text-md italic note">
                                All benefits are subject to availability. Please
                                see Terms & Conditions.
                            </span>
                            <br></br>
                        </div>
                        <br />
                        <br />
                    </div>
                )}

                {programLabel === "E5129AB1-5DBB-4443-AB14-8D3375D4F0DC" && (
                    <div className="Benefits-tableContainer-Parent">
                        <table className="Benefits-tableContainer">
                            <thead></thead>
                            <tbody>
                                <tr className="Benefits-headings">
                                    <td
                                        id="Benefits-Tier"
                                        style={{
                                            fontWeight: "600",
                                            textAlign: "center",
                                            width: "40%",
                                        }}
                                    ></td>

                                    <td
                                        id="Benefits-Tier"
                                        style={{
                                            background: `${tiers[0].color}`,
                                            fontWeight: "600",
                                            textAlign: "center",
                                        }}
                                    >
                                        EXPLORER
                                    </td>
                                    <td
                                        id="Benefits-Tier"
                                        style={{
                                            background: `${tiers[1].color}`,
                                            fontWeight: "600",
                                            textAlign: "center",
                                            color: "#fff",
                                        }}
                                    >
                                        WANDERER
                                    </td>
                                    <td
                                        id="Benefits-Tier"
                                        style={{
                                            background: `${tiers[2].color}`,
                                            fontWeight: "600",
                                            textAlign: "center",
                                            color: "#fff",
                                        }}
                                    >
                                        VANGUARD
                                    </td>
                                    <td
                                        id="Benefits-Tier"
                                        style={{
                                            background: `${tiers[3].color}`,
                                            fontWeight: "600",
                                            textAlign: "center",
                                            color: "#fff",
                                        }}
                                    >
                                        JET SETTER
                                    </td>
                                </tr>
                                <tr>
                                    <td id="Benefits-benefits">MEMBER RATES</td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[0].color}`,
                                            textAlign: "center",
                                        }}
                                    >
                                        {" "}
                                        10%
                                    </td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[1].color}`,
                                            textAlign: "center",
                                            color: "#fff",
                                        }}
                                    >
                                        11%
                                    </td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[2].color}`,
                                            textAlign: "center",
                                            color: "#fff",
                                        }}
                                    >
                                        13%
                                    </td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[3].color}`,
                                            textAlign: "center",
                                            color: "#fff",
                                        }}
                                    >
                                        15%
                                    </td>
                                </tr>
                                <tr>
                                    <td id="Benefits-benefits">
                                        EXCLUSIVE OFFERS
                                    </td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[0].color}`,
                                            textAlign: "center",
                                        }}
                                    >
                                        {/* <BsSuitDiamondFill /> */}
                                        <VscCircleFilled />
                                    </td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[1].color}`,
                                            textAlign: "center",
                                            color: "#fff",
                                        }}
                                    >
                                        <VscCircleFilled />
                                    </td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[2].color}`,
                                            textAlign: "center",
                                            color: "#fff",
                                        }}
                                    >
                                        <VscCircleFilled />
                                    </td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[3].color}`,
                                            textAlign: "center",
                                            color: "#fff",
                                        }}
                                    >
                                        <VscCircleFilled />
                                    </td>
                                </tr>
                                <tr>
                                    <td id="Benefits-benefits">
                                        PRIORITY COMMUNICATION{" "}
                                    </td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[0].color}`,
                                            textAlign: "center",
                                        }}
                                    >
                                        <VscCircleFilled />
                                    </td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[1].color}`,
                                            textAlign: "center",
                                            color: "#fff",
                                        }}
                                    >
                                        <VscCircleFilled />
                                    </td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[2].color}`,
                                            textAlign: "center",
                                            color: "#fff",
                                        }}
                                    >
                                        <VscCircleFilled />
                                    </td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[3].color}`,
                                            textAlign: "center",
                                            color: "#fff",
                                        }}
                                    >
                                        <VscCircleFilled />
                                    </td>
                                </tr>
                                <tr>
                                    <td id="Benefits-benefits">
                                        WELCOME AMENITY{" "}
                                    </td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[0].color}`,
                                            textAlign: "center",
                                        }}
                                    >
                                        <VscCircleFilled />
                                    </td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[1].color}`,
                                            textAlign: "center",
                                            color: "#fff",
                                        }}
                                    >
                                        <VscCircleFilled />
                                    </td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[2].color}`,
                                            textAlign: "center",
                                            color: "#fff",
                                        }}
                                    >
                                        <VscCircleFilled />
                                    </td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[3].color}`,
                                            textAlign: "center",
                                            color: "#fff",
                                        }}
                                    >
                                        <VscCircleFilled />
                                    </td>
                                </tr>
                                <tr>
                                    <td id="Benefits-benefits">
                                        O2MICRON GREEN{" "}
                                    </td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[0].color}`,
                                            textAlign: "center",
                                        }}
                                    >
                                        {" "}
                                        <VscCircleFilled />
                                    </td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[1].color}`,
                                            textAlign: "center",
                                            color: "#fff",
                                        }}
                                    >
                                        <VscCircleFilled />
                                    </td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[2].color}`,
                                            textAlign: "center",
                                            color: "#fff",
                                        }}
                                    >
                                        <VscCircleFilled />{" "}
                                    </td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[3].color}`,
                                            textAlign: "center",
                                            color: "#fff",
                                        }}
                                    >
                                        <VscCircleFilled />
                                    </td>
                                </tr>

                                <tr>
                                    <td id="Benefits-benefits">
                                        PERSONALIZED ARRIVAL EXPERIENCE{" "}
                                    </td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[0].color}`,
                                            textAlign: "center",
                                        }}
                                    >
                                        {" "}
                                        <VscCircleFilled />
                                    </td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[1].color}`,
                                            textAlign: "center",
                                            color: "#fff",
                                        }}
                                    >
                                        <VscCircleFilled />{" "}
                                    </td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[2].color}`,
                                            textAlign: "center",
                                            color: "#fff",
                                        }}
                                    >
                                        <VscCircleFilled />{" "}
                                    </td>

                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[3].color}`,
                                            textAlign: "center",
                                            color: "#fff",
                                        }}
                                    >
                                        <VscCircleFilled />
                                    </td>
                                </tr>

                                <tr>
                                    <td id="Benefits-benefits">
                                        COMPLIMENTARY LATE CHECK OUT (ON REQUEST
                                        UPON AVAILABILITY
                                    </td>

                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[0].color}`,
                                            textAlign: "center",
                                        }}
                                    ></td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[1].color}`,
                                            textAlign: "center",
                                            color: "#fff",
                                        }}
                                    >
                                        TILL 16:00
                                    </td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[2].color}`,
                                            textAlign: "center",
                                            color: "#fff",
                                        }}
                                    >
                                        TILL 17:00
                                    </td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[3].color}`,
                                            textAlign: "center",
                                            color: "#fff",
                                        }}
                                    >
                                        TILL 18:00
                                    </td>
                                </tr>
                                <tr>
                                    <td id="Benefits-benefits">
                                        COMPLIMENTARY EARLY CHECK IN (SUBJECT TO
                                        AVAILABILITY)
                                    </td>

                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[0].color}`,
                                            textAlign: "center",
                                        }}
                                    ></td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[1].color}`,
                                            textAlign: "center",
                                            color: "#fff",
                                        }}
                                    >
                                        <VscCircleFilled />
                                    </td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[2].color}`,
                                            textAlign: "center",
                                            color: "#fff",
                                        }}
                                    >
                                        <VscCircleFilled />
                                    </td>

                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[3].color}`,
                                            textAlign: "center",
                                            color: "#fff",
                                        }}
                                    >
                                        <VscCircleFilled />
                                    </td>
                                </tr>

                                <tr>
                                    <td id="Benefits-benefits">
                                        VIP DINING EXPERIENCE
                                    </td>

                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[0].color}`,
                                            textAlign: "center",
                                        }}
                                    ></td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[1].color}`,
                                            textAlign: "center",
                                            color: "#fff",
                                        }}
                                    >
                                        10%
                                    </td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[2].color}`,
                                            textAlign: "center",
                                            color: "#fff",
                                        }}
                                    >
                                        15%
                                    </td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[3].color}`,
                                            textAlign: "center",
                                            color: "#fff",
                                        }}
                                    >
                                        20%
                                    </td>
                                </tr>

                                <tr>
                                    <td id="Benefits-benefits">
                                        DISCOUNT FOR SPA PRODUCTS
                                    </td>

                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[0].color}`,
                                            textAlign: "center",
                                        }}
                                    ></td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[1].color}`,
                                            textAlign: "center",
                                            color: "#fff",
                                        }}
                                    >
                                        7%
                                    </td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[2].color}`,
                                            textAlign: "center",
                                            color: "#fff",
                                        }}
                                    >
                                        10%
                                    </td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[3].color}`,
                                            textAlign: "center",
                                            color: "#fff",
                                        }}
                                    >
                                        15%
                                    </td>
                                </tr>
                                <tr>
                                    <td id="Benefits-benefits">
                                        EXCLUSIVE INVITATIONS 
                                    </td>

                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[0].color}`,
                                            textAlign: "center",
                                        }}
                                    ></td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[1].color}`,
                                            textAlign: "center",
                                            color: "#fff",
                                        }}
                                    ></td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[2].color}`,
                                            textAlign: "center",
                                            color: "#fff",
                                        }}
                                    >
                                        <VscCircleFilled />{" "}
                                    </td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[3].color}`,
                                            textAlign: "center",
                                            color: "#fff",
                                        }}
                                    >
                                        <VscCircleFilled />
                                    </td>
                                </tr>
                                <tr>
                                    <td id="Benefits-benefits">
                                        PRIVATE WINE/OLIVE OIL TASTING
                                    </td>

                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[0].color}`,
                                            textAlign: "center",
                                        }}
                                    ></td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[1].color}`,
                                            textAlign: "center",
                                            color: "#fff",
                                        }}
                                    ></td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[2].color}`,
                                            textAlign: "center",
                                            color: "#fff",
                                        }}
                                    >
                                        <VscCircleFilled />{" "}
                                    </td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[3].color}`,
                                            textAlign: "center",
                                            color: "#fff",
                                        }}
                                    >
                                        <VscCircleFilled />
                                    </td>
                                </tr>
                                <tr>
                                    <td id="Benefits-benefits">
                                        ROOM UPGRADE (SUBJECT TO AVAILABILITY)
                                    </td>

                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[0].color}`,
                                            textAlign: "center",
                                        }}
                                    ></td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[1].color}`,
                                            textAlign: "center",
                                            color: "#fff",
                                        }}
                                    ></td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[2].color}`,
                                            textAlign: "center",
                                            color: "#fff",
                                        }}
                                    >
                                        <VscCircleFilled />{" "}
                                    </td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[3].color}`,
                                            textAlign: "center",
                                            color: "#fff",
                                        }}
                                    >
                                        <VscCircleFilled />
                                    </td>
                                </tr>
                                <tr>
                                    <td id="Benefits-benefits">
                                        FLOATING BREAKFAST
                                    </td>

                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[0].color}`,
                                            textAlign: "center",
                                        }}
                                    ></td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[1].color}`,
                                            textAlign: "center",
                                            color: "#fff",
                                        }}
                                    ></td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[2].color}`,
                                            textAlign: "center",
                                            color: "#fff",
                                        }}
                                    >
                                        ONCE PER STAY (MINIMUM 7 NIGHTS){" "}
                                    </td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[3].color}`,
                                            textAlign: "center",
                                            color: "#fff",
                                        }}
                                    >
                                        <VscCircleFilled />
                                    </td>
                                </tr>
                                <tr>
                                    <td id="Benefits-benefits">
                                        COMPLIMENTARY BESPOKEN SPA TREATMENT 
                                    </td>

                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[0].color}`,
                                            textAlign: "center",
                                        }}
                                    ></td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[1].color}`,
                                            textAlign: "center",
                                            color: "#fff",
                                        }}
                                    ></td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[2].color}`,
                                            textAlign: "center",
                                            color: "#fff",
                                        }}
                                    >
                                        ONCE PER STAY (MINIMUM 5 NIGHTS){" "}
                                    </td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[3].color}`,
                                            textAlign: "center",
                                            color: "#fff",
                                        }}
                                    >
                                        ONCE PER STAY (MINIMUM 5 NIGHTS)
                                    </td>
                                </tr>

                                <tr>
                                    <td id="Benefits-benefits">
                                        COMPLIMENTARY PRIVATE &nbsp; TRANSFER
                                    </td>

                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[0].color}`,
                                            textAlign: "center",
                                        }}
                                    ></td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[1].color}`,
                                            textAlign: "center",
                                            color: "#fff",
                                        }}
                                    ></td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[2].color}`,
                                            textAlign: "center",
                                            color: "#fff",
                                        }}
                                    >
                                        ARRIVAL (ONCE PER YEAR){" "}
                                    </td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[3].color}`,
                                            textAlign: "center",
                                            color: "#fff",
                                        }}
                                    >
                                        ARRIVAL & DEPARTURE TRASFER (ONCE PER
                                        YEAR)
                                    </td>
                                </tr>
                                <tr>
                                    <td id="Benefits-benefits">
                                        COMPLIMENTARY USE OF SPA FACILITIES
                                    </td>

                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[0].color}`,
                                            textAlign: "center",
                                        }}
                                    ></td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[1].color}`,
                                            textAlign: "center",
                                            color: "#fff",
                                        }}
                                    ></td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[2].color}`,
                                            textAlign: "center",
                                            color: "#fff",
                                        }}
                                    >
                                        ONCE PER STAY (MINIMUM 5 NIGHTS)
                                    </td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[3].color}`,
                                            textAlign: "center",
                                            color: "#fff",
                                        }}
                                    >
                                        UNLIMITED
                                    </td>
                                </tr>

                                <tr>
                                    <td id="Benefits-benefits">
                                        ONE COMPLIMENTARY NIGHT STAY OF THE SAME
                                        ROOM TYPE
                                    </td>

                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[0].color}`,
                                            textAlign: "center",
                                        }}
                                    ></td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[1].color}`,
                                            textAlign: "center",
                                            color: "#fff",
                                        }}
                                    ></td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[2].color}`,
                                            textAlign: "center",
                                            color: "#fff",
                                        }}
                                    ></td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[3].color}`,
                                            textAlign: "center",
                                            color: "#fff",
                                        }}
                                    >
                                        EVERY 10 NIGHTS STAY, THE 10 NIGHT IS
                                        COMPLIMENTAY
                                    </td>
                                </tr>

                                <tr>
                                    <td id="Benefits-benefits">
                                        PERSONALIZED WELCOME & DEPARTURE GIFT 
                                    </td>

                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[0].color}`,
                                            textAlign: "center",
                                        }}
                                    ></td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[1].color}`,
                                            textAlign: "center",
                                            color: "#fff",
                                        }}
                                    ></td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[2].color}`,
                                            textAlign: "center",
                                            color: "#fff",
                                        }}
                                    ></td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[3].color}`,
                                            textAlign: "center",
                                            color: "#fff",
                                        }}
                                    >
                                        <VscCircleFilled />
                                    </td>
                                </tr>

                                <tr>
                                    <td id="Benefits-benefits">
                                        PRIVATE YOGA OR MEDITATION SESSION
                                    </td>

                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[0].color}`,
                                            textAlign: "center",
                                        }}
                                    ></td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[1].color}`,
                                            textAlign: "center",
                                            color: "#fff",
                                        }}
                                    ></td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[2].color}`,
                                            textAlign: "center",
                                            color: "#fff",
                                        }}
                                    ></td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[3].color}`,
                                            textAlign: "center",
                                            color: "#fff",
                                        }}
                                    >
                                        <VscCircleFilled />
                                    </td>
                                </tr>
                                <tr>
                                    <td id="Benefits-benefits">
                                        BREAKFAST IN BED (once per stay)
                                    </td>

                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[0].color}`,
                                            textAlign: "center",
                                        }}
                                    ></td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[1].color}`,
                                            textAlign: "center",
                                            color: "#fff",
                                        }}
                                    ></td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[2].color}`,
                                            textAlign: "center",
                                            color: "#fff",
                                        }}
                                    ></td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[3].color}`,
                                            textAlign: "center",
                                            color: "#fff",
                                        }}
                                    >
                                        <VscCircleFilled />
                                    </td>
                                </tr>
                            </tbody>
                        </table>

                        <br />
                        <br />
                    </div>
                )}

                {(programLabel === ALT.PROD || programLabel === ALT.INTG) && (
                    <div className="Benefits-tableContainer-Parent">
                        <table className="Benefits-tableContainer">
                            <thead></thead>
                            <tbody style={{ border: "1px solid black" }}>
                                <tr
                                    className="Benefits-headings"
                                    style={{ borderBottom: "1px solid black" }}
                                >
                                    <td
                                        style={{
                                            fontWeight: "600",
                                            textAlign: "center",
                                            width: "40%",
                                        }}
                                    >
                                        Benefits at a glance
                                    </td>

                                    <td
                                        className="Benefits-Tier"
                                        style={{
                                            // background: `${tiers[0].color}`,
                                            fontWeight: "600",
                                            textAlign: "center",
                                        }}
                                    >
                                        Level 1
                                    </td>
                                    <td
                                        className="Benefits-Tier"
                                        style={{
                                            // background: `${tiers[1].color}`,
                                            fontWeight: "600",
                                            textAlign: "center",
                                        }}
                                    >
                                        Level 2
                                    </td>
                                    <td
                                        className="Benefits-Tier"
                                        style={{
                                            // background: `${tiers[2].color}`,
                                            fontWeight: "600",
                                            textAlign: "center",
                                        }}
                                    >
                                        Level 3
                                    </td>
                                </tr>
                                <tr>
                                    <td id="Benefits-benefits">
                                        Spend 1€, get 1 loyalty point!
                                    </td>
                                    <td
                                        style={{
                                            // background: `${tiers[0].color}`,
                                            textAlign: "center",
                                        }}
                                    >
                                        <VscCircleFilled />
                                    </td>
                                    <td
                                        style={{
                                            // background: `${tiers[1].color}`,
                                            textAlign: "center",
                                        }}
                                    >
                                        <VscCircleFilled />
                                    </td>
                                    <td
                                        style={{
                                            // background: `${tiers[2].color}`,
                                            textAlign: "center",
                                        }}
                                    >
                                        <VscCircleFilled />
                                    </td>
                                </tr>
                                <tr>
                                    <td id="Benefits-benefits">
                                        Discount for direct bookings
                                    </td>

                                    <td
                                        style={{
                                            // background: `${tiers[0].color}`,
                                            textAlign: "center",
                                        }}
                                    >
                                        5%
                                    </td>
                                    <td
                                        style={{
                                            // background: `${tiers[1].color}`,
                                            textAlign: "center",
                                        }}
                                    >
                                        7%
                                    </td>
                                    <td
                                        style={{
                                            // background: `${tiers[2].color}`,
                                            textAlign: "center",
                                        }}
                                    >
                                        10%
                                    </td>
                                </tr>
                                <tr>
                                    <td id="Benefits-benefits">
                                        {" "}
                                        A bottle of wine, water and a fruit
                                        basket in room upon arrival (applies
                                        only for online bookings via
                                        atlanticahotels.com)
                                    </td>

                                    <td
                                        style={{
                                            // background: `${tiers[0].color}`,
                                            textAlign: "center",
                                        }}
                                    >
                                        <VscCircleFilled />
                                    </td>
                                    <td
                                        style={{
                                            // background: `${tiers[1].color}`,
                                            textAlign: "center",
                                        }}
                                    >
                                        <VscCircleFilled />
                                    </td>
                                    <td
                                        style={{
                                            // background: `${tiers[2].color}`,
                                            textAlign: "center",
                                        }}
                                    >
                                        <VscCircleFilled />
                                    </td>
                                </tr>
                                <tr>
                                    <td id="Benefits-benefits">
                                        Late check-out until 14:00 (subject to
                                        availability)
                                    </td>

                                    <td
                                        style={{
                                            // background: `${tiers[0].color}`,
                                            textAlign: "center",
                                        }}
                                    ></td>
                                    <td
                                        style={{
                                            // background: `${tiers[1].color}`,
                                            textAlign: "center",
                                        }}
                                    >
                                        <VscCircleFilled />
                                    </td>
                                    <td
                                        style={{
                                            // background: `${tiers[2].color}`,
                                            textAlign: "center",
                                        }}
                                    >
                                        <VscCircleFilled />
                                    </td>
                                </tr>
                                <tr>
                                    <td id="Benefits-benefits">
                                        One free a la Carte meal* during the
                                        stay in the Hotel (Applies for Atlantica
                                        Hotels which operate A La Carte
                                        Restaurants)
                                    </td>

                                    <td
                                        style={{
                                            // background: `${tiers[0].color}`,
                                            textAlign: "center",
                                        }}
                                    ></td>
                                    <td
                                        style={{
                                            // background: `${tiers[1].color}`,
                                            textAlign: "center",
                                        }}
                                    ></td>
                                    <td
                                        style={{
                                            // background: `${tiers[2].color}`,
                                            textAlign: "center",
                                        }}
                                    >
                                        <VscCircleFilled />
                                    </td>
                                </tr>
                                <tr>
                                    <td id="Benefits-benefits">
                                        Late check-out until 18:00 (subject to
                                        availability)
                                    </td>

                                    <td
                                        style={{
                                            // background: `${tiers[0].color}`,
                                            textAlign: "center",
                                        }}
                                    ></td>
                                    <td
                                        style={{
                                            // background: `${tiers[1].color}`,
                                            textAlign: "center",
                                        }}
                                    ></td>
                                    <td
                                        style={{
                                            // background: `${tiers[2].color}`,
                                            textAlign: "center",
                                        }}
                                    >
                                        <VscCircleFilled />
                                    </td>
                                </tr>
                                <tr>
                                    <td id="Benefits-benefits">
                                        Room Upgrade (subject to availability)
                                    </td>

                                    <td
                                        style={{
                                            // background: `${tiers[0].color}`,
                                            textAlign: "center",
                                        }}
                                    ></td>
                                    <td
                                        style={{
                                            // background: `${tiers[1].color}`,
                                            textAlign: "center",
                                        }}
                                    ></td>
                                    <td
                                        style={{
                                            // background: `${tiers[2].color}`,
                                            textAlign: "center",
                                        }}
                                    >
                                        <VscCircleFilled />
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                        <br />
                        <br />
                    </div>
                )}
                {programLabel === "AA116997-54BC-468D-94C7-28EFD2FF7C4C" && (
                    <div className="Benefits-tableContainer-Parent">
                        <table className="Benefits-tableContainer">
                            <thead></thead>
                            <tbody>
                                <tr className="Benefits-headings">
                                    <td
                                        id="Benefits-Tier"
                                        style={{
                                            fontWeight: "600",
                                            textAlign: "center",
                                        }}
                                    >
                                        Benefits at a glance
                                    </td>

                                    <td
                                        id="Benefits-Tier"
                                        style={{
                                            background: `${tiers[0].color}`,

                                            fontWeight: "600",
                                            textAlign: "center",
                                        }}
                                    >
                                        Silver
                                    </td>
                                    <td
                                        id="Benefits-Tier"
                                        style={{
                                            background: `${tiers[1].color}`,

                                            fontWeight: "600",
                                            textAlign: "center",
                                        }}
                                    >
                                        Gold
                                    </td>
                                    <td
                                        id="Benefits-Tier"
                                        style={{
                                            background: `${tiers[2].color}`,

                                            fontWeight: "600",
                                            textAlign: "center",
                                            color: "white",
                                        }}
                                    >
                                        Platinum
                                    </td>
                                </tr>
                                <tr>
                                    <td
                                        id="Benefits-benefits"
                                        className=" font-bold"
                                    >
                                        Enrollment bonus points
                                    </td>

                                    <td
                                        id="Benefits-benefits"
                                        className=" font-bold"
                                        style={{
                                            background: `${tiers[0].color}`,
                                            textAlign: "center",
                                        }}
                                    >
                                        30
                                    </td>
                                    <td
                                        id="Benefits-benefits"
                                        className=" font-bold"
                                        style={{
                                            background: `${tiers[1].color}`,
                                            textAlign: "center",
                                        }}
                                    >
                                        {" "}
                                        30
                                    </td>
                                    <td
                                        id="Benefits-benefits"
                                        className=" font-bold"
                                        style={{
                                            background: `${tiers[2].color}`,
                                            textAlign: "center",
                                            color: "white",
                                        }}
                                    >
                                        30
                                    </td>
                                </tr>
                                <tr>
                                    <td id="Benefits-benefits">
                                        Discount on hotels's website rates
                                        (discount percentage according to tier)
                                    </td>

                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[0].color}`,
                                            textAlign: "center",
                                        }}
                                    >
                                        10%
                                    </td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[1].color}`,
                                            textAlign: "center",
                                        }}
                                    >
                                        15%
                                    </td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[2].color}`,
                                            textAlign: "center",
                                            color: "white",
                                        }}
                                    >
                                        20%
                                    </td>
                                </tr>
                                <tr>
                                    <td id="Benefits-benefits">
                                        Invitation to Manager's Cocktail
                                    </td>

                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[0].color}`,
                                            textAlign: "center",
                                        }}
                                    >
                                        <VscCircleFilled />
                                    </td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[1].color}`,
                                            textAlign: "center",
                                        }}
                                    >
                                        <VscCircleFilled />
                                    </td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[2].color}`,
                                            textAlign: "center",
                                            color: "white",
                                        }}
                                    >
                                        <VscCircleFilled />
                                    </td>
                                </tr>
                                <tr>
                                    <td id="Benefits-benefits">
                                        Welcome offer in room
                                    </td>

                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[0].color}`,
                                            textAlign: "center",
                                        }}
                                    >
                                        <VscCircleFilled />
                                    </td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[1].color}`,
                                            textAlign: "center",
                                        }}
                                    >
                                        <VscCircleFilled />
                                    </td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[2].color}`,
                                            textAlign: "center",
                                            color: "white",
                                        }}
                                    >
                                        <VscCircleFilled />
                                    </td>
                                </tr>

                                <tr>
                                    <td id="Benefits-benefits">
                                        Special departure gift according to tier
                                    </td>

                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[0].color}`,
                                            textAlign: "center",
                                        }}
                                    >
                                        {" "}
                                        <VscCircleFilled />
                                    </td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[1].color}`,
                                            textAlign: "center",
                                        }}
                                    >
                                        {" "}
                                        <VscCircleFilled />
                                    </td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[2].color}`,
                                            textAlign: "center",
                                            color: "white",
                                        }}
                                    >
                                        <VscCircleFilled />
                                    </td>
                                </tr>
                                <tr>
                                    <td id="Benefits-benefits">
                                        Priority Check In Upon Arrival{" "}
                                    </td>

                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[0].color}`,
                                            textAlign: "center",
                                        }}
                                    >
                                        {" "}
                                        <VscCircleFilled />
                                    </td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[1].color}`,
                                            textAlign: "center",
                                        }}
                                    >
                                        {" "}
                                        <VscCircleFilled />
                                    </td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[2].color}`,
                                            textAlign: "center",
                                            color: "white",
                                        }}
                                    >
                                        <VscCircleFilled />
                                    </td>
                                </tr>
                                <tr>
                                    <td id="Benefits-benefits">
                                        Discount on Spa Treatments
                                    </td>

                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[0].color}`,
                                            textAlign: "center",
                                        }}
                                    >
                                        {" "}
                                        <VscCircleFilled />
                                    </td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[1].color}`,
                                            textAlign: "center",
                                        }}
                                    >
                                        {" "}
                                        <VscCircleFilled />
                                    </td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[2].color}`,
                                            textAlign: "center",
                                            color: "white",
                                        }}
                                    >
                                        <VscCircleFilled />
                                    </td>
                                </tr>
                                <tr>
                                    <td id="Benefits-benefits">
                                        Hotel Outlets discount
                                    </td>

                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[0].color}`,
                                            textAlign: "center",
                                        }}
                                    >
                                        {" "}
                                        <VscCircleFilled />
                                    </td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[1].color}`,
                                            textAlign: "center",
                                        }}
                                    >
                                        {" "}
                                        <VscCircleFilled />
                                    </td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[2].color}`,
                                            textAlign: "center",
                                            color: "white",
                                        }}
                                    >
                                        <VscCircleFilled />
                                    </td>
                                </tr>
                                <tr>
                                    <td id="Benefits-benefits">
                                        3rd party discount{" "}
                                    </td>

                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[0].color}`,
                                            textAlign: "center",
                                        }}
                                    >
                                        {" "}
                                        <VscCircleFilled />
                                    </td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[1].color}`,
                                            textAlign: "center",
                                        }}
                                    >
                                        {" "}
                                        <VscCircleFilled />
                                    </td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[2].color}`,
                                            textAlign: "center",
                                            color: "white",
                                        }}
                                    >
                                        <VscCircleFilled />
                                    </td>
                                </tr>

                                <tr>
                                    <td id="Benefits-benefits">
                                        3rd party experiences
                                    </td>

                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[0].color}`,
                                            textAlign: "center",
                                        }}
                                    >
                                        {" "}
                                        <VscCircleFilled />
                                    </td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[1].color}`,
                                            textAlign: "center",
                                        }}
                                    >
                                        {" "}
                                        <VscCircleFilled />
                                    </td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[2].color}`,
                                            textAlign: "center",
                                            color: "white",
                                        }}
                                    >
                                        {" "}
                                        <VscCircleFilled />
                                    </td>
                                </tr>
                                <tr>
                                    <td id="Benefits-benefits">
                                        Exclusive emails with hidden benefits
                                        per tier
                                    </td>

                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[0].color}`,
                                            textAlign: "center",
                                        }}
                                    >
                                        {" "}
                                        <VscCircleFilled />
                                    </td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[1].color}`,
                                            textAlign: "center",
                                        }}
                                    >
                                        {" "}
                                        <VscCircleFilled />
                                    </td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[2].color}`,
                                            textAlign: "center",
                                            color: "white",
                                        }}
                                    >
                                        {" "}
                                        <VscCircleFilled />
                                    </td>
                                </tr>
                                <tr>
                                    <td id="Benefits-benefits">Free nights</td>

                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[0].color}`,
                                            textAlign: "center",
                                        }}
                                    >
                                        <VscCircleFilled />
                                    </td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[1].color}`,
                                            textAlign: "center",
                                        }}
                                    >
                                        <VscCircleFilled />
                                    </td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[2].color}`,
                                            textAlign: "center",
                                            color: "white",
                                        }}
                                    >
                                        <VscCircleFilled />
                                    </td>
                                </tr>

                                <tr>
                                    <td id="Benefits-benefits">
                                        Complimentary Early Check In
                                    </td>

                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[0].color}`,
                                            textAlign: "center",
                                        }}
                                    ></td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[1].color}`,
                                            textAlign: "center",
                                        }}
                                    >
                                        <VscCircleFilled />
                                    </td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[2].color}`,
                                            textAlign: "center",
                                            color: "white",
                                        }}
                                    >
                                        <VscCircleFilled />
                                    </td>
                                </tr>
                                <tr>
                                    <td id="Benefits-benefits">
                                        Complimentary Late Check Out
                                    </td>

                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[0].color}`,
                                            textAlign: "center",
                                        }}
                                    ></td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[1].color}`,
                                            textAlign: "center",
                                        }}
                                    >
                                        <VscCircleFilled />
                                    </td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[2].color}`,
                                            textAlign: "center",
                                            color: "white",
                                        }}
                                    >
                                        <VscCircleFilled />
                                    </td>
                                </tr>
                                <tr>
                                    <td id="Benefits-benefits">
                                        Free Spa Treatment
                                    </td>

                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[0].color}`,
                                            textAlign: "center",
                                        }}
                                    ></td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[1].color}`,
                                            textAlign: "center",
                                        }}
                                    >
                                        <VscCircleFilled />
                                    </td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[2].color}`,
                                            textAlign: "center",
                                            color: "white",
                                        }}
                                    >
                                        <VscCircleFilled />
                                    </td>
                                </tr>
                                {/* <tr>
                                    <td id="Benefits-benefits">
                                        Reserved sunbeds at the beach
                                    </td>

                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[0].color}`,
                                            textAlign: "center",
                                        }}
                                    ></td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[1].color}`,
                                            textAlign: "center",
                                        }}
                                    >
                                        <VscCircleFilled />
                                    </td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[2].color}`,
                                            textAlign: "center",
                                            color: "white",
                                        }}
                                    >
                                        <VscCircleFilled />
                                    </td>
                                </tr> */}
                                <tr>
                                    <td id="Benefits-benefits">
                                        Free Room Upgrade
                                    </td>

                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[0].color}`,
                                            textAlign: "center",
                                        }}
                                    ></td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[1].color}`,
                                            textAlign: "center",
                                        }}
                                    ></td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[2].color}`,
                                            textAlign: "center",
                                            color: "white",
                                        }}
                                    >
                                        <VscCircleFilled />
                                    </td>
                                </tr>
                                <tr>
                                    <td id="Benefits-benefits">
                                        Complimentary a la carte Dinner
                                    </td>

                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[0].color}`,
                                            textAlign: "center",
                                        }}
                                    ></td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[1].color}`,
                                            textAlign: "center",
                                        }}
                                    ></td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[2].color}`,
                                            textAlign: "center",
                                            color: "white",
                                        }}
                                    >
                                        <VscCircleFilled />
                                    </td>
                                </tr>
                                <tr>
                                    <td id="Benefits-benefits">
                                        Free Transfer from/to Heraklion airport
                                    </td>

                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[0].color}`,
                                            textAlign: "center",
                                        }}
                                    ></td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[1].color}`,
                                            textAlign: "center",
                                        }}
                                    ></td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[2].color}`,
                                            textAlign: "center",
                                            color: "white",
                                        }}
                                    >
                                        <VscCircleFilled />
                                    </td>
                                </tr>
                                <tr>
                                    <td id="Benefits-benefits">
                                        Reserved Gazebo
                                    </td>

                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[0].color}`,
                                            textAlign: "center",
                                        }}
                                    ></td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[1].color}`,
                                            textAlign: "center",
                                        }}
                                    ></td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[2].color}`,
                                            textAlign: "center",
                                            color: "white",
                                        }}
                                    >
                                        <VscCircleFilled />
                                    </td>
                                </tr>
                                <tr>
                                    <td id="Benefits-benefits">
                                        Free laundry service
                                    </td>

                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[0].color}`,
                                            textAlign: "center",
                                        }}
                                    ></td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[1].color}`,
                                            textAlign: "center",
                                        }}
                                    ></td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[2].color}`,
                                            textAlign: "center",
                                            color: "white",
                                        }}
                                    >
                                        <VscCircleFilled />
                                    </td>
                                </tr>
                                <tr>
                                    <td id="Benefits-benefits">
                                        Room extras discount
                                    </td>

                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[0].color}`,
                                            textAlign: "center",
                                        }}
                                    ></td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[1].color}`,
                                            textAlign: "center",
                                        }}
                                    ></td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[2].color}`,
                                            textAlign: "center",
                                            color: "white",
                                        }}
                                    >
                                        <VscCircleFilled />
                                    </td>
                                </tr>
                                <tr>
                                    <td id="Benefits-benefits">
                                        Beauty Basket with branded local
                                        products
                                    </td>

                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[0].color}`,
                                            textAlign: "center",
                                        }}
                                    ></td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[1].color}`,
                                            textAlign: "center",
                                        }}
                                    ></td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[2].color}`,
                                            textAlign: "center",
                                            color: "white",
                                        }}
                                    >
                                        <VscCircleFilled />
                                    </td>
                                </tr>
                                <tr>
                                    <td id="Benefits-benefits">
                                        In room Breakfast{" "}
                                    </td>

                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[0].color}`,
                                            textAlign: "center",
                                        }}
                                    ></td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[1].color}`,
                                            textAlign: "center",
                                        }}
                                    ></td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[2].color}`,
                                            textAlign: "center",
                                            color: "white",
                                        }}
                                    >
                                        <VscCircleFilled />
                                    </td>
                                </tr>
                                <tr>
                                    <td id="Benefits-benefits">
                                        Luxurious Hotel Beach Bag
                                    </td>

                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[0].color}`,
                                            textAlign: "center",
                                        }}
                                    ></td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[1].color}`,
                                            textAlign: "center",
                                        }}
                                    ></td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[2].color}`,
                                            textAlign: "center",
                                            color: "white",
                                        }}
                                    >
                                        <VscCircleFilled />
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                        <br></br>
                        <div style={{ marginLeft: "10%" }}>
                            <h3>Conditions</h3>
                            <ul>
                                <li>
                                    Direct bookings are considered those made
                                    directly with the hotel via its website, or
                                    by email, or by phone.
                                </li>
                                <li>
                                    Priority Check In Upon Arrival,
                                    Complimentary Early Check In, Complimentary
                                    Late Check Out, Free Room Upgrade: Benefits
                                    applied upon availability
                                </li>
                                <li>
                                    Luxurious Hotel Beach Bag, Beauty Basket
                                    with branded local products, In-Room
                                    Breakfast, Free laundry service, Free Spa
                                    treatment: Benefits applied if minimum stay
                                    of 3 days is fulfilled and offered once per
                                    stay
                                </li>
                                <li>
                                    Reserved sunbeds at the beach, Reserved
                                    Gazebo: Benefits applied if available by the
                                    hotel
                                </li>
                                <li>
                                    Free Transfer from/to Heraklion airport:
                                    Benefits applied if available by the hotel
                                    and a minimum stay applies depending on the
                                    hotel
                                </li>
                                <li>
                                    Complimentary a la carte Dinner: Benefits
                                    applied once per week and minimum stay of
                                    one fully completed week is required
                                </li>
                            </ul>
                        </div>
                        <br></br>
                        <br></br>
                    </div>
                )}

                {programLabel ===
                    "AVRACOLL-13A15C9C-186C-42C6-9240-FEB62E2A9EC1" && (
                    <div className="Benefits-tableContainer-Parent">
                        <table className="Benefits-tableContainer">
                            <thead></thead>
                            <tbody>
                                <tr className="Benefits-headings">
                                    <td
                                        id="Benefits-Tier"
                                        style={{
                                            fontWeight: "600",
                                            textAlign: "center",
                                            width: "40%",
                                        }}
                                    >
                                        Benefits at a glance
                                    </td>

                                    <td
                                        id="Benefits-Tier"
                                        style={{
                                            background: `${tiers[0].color}`,
                                            fontWeight: "600",
                                            textAlign: "center",
                                        }}
                                    >
                                        White
                                    </td>
                                    <td
                                        id="Benefits-Tier"
                                        style={{
                                            background: `${tiers[1].color}`,
                                            fontWeight: "600",
                                            textAlign: "center",
                                        }}
                                    >
                                        Silver
                                    </td>
                                    <td
                                        id="Benefits-Tier"
                                        style={{
                                            background: `${tiers[2].color}`,
                                            fontWeight: "600",
                                            textAlign: "center",
                                        }}
                                    >
                                        Gold
                                    </td>
                                </tr>
                                <tr>
                                    <td id="Benefits-benefits">
                                        Member Rates for Direct Discount *
                                    </td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[0].color}`,
                                            textAlign: "center",
                                        }}
                                    >
                                        3%
                                    </td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[1].color}`,
                                            textAlign: "center",
                                        }}
                                    >
                                        7%
                                    </td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[2].color}`,
                                            textAlign: "center",
                                        }}
                                    >
                                        10%
                                    </td>
                                </tr>
                                <tr>
                                    <td id="Benefits-benefits">
                                        Room upgrade on availablity
                                    </td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[0].color}`,
                                            textAlign: "center",
                                        }}
                                    >
                                        <VscCircleFilled />
                                    </td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[1].color}`,
                                            textAlign: "center",
                                        }}
                                    >
                                        <VscCircleFilled />
                                    </td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[2].color}`,
                                            textAlign: "center",
                                        }}
                                    >
                                        <VscCircleFilled />
                                    </td>
                                </tr>
                                <tr>
                                    <td id="Benefits-benefits">
                                        VIP welcome amenity
                                    </td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[0].color}`,
                                            textAlign: "center",
                                        }}
                                    >
                                        <VscCircleFilled />
                                    </td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[1].color}`,
                                            textAlign: "center",
                                        }}
                                    >
                                        <VscCircleFilled />
                                    </td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[2].color}`,
                                            textAlign: "center",
                                        }}
                                    >
                                        <VscCircleFilled />
                                    </td>
                                </tr>
                                <tr>
                                    <td id="Benefits-benefits">
                                        Daily unlimited (high speed) internet
                                        access for unlimited number of devices
                                    </td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[0].color}`,
                                            textAlign: "center",
                                        }}
                                    >
                                        <VscCircleFilled />
                                    </td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[1].color}`,
                                            textAlign: "center",
                                        }}
                                    >
                                        <VscCircleFilled />
                                    </td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[2].color}`,
                                            textAlign: "center",
                                        }}
                                    >
                                        <VscCircleFilled />
                                    </td>
                                </tr>

                                <tr>
                                    <td id="Benefits-benefits">
                                        Early check-in bassed on availability
                                    </td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[0].color}`,
                                            textAlign: "center",
                                        }}
                                    ></td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[1].color}`,
                                            textAlign: "center",
                                        }}
                                    >
                                        <VscCircleFilled />
                                    </td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[2].color}`,
                                            textAlign: "center",
                                        }}
                                    >
                                        <VscCircleFilled />
                                    </td>
                                </tr>

                                <tr>
                                    <td id="Benefits-benefits">
                                        Late check-out(4 p.m.) based on
                                        availability
                                    </td>

                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[0].color}`,
                                            textAlign: "center",
                                        }}
                                    >
                                        <VscCircleFilled />
                                    </td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[1].color}`,
                                            textAlign: "center",
                                        }}
                                    >
                                        <VscCircleFilled />
                                    </td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[2].color}`,
                                            textAlign: "center",
                                        }}
                                    >
                                        <VscCircleFilled />
                                    </td>
                                </tr>
                                <tr>
                                    <td id="Benefits-benefits">
                                        Personalized Welcome Note
                                    </td>

                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[0].color}`,
                                            textAlign: "center",
                                        }}
                                    >
                                        <VscCircleFilled />
                                    </td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[1].color}`,
                                            textAlign: "center",
                                        }}
                                    >
                                        <VscCircleFilled />
                                    </td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[2].color}`,
                                            textAlign: "center",
                                        }}
                                    >
                                        <VscCircleFilled />
                                    </td>
                                </tr>

                                <tr>
                                    <td id="Benefits-benefits">
                                        Complimentary 30-minute extension on any
                                        50-minute body or face treatment(exc.
                                        ...)
                                    </td>

                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[0].color}`,
                                            textAlign: "center",
                                        }}
                                    >
                                        <VscCircleFilled />
                                    </td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[1].color}`,
                                            textAlign: "center",
                                        }}
                                    >
                                        <VscCircleFilled />
                                    </td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[2].color}`,
                                            textAlign: "center",
                                        }}
                                    >
                                        <VscCircleFilled />
                                    </td>
                                </tr>

                                <tr>
                                    <td id="Benefits-benefits">
                                        Clothes pressing/dry cleaning
                                    </td>

                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[0].color}`,
                                            textAlign: "center",
                                        }}
                                    >
                                        <VscCircleFilled />
                                    </td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[1].color}`,
                                            textAlign: "center",
                                        }}
                                    >
                                        <VscCircleFilled />
                                    </td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[2].color}`,
                                            textAlign: "center",
                                        }}
                                    >
                                        <VscCircleFilled />
                                    </td>
                                </tr>

                                <tr>
                                    <td id="Benefits-benefits">
                                        Unpacking services
                                    </td>

                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[0].color}`,
                                            textAlign: "center",
                                        }}
                                    >
                                        <VscCircleFilled />
                                    </td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[1].color}`,
                                            textAlign: "center",
                                        }}
                                    >
                                        <VscCircleFilled />
                                    </td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[2].color}`,
                                            textAlign: "center",
                                        }}
                                    >
                                        <VscCircleFilled />
                                    </td>
                                </tr>
                            </tbody>
                        </table>

                        <br />
                        <br />
                    </div>
                )}

                {programLabel ===
                    "ALD-D6723397-1407-4C60-93BD-386DCE063346" && (
                    <div className="Benefits-tableContainer-Parent">
                        <table className="Benefits-tableContainer">
                            <thead></thead>
                            <tbody>
                                <tr className="Benefits-headings">
                                    <td
                                        id="Benefits-Tier"
                                        style={{
                                            fontWeight: "600",
                                            textAlign: "center",
                                            width: "40%",
                                        }}
                                    >
                                        Benefits
                                    </td>

                                    <td
                                        id="Benefits-Tier"
                                        style={{
                                            background: `${tiers[0].color}`,
                                            fontWeight: "600",
                                            textAlign: "center",
                                        }}
                                    >
                                        Admirer (from 0 - 99.999 points)
                                    </td>
                                    <td
                                        id="Benefits-Tier"
                                        style={{
                                            background: `${tiers[1].color}`,
                                            fontWeight: "600",
                                            textAlign: "center",
                                        }}
                                    >
                                        Enthusiast (from 100.000 – 199.999
                                        points)
                                    </td>
                                    <td
                                        id="Benefits-Tier"
                                        style={{
                                            background: `${tiers[2].color}`,
                                            fontWeight: "600",
                                            textAlign: "center",
                                        }}
                                    >
                                        Devotee (from 200.000 points)
                                    </td>
                                </tr>
                                <tr>
                                    <td id="Benefits-benefits">
                                        Discount on direct future bookings
                                    </td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[0].color}`,
                                            textAlign: "center",
                                        }}
                                    >
                                        5%
                                    </td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[1].color}`,
                                            textAlign: "center",
                                        }}
                                    >
                                        5%
                                    </td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[2].color}`,
                                            textAlign: "center",
                                        }}
                                    >
                                        5%
                                    </td>
                                </tr>
                                <tr>
                                    <td id="Benefits-benefits">
                                        Priority check in
                                    </td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[0].color}`,
                                            textAlign: "center",
                                        }}
                                    >
                                        <VscCircleFilled />
                                    </td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[1].color}`,
                                            textAlign: "center",
                                        }}
                                    >
                                        <VscCircleFilled />
                                    </td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[2].color}`,
                                            textAlign: "center",
                                        }}
                                    >
                                        <VscCircleFilled />
                                    </td>
                                </tr>
                                <tr>
                                    <td id="Benefits-benefits">
                                        Bonus points with registration (500
                                        points)
                                    </td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[0].color}`,
                                            textAlign: "center",
                                        }}
                                    >
                                        <VscCircleFilled />
                                    </td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[1].color}`,
                                            textAlign: "center",
                                        }}
                                    >
                                        <VscCircleFilled />
                                    </td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[2].color}`,
                                            textAlign: "center",
                                        }}
                                    >
                                        <VscCircleFilled />
                                    </td>
                                </tr>
                                <tr>
                                    <td id="Benefits-benefits">
                                        Discount in Spa/Wellness Center
                                    </td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[0].color}`,
                                            textAlign: "center",
                                        }}
                                    >
                                        10%
                                    </td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[1].color}`,
                                            textAlign: "center",
                                        }}
                                    >
                                        10%
                                    </td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[2].color}`,
                                            textAlign: "center",
                                        }}
                                    >
                                        Complimentary 25' Massage
                                    </td>
                                </tr>

                                <tr>
                                    <td id="Benefits-benefits">
                                        Complimentary late check out until 17:00
                                        (upon availability)
                                    </td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[0].color}`,
                                            textAlign: "center",
                                        }}
                                    ></td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[1].color}`,
                                            textAlign: "center",
                                        }}
                                    >
                                        <VscCircleFilled />
                                    </td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[2].color}`,
                                            textAlign: "center",
                                        }}
                                    >
                                        <VscCircleFilled />
                                    </td>
                                </tr>

                                <tr>
                                    <td id="Benefits-benefits">
                                        Room Upgrade (upon availability)
                                    </td>

                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[0].color}`,
                                            textAlign: "center",
                                        }}
                                    ></td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[1].color}`,
                                            textAlign: "center",
                                        }}
                                    >
                                        <VscCircleFilled />
                                    </td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[2].color}`,
                                            textAlign: "center",
                                        }}
                                    >
                                        <VscCircleFilled />
                                    </td>
                                </tr>
                                <tr>
                                    <td id="Benefits-benefits">
                                        Welcome Treat upon arrival
                                    </td>

                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[0].color}`,
                                            textAlign: "center",
                                        }}
                                    ></td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[1].color}`,
                                            textAlign: "center",
                                        }}
                                    >
                                        Enthusiast Welcome Treat
                                    </td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[2].color}`,
                                            textAlign: "center",
                                        }}
                                    >
                                        Devotee Welcome Treat
                                    </td>
                                </tr>

                                <tr>
                                    <td id="Benefits-benefits">
                                        Free mini bar with soft drinks &
                                        refreshments with daily refill
                                    </td>

                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[0].color}`,
                                            textAlign: "center",
                                        }}
                                    ></td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[1].color}`,
                                            textAlign: "center",
                                        }}
                                    ></td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[2].color}`,
                                            textAlign: "center",
                                        }}
                                    >
                                        <VscCircleFilled />
                                    </td>
                                </tr>

                                <tr>
                                    <td id="Benefits-benefits">
                                        1 Complimentary a la carte meal
                                    </td>

                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[0].color}`,
                                            textAlign: "center",
                                        }}
                                    ></td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[1].color}`,
                                            textAlign: "center",
                                        }}
                                    ></td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[2].color}`,
                                            textAlign: "center",
                                        }}
                                    >
                                        <VscCircleFilled />
                                    </td>
                                </tr>

                                <tr>
                                    <td id="Benefits-benefits">
                                        Special departure gift
                                    </td>

                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[0].color}`,
                                            textAlign: "center",
                                        }}
                                    ></td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[1].color}`,
                                            textAlign: "center",
                                        }}
                                    ></td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[2].color}`,
                                            textAlign: "center",
                                        }}
                                    >
                                        <VscCircleFilled />
                                    </td>
                                </tr>
                                <tr>
                                    <td id="Benefits-benefits">
                                        Afternoon maid service
                                    </td>

                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[0].color}`,
                                            textAlign: "center",
                                        }}
                                    ></td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[1].color}`,
                                            textAlign: "center",
                                        }}
                                    ></td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[2].color}`,
                                            textAlign: "center",
                                        }}
                                    >
                                        <VscCircleFilled />
                                    </td>
                                </tr>
                            </tbody>
                        </table>

                        <br />
                        <br />
                    </div>
                )}
                {/* <div className="tier-benefits-container">
      <div className={`tier-column ${memberInfo.memberTier === 'Admirer' ? 'active-tier' : ''}`} 
      style={{ backgroundColor: `${tiers[0].color}`}}>
        <h3>Admirer (0 - 99,999 points)</h3>
        <ul>
          <li> 5% discount on direct future bookings</li>
          <li> Priority check-in</li>
          <li> Bonus points with registration (500 points)</li>
          <li> 10% discount in Spa/Wellness Center</li>
        </ul>
      </div>
      <div className={`tier-column ${memberInfo.memberTier === 'Enthusiast' ? 'active-tier' : ''}`}
        style={{ backgroundColor: `${tiers[1].color}`}}>
        <h3>Enthusiast (100,000 – 199,999 points)</h3>
        <ul>
          <li> 5% discount on direct future bookings</li>
          <li> Priority check-in</li>
          <li> Sparkling wine and fruit basket in the room upon arrival</li>
          <li> Complimentary check-out until 17:00 (upon availability)</li>
          <li> Room Upgrade (upon availability)</li>
          <li> 10% discount in Spa/Wellness Center</li>
        </ul>
      </div>
      <div className={`tier-column ${memberInfo.memberTier === 'Devotee' ? 'active-tier' : ''}`}
        style={{ backgroundColor: `${tiers[2].color}`, color:'white'}}>
        <h3>Devotee (200,000 points)</h3>
        <ul>
          <li> 5% discount on direct future bookings</li>
          <li> Priority check-in</li>
          <li> Free mini bar with soft drinks & refreshments with daily refill</li>
          <li> Bottle of champagne & flowers upon arrival</li>
          <li> 1 Complimentary a la carte meal</li>
          <li> Special departure gift</li>
          <li> Complimentary 25' massage</li>
          <li> Room Upgrade (upon availability)</li>
          <li> Afternoon maid service</li>
        </ul>
      </div>
    </div> */}
                {programLabel === "0E2CBAB8-4DA6-402D-8185-36E907243324" && (
                    <div className="Benefits-tableContainer-Parent">
                        <table className="Benefits-tableContainer">
                            <thead></thead>
                            <tbody>
                                <tr className="Benefits-headings">
                                    <td
                                        id="Benefits-Tier"
                                        style={{
                                            fontWeight: "600",
                                            textAlign: "center",
                                            width: "40%",
                                        }}
                                    >
                                        Zoe's Loyalty Club & Rewards
                                    </td>

                                    <td
                                        id="Benefits-Tier"
                                        style={{
                                            background: `${tiers[0].color}`,
                                            fontWeight: "600",
                                            textAlign: "center",
                                        }}
                                    >
                                        Loyal (0 - 39,999 points)
                                    </td>
                                    <td
                                        id="Benefits-Tier"
                                        style={{
                                            background: `${tiers[1].color}`,
                                            fontWeight: "600",
                                            textAlign: "center",
                                        }}
                                    >
                                        VIP (40,000 - 59,999 points)
                                    </td>
                                    <td
                                        id="Benefits-Tier"
                                        style={{
                                            background: `${tiers[2].color}`,
                                            color: "white",

                                            fontWeight: "600",
                                            textAlign: "center",
                                        }}
                                    >
                                        Ambassador (60,000+ points)
                                    </td>
                                </tr>
                                <tr>
                                    <td id="Benefits-benefits">Member Rate</td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[0].color}`,
                                            textAlign: "center",
                                        }}
                                    >
                                        10%
                                    </td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[1].color}`,
                                            textAlign: "center",
                                        }}
                                    >
                                        12%
                                    </td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[2].color}`,
                                            color: "white",

                                            textAlign: "center",
                                        }}
                                    >
                                        15%
                                    </td>
                                </tr>
                                <tr>
                                    <td id="Benefits-benefits">
                                        Welcome Treatment in the room
                                    </td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[0].color}`,
                                            textAlign: "center",
                                        }}
                                    >
                                        <VscCircleFilled />
                                    </td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[1].color}`,
                                            textAlign: "center",
                                        }}
                                    >
                                        <VscCircleFilled />
                                    </td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[2].color}`,
                                            color: "white",

                                            textAlign: "center",
                                        }}
                                    >
                                        <VscCircleFilled />
                                    </td>
                                </tr>
                                <tr>
                                    <td id="Benefits-benefits">
                                        Earn points from hotel stays
                                    </td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[0].color}`,
                                            textAlign: "center",
                                        }}
                                    >
                                        <VscCircleFilled />
                                    </td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[1].color}`,
                                            textAlign: "center",
                                        }}
                                    >
                                        <VscCircleFilled />
                                    </td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[2].color}`,
                                            color: "white",

                                            textAlign: "center",
                                        }}
                                    >
                                        <VscCircleFilled />
                                    </td>
                                </tr>
                                <tr>
                                    <td id="Benefits-benefits">
                                        Welcome Drink
                                    </td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[0].color}`,
                                            textAlign: "center",
                                        }}
                                    >
                                        {" "}
                                        <VscCircleFilled />
                                    </td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[1].color}`,
                                            textAlign: "center",
                                        }}
                                    >
                                        <VscCircleFilled />
                                    </td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[2].color}`,
                                            color: "white",

                                            textAlign: "center",
                                        }}
                                    >
                                        <VscCircleFilled />
                                    </td>
                                </tr>

                                <tr>
                                    <td id="Benefits-benefits">
                                        Discount at Restaurant and Bar
                                    </td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[0].color}`,
                                            textAlign: "center",
                                        }}
                                    >
                                        10%
                                    </td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[1].color}`,
                                            textAlign: "center",
                                        }}
                                    >
                                        10%
                                    </td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[2].color}`,
                                            color: "white",

                                            textAlign: "center",
                                        }}
                                    >
                                        10%
                                    </td>
                                </tr>

                                <tr>
                                    <td id="Benefits-benefits">
                                        *****Discount at Vanity Spa according to
                                        tier
                                    </td>

                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[0].color}`,
                                            textAlign: "center",
                                        }}
                                    >
                                        {" "}
                                        5%
                                    </td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[1].color}`,
                                            textAlign: "center",
                                        }}
                                    >
                                        10%
                                    </td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[2].color}`,
                                            color: "white",

                                            textAlign: "center",
                                        }}
                                    >
                                        15%
                                    </td>
                                </tr>
                                <tr>
                                    <td id="Benefits-benefits">
                                        Exclusive Offers
                                    </td>

                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[0].color}`,
                                            textAlign: "center",
                                        }}
                                    >
                                        {" "}
                                        <VscCircleFilled />
                                    </td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[1].color}`,
                                            textAlign: "center",
                                        }}
                                    >
                                        <VscCircleFilled />
                                    </td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[2].color}`,
                                            color: "white",

                                            textAlign: "center",
                                        }}
                                    >
                                        <VscCircleFilled />
                                    </td>
                                </tr>

                                <tr>
                                    <td id="Benefits-benefits">
                                        Free Bottle of Water (daily)
                                    </td>

                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[0].color}`,
                                            textAlign: "center",
                                        }}
                                    >
                                        {" "}
                                        <VscCircleFilled />
                                    </td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[1].color}`,
                                            textAlign: "center",
                                        }}
                                    >
                                        {" "}
                                        <VscCircleFilled />
                                    </td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[2].color}`,
                                            color: "white",

                                            textAlign: "center",
                                        }}
                                    >
                                        <VscCircleFilled />
                                    </td>
                                </tr>

                                <tr>
                                    <td id="Benefits-benefits">
                                        *Early Check In
                                    </td>

                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[0].color}`,
                                            textAlign: "center",
                                        }}
                                    ></td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[1].color}`,
                                            textAlign: "center",
                                        }}
                                    >
                                        {" "}
                                        <VscCircleFilled />
                                    </td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[2].color}`,
                                            color: "white",

                                            textAlign: "center",
                                        }}
                                    >
                                        <VscCircleFilled />
                                    </td>
                                </tr>

                                <tr>
                                    <td id="Benefits-benefits">
                                        *Late Check Out
                                    </td>

                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[0].color}`,
                                            textAlign: "center",
                                        }}
                                    ></td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[1].color}`,
                                            textAlign: "center",
                                        }}
                                    >
                                        {" "}
                                        <VscCircleFilled />
                                    </td>

                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[2].color}`,
                                            color: "white",

                                            color: "white",
                                            textAlign: "center",
                                        }}
                                    >
                                        <VscCircleFilled />
                                    </td>
                                </tr>
                                <tr>
                                    <td id="Benefits-benefits">
                                        **Airport Transfer Discount
                                    </td>

                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[0].color}`,
                                            textAlign: "center",
                                        }}
                                    ></td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[1].color}`,
                                            textAlign: "center",
                                        }}
                                    >
                                        {" "}
                                        <VscCircleFilled />
                                    </td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[2].color}`,
                                            color: "white",

                                            textAlign: "center",
                                        }}
                                    >
                                        <VscCircleFilled />
                                    </td>
                                </tr>
                                <tr>
                                    <td id="Benefits-benefits">
                                        No Room Service Charges
                                    </td>

                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[0].color}`,
                                            textAlign: "center",
                                        }}
                                    ></td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[1].color}`,
                                            textAlign: "center",
                                        }}
                                    >
                                        {" "}
                                        <VscCircleFilled />
                                    </td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[2].color}`,
                                            color: "white",

                                            textAlign: "center",
                                        }}
                                    >
                                        <VscCircleFilled />
                                    </td>
                                </tr>
                                <tr>
                                    <td id="Benefits-benefits">
                                        Complimentary Cocktail (once per stay)
                                    </td>

                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[0].color}`,
                                            textAlign: "center",
                                        }}
                                    ></td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[1].color}`,
                                            textAlign: "center",
                                        }}
                                    >
                                        {" "}
                                        <VscCircleFilled />
                                    </td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[2].color}`,
                                            color: "white",

                                            textAlign: "center",
                                        }}
                                    >
                                        <VscCircleFilled />
                                    </td>
                                </tr>
                                <tr>
                                    <td id="Benefits-benefits">
                                        ***Discount in Laundry Service
                                    </td>

                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[0].color}`,
                                            textAlign: "center",
                                        }}
                                    ></td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[1].color}`,
                                            textAlign: "center",
                                        }}
                                    >
                                        {" "}
                                        <VscCircleFilled />
                                    </td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[2].color}`,
                                            color: "white",

                                            textAlign: "center",
                                        }}
                                    >
                                        <VscCircleFilled />
                                    </td>
                                </tr>
                                <tr>
                                    <td id="Benefits-benefits">
                                        *Free Access in Spa (hammam & sauna)
                                    </td>

                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[0].color}`,
                                            textAlign: "center",
                                        }}
                                    ></td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[1].color}`,
                                            textAlign: "center",
                                        }}
                                    >
                                        {" "}
                                        <VscCircleFilled />
                                    </td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[2].color}`,
                                            color: "white",

                                            textAlign: "center",
                                        }}
                                    >
                                        <VscCircleFilled />
                                    </td>
                                </tr>
                                <tr>
                                    <td
                                        id="Benefits-benefits"
                                        className=" font-bold"
                                    >
                                        Turn down Service (evening)
                                    </td>

                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[0].color}`,
                                            textAlign: "center",
                                        }}
                                    ></td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[1].color}`,
                                            textAlign: "center",
                                        }}
                                    >
                                        {" "}
                                        <VscCircleFilled />
                                    </td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[2].color}`,
                                            color: "white",

                                            textAlign: "center",
                                        }}
                                    >
                                        <VscCircleFilled />
                                    </td>
                                </tr>
                                <tr>
                                    <td id="Benefits-benefits">
                                        ****Free Room Upgrade
                                    </td>

                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[0].color}`,
                                            textAlign: "center",
                                        }}
                                    ></td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[1].color}`,
                                            textAlign: "center",
                                        }}
                                    ></td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[2].color}`,
                                            color: "white",

                                            textAlign: "center",
                                        }}
                                    >
                                        <VscCircleFilled />
                                    </td>
                                </tr>
                                <tr>
                                    <td id="Benefits-benefits">
                                        Special Amenities
                                    </td>

                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[0].color}`,
                                            textAlign: "center",
                                        }}
                                    ></td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[1].color}`,
                                            textAlign: "center",
                                        }}
                                    ></td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[2].color}`,
                                            color: "white",

                                            textAlign: "center",
                                        }}
                                    >
                                        <VscCircleFilled />
                                    </td>
                                </tr>
                                <tr>
                                    <td id="Benefits-benefits">
                                        In Room Breakfast
                                    </td>

                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[0].color}`,
                                            textAlign: "center",
                                        }}
                                    ></td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[1].color}`,
                                            textAlign: "center",
                                        }}
                                    ></td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[2].color}`,
                                            color: "white",

                                            textAlign: "center",
                                        }}
                                    >
                                        <VscCircleFilled />
                                    </td>
                                </tr>
                                <tr>
                                    <td id="Benefits-benefits">
                                        Free Mini Bar at Check in (once)
                                    </td>

                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[0].color}`,
                                            textAlign: "center",
                                        }}
                                    ></td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[1].color}`,
                                            textAlign: "center",
                                        }}
                                    ></td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[2].color}`,
                                            color: "white",

                                            textAlign: "center",
                                        }}
                                    >
                                        <VscCircleFilled />
                                    </td>
                                </tr>
                                <tr>
                                    <td id="Benefits-benefits">
                                        *Free Boat Trip
                                    </td>

                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[0].color}`,
                                            textAlign: "center",
                                        }}
                                    ></td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[1].color}`,
                                            textAlign: "center",
                                        }}
                                    ></td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[2].color}`,
                                            color: "white",

                                            textAlign: "center",
                                        }}
                                    >
                                        <VscCircleFilled />
                                    </td>
                                </tr>
                                <tr>
                                    <td id="Benefits-benefits">
                                        *Free Scuba Diving Lesson Experience
                                    </td>

                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[0].color}`,
                                            textAlign: "center",
                                        }}
                                    ></td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[1].color}`,
                                            textAlign: "center",
                                        }}
                                    ></td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[2].color}`,
                                            color: "white",

                                            textAlign: "center",
                                        }}
                                    >
                                        <VscCircleFilled />
                                    </td>
                                </tr>
                                <tr>
                                    <td id="Benefits-benefits">
                                        *Car Rental Upgrade
                                    </td>

                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[0].color}`,
                                            textAlign: "center",
                                        }}
                                    ></td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[1].color}`,
                                            textAlign: "center",
                                        }}
                                    ></td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[2].color}`,
                                            color: "white",

                                            textAlign: "center",
                                        }}
                                    >
                                        <VscCircleFilled />
                                    </td>
                                </tr>
                                <tr>
                                    <td id="Benefits-benefits">
                                        Make a friend a VIP Member
                                    </td>

                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[0].color}`,
                                            textAlign: "center",
                                        }}
                                    ></td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[1].color}`,
                                            textAlign: "center",
                                        }}
                                    ></td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[2].color}`,
                                            color: "white",

                                            textAlign: "center",
                                        }}
                                    >
                                        <VscCircleFilled />
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                        <br></br>
                        <div className="notes">
                            <span className="text-md italic note">
                                *Subject to Avaialability & pre-booking{" "}
                            </span>
                            <br></br>

                            <span className="text-md italic note">
                                **When transfer booked with us in advace for
                                Larnaca & Paphos airports
                            </span>
                            <br></br>

                            <span className="text-md italic note">
                                ***For the usage of our selected Laundry Service
                                Partners
                            </span>
                            <br></br>

                            <span className="text-md italic note">
                                ****Subject to availbility and occupancy
                            </span>
                            <br></br>

                            <span className="text-md italic note">
                                *****From selected options in spa brochure
                            </span>
                            <br></br>
                        </div>
                        <br />
                        <br />
                    </div>
                )}

                {programLabel === "53CE9A36-A9EC-4A7A-97A1-7E76FCFF27F5" && (
                    <div className="Benefits-tableContainer-Parent">
                        <table className="Benefits-tableContainer">
                            <thead></thead>
                            <tbody>
                                <tr className="Benefits-headings">
                                    <td
                                        id="Benefits-Tier"
                                        style={{
                                            fontWeight: "600",
                                            textAlign: "center",
                                        }}
                                    >
                                        Benefits
                                    </td>

                                    <td
                                        id="Benefits-Tier"
                                        style={{
                                            background: `${tiers[0].color}`,

                                            fontWeight: "600",
                                            textAlign: "center",
                                            color: "white",
                                        }}
                                    >
                                        Member{" "}
                                    </td>
                                    <td
                                        id="Benefits-Tier"
                                        style={{
                                            background: `${tiers[1].color}`,

                                            fontWeight: "600",
                                            textAlign: "center",
                                            color: "white",
                                        }}
                                    >
                                        Local{" "}
                                    </td>
                                    <td
                                        id="Benefits-Tier"
                                        style={{
                                            background: `${tiers[2].color}`,

                                            fontWeight: "600",
                                            textAlign: "center",
                                            color: "white",
                                        }}
                                    >
                                        Friend{" "}
                                    </td>
                                    <td
                                        id="Benefits-Tier"
                                        style={{
                                            background: `${tiers[3].color}`,
                                            fontWeight: "600",
                                            textAlign: "center",
                                            color: "white",
                                        }}
                                    >
                                        Family{" "}
                                    </td>
                                </tr>

                                <tr>
                                    <td id="Benefits-benefits">
                                        Discount on direct bookings
                                    </td>

                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[0].color}`,
                                            textAlign: "center",
                                            color: "white",
                                        }}
                                    >
                                        10%{" "}
                                    </td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[1].color}`,
                                            textAlign: "center",
                                            color: "white",
                                        }}
                                    >
                                        10%{" "}
                                    </td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[2].color}`,
                                            textAlign: "center",
                                            color: "white",
                                        }}
                                    >
                                        12%{" "}
                                    </td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[3].color}`,
                                            textAlign: "center",
                                            color: "white",
                                        }}
                                    >
                                        15%{" "}
                                    </td>
                                </tr>
                                <tr>
                                    <td id="Benefits-benefits">
                                        Early check-in (on request, upon
                                        availability)
                                    </td>

                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[0].color}`,
                                            textAlign: "center",
                                        }}
                                    >
                                        <AlianthosW />
                                    </td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[1].color}`,
                                            textAlign: "center",
                                        }}
                                    >
                                        <AlianthosW />
                                    </td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[2].color}`,
                                            textAlign: "center",
                                        }}
                                    >
                                        <AlianthosW />
                                    </td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[3].color}`,
                                            textAlign: "center",
                                            color: "white",
                                        }}
                                    >
                                        <AlianthosW />
                                    </td>
                                </tr>
                                <tr>
                                    <td id="Benefits-benefits">
                                        Exclusive members-only offers
                                    </td>

                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[0].color}`,
                                            textAlign: "center",
                                        }}
                                    >
                                        <AlianthosW />
                                    </td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[1].color}`,
                                            textAlign: "center",
                                        }}
                                    >
                                        <AlianthosW />
                                    </td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[2].color}`,
                                            textAlign: "center",
                                        }}
                                    >
                                        <AlianthosW />
                                    </td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[3].color}`,
                                            textAlign: "center",
                                            color: "white",
                                        }}
                                    >
                                        <AlianthosW />
                                    </td>
                                </tr>

                                <tr>
                                    <td id="Benefits-benefits">
                                        Discounts at partner businesses
                                    </td>

                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[0].color}`,
                                            textAlign: "center",
                                        }}
                                    >
                                        {" "}
                                        <AlianthosW />
                                    </td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[1].color}`,
                                            textAlign: "center",
                                        }}
                                    >
                                        {" "}
                                        <AlianthosW />
                                    </td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[2].color}`,
                                            textAlign: "center",
                                        }}
                                    >
                                        <AlianthosW />
                                    </td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[3].color}`,
                                            textAlign: "center",
                                            color: "white",
                                        }}
                                    >
                                        <AlianthosW />
                                    </td>
                                </tr>
                                <tr>
                                    <td id="Benefits-benefits">
                                        Personal Advisor Long Time Αppointment
                                    </td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[0].color}`,
                                            textAlign: "center",
                                        }}
                                    ></td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[1].color}`,
                                            textAlign: "center",
                                        }}
                                    >
                                        <AlianthosW />
                                    </td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[2].color}`,
                                            textAlign: "center",
                                        }}
                                    >
                                        <AlianthosW />
                                    </td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[3].color}`,
                                            textAlign: "center",
                                            color: "white",
                                        }}
                                    >
                                        <AlianthosW />
                                    </td>
                                </tr>
                                <tr>
                                    <td id="Benefits-benefits">
                                        Complimentary cocktail
                                    </td>

                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[0].color}`,
                                            textAlign: "center",
                                        }}
                                    ></td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[1].color}`,
                                            textAlign: "center",
                                        }}
                                    >
                                        <AlianthosW />
                                    </td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[2].color}`,
                                            textAlign: "center",
                                        }}
                                    >
                                        <AlianthosW />
                                    </td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[3].color}`,
                                            textAlign: "center",
                                            color: "white",
                                        }}
                                    >
                                        <AlianthosW />
                                    </td>
                                </tr>

                                <tr>
                                    <td id="Benefits-benefits">
                                        Farewell gift
                                    </td>

                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[0].color}`,
                                            textAlign: "center",
                                        }}
                                    ></td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[1].color}`,
                                            textAlign: "center",
                                        }}
                                    >
                                        <AlianthosW />
                                    </td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[2].color}`,
                                            textAlign: "center",
                                        }}
                                    >
                                        <AlianthosW />
                                    </td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[3].color}`,
                                            textAlign: "center",
                                            color: "white",
                                        }}
                                    >
                                        <AlianthosW />
                                    </td>
                                </tr>
                                <tr>
                                    <td id="Benefits-benefits">
                                        One complimentary Lunch - one per person
                                    </td>

                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[0].color}`,
                                            textAlign: "center",
                                        }}
                                    ></td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[1].color}`,
                                            textAlign: "center",
                                        }}
                                    ></td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[2].color}`,
                                            textAlign: "center",
                                        }}
                                    >
                                        <AlianthosW />
                                    </td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[3].color}`,
                                            textAlign: "center",
                                            color: "white",
                                        }}
                                    >
                                        <AlianthosW />
                                    </td>
                                </tr>
                                {/* <tr>
                <td id='Benefits-benefits'>Special Welcome Treat</td>

                <td
                  id='Benefits-benefits'
                  style={{
                   background: `${tiers[0].color}`,
                    textAlign: 'center',
                  }}></td>
                <td
                  id='Benefits-benefits'
                  style={{
                   background: `${tiers[1].color}`,
                    textAlign: 'center',
                  }}>                  
</td>
                <td
                  id='Benefits-benefits'
                  style={{
                   background: `${tiers[2].color}`,
                    textAlign: 'center',
                  }}>
                  <AlianthosW />
                </td>
                <td
                  id='Benefits-benefits'
                  style={{
                   background: `${tiers[3].color}`,
                    textAlign: 'center',                    color:'white'

                  }}>
                  <AlianthosW />
                </td>
              </tr> */}
                                <tr>
                                    <td id="Benefits-benefits">
                                        Best room available (in booked category,
                                        upon availability)
                                    </td>

                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[0].color}`,
                                            textAlign: "center",
                                        }}
                                    ></td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[1].color}`,
                                            textAlign: "center",
                                        }}
                                    ></td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[2].color}`,
                                            textAlign: "center",
                                        }}
                                    >
                                        <AlianthosW />
                                    </td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[3].color}`,
                                            textAlign: "center",
                                            color: "white",
                                        }}
                                    >
                                        <AlianthosW />
                                    </td>
                                </tr>
                                <tr>
                                    <td id="Benefits-benefits">
                                        Complimentary stay
                                    </td>

                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[0].color}`,
                                            textAlign: "center",
                                        }}
                                    ></td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[1].color}`,
                                            textAlign: "center",
                                        }}
                                    ></td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[2].color}`,
                                            textAlign: "center",
                                        }}
                                    >
                                        <AlianthosW />
                                    </td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[3].color}`,
                                            textAlign: "center",
                                            color: "white",
                                        }}
                                    >
                                        <AlianthosW />
                                    </td>
                                </tr>

                                <tr>
                                    <td id="Benefits-benefits">
                                        Discount in Hotel restaurant & bar
                                    </td>

                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[0].color}`,
                                            textAlign: "center",
                                        }}
                                    ></td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[1].color}`,
                                            textAlign: "center",
                                        }}
                                    ></td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[2].color}`,
                                            textAlign: "center",
                                        }}
                                    >
                                        {" "}
                                    </td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[3].color}`,
                                            textAlign: "center",
                                            color: "white",
                                        }}
                                    >
                                        <AlianthosW />
                                    </td>
                                </tr>
                                <tr>
                                    <td id="Benefits-benefits">
                                        Tailor your stay (on request, upon
                                        availability)
                                    </td>

                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[0].color}`,
                                            textAlign: "center",
                                        }}
                                    ></td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[1].color}`,
                                            textAlign: "center",
                                        }}
                                    ></td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[2].color}`,
                                            textAlign: "center",
                                        }}
                                    ></td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[3].color}`,
                                            textAlign: "center",
                                            color: "white",
                                        }}
                                    >
                                        <AlianthosW />
                                    </td>
                                </tr>
                                <tr>
                                    <td id="Benefits-benefits">
                                        Late check-out (on request, upon
                                        availability)
                                    </td>

                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[0].color}`,
                                            textAlign: "center",
                                        }}
                                    ></td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[1].color}`,
                                            textAlign: "center",
                                        }}
                                    ></td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[2].color}`,
                                            textAlign: "center",
                                        }}
                                    ></td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[3].color}`,
                                            textAlign: "center",
                                            color: "white",
                                        }}
                                    >
                                        <AlianthosW />
                                    </td>
                                </tr>
                                <tr>
                                    <td id="Benefits-benefits">
                                        Afternoon housekeeping (on request)
                                    </td>

                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[0].color}`,
                                            textAlign: "center",
                                        }}
                                    ></td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[1].color}`,
                                            textAlign: "center",
                                        }}
                                    ></td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[2].color}`,
                                            textAlign: "center",
                                        }}
                                    ></td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[3].color}`,
                                            textAlign: "center",
                                            color: "white",
                                        }}
                                    >
                                        <AlianthosW />
                                    </td>
                                </tr>
                                <tr>
                                    <td id="Benefits-benefits">
                                        Room upgrade (on request, upon
                                        availability)
                                    </td>

                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[0].color}`,
                                            textAlign: "center",
                                        }}
                                    ></td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[1].color}`,
                                            textAlign: "center",
                                        }}
                                    ></td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[2].color}`,
                                            textAlign: "center",
                                        }}
                                    ></td>
                                    <td
                                        id="Benefits-benefits"
                                        style={{
                                            background: `${tiers[3].color}`,
                                            textAlign: "center",
                                            color: "white",
                                        }}
                                    >
                                        <AlianthosW />
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                        <br></br>
                        <br></br>
                    </div>
                )}

                {programLabel === "9CBD7717-07C3-4C3E-90B4-6FD3DBF8A8BD" && (
                    <div className="Benefits-tableContainer-Parent">
                        {/* <div className="p-4">
      <div className="flex gap-4 mb-4">
        {Object.keys(Marbbenefits).map((category) => (
          <button
            key={category}
            className={` py-2 rounded `}
            style={{ backgroundColor: visibleCategory === category ? "#002FB3" : "lightgray", color:visibleCategory === category? "white" : "black"}}
            onClick={() => setVisibleCategory(category)}
          >
            {category}
          </button>
        ))}
        <button
            style={{ backgroundColor: visibleCategory === "All" ? "#002FB3" : "lightgray", color:visibleCategory === "All"? "white" : "black"}}
            onClick={() => setVisibleCategory("All")}
        >
          Show All
        </button>
      </div> */}
                        <table className="Benefits-tableContainer">
                            <thead>
                                <tr className="Benefits-headings bg-[#ECE2ED]">
                                    <th
                                        className=" p-2"
                                        style={{ backgroundColor: "#ece2ed" }}
                                    >
                                        Loyalty Benefits
                                    </th>
                                    {MarbtierColors.map((color, index) => (
                                        <th
                                            key={index}
                                            style={{
                                                backgroundColor: color,
                                                color:
                                                    index < 2
                                                        ? "black"
                                                        : "white",
                                            }}
                                        >
                                            {
                                                [
                                                    "Cyan",
                                                    "Azure",
                                                    "Indigo",
                                                    "Sapphire",
                                                ][index]
                                            }
                                        </th>
                                    ))}
                                </tr>
                            </thead>
                            <tbody>
                                {Object.entries(Marbbenefits).map(
                                    ([category, rows]) =>
                                        rows.map((row, rowIndex) => (
                                            <tr key={`${category}-${rowIndex}`}>
                                                {row.map((cell, cellIndex) => (
                                                    <td
                                                        key={cellIndex}
                                                        style={{
                                                            backgroundColor:
                                                                cellIndex > 0
                                                                    ? MarbtierColors[
                                                                          cellIndex -
                                                                              1
                                                                      ]
                                                                    : "#ece2ed",
                                                            color:
                                                                cellIndex < 3
                                                                    ? "black"
                                                                    : "white",
                                                        }}
                                                    >
                                                        {cell}
                                                    </td>
                                                ))}
                                            </tr>
                                        )),
                                )}
                            </tbody>
                        </table>
                        <p
                            className=""
                            style={{
                                backgroundColor: "rgb(236, 226, 237)",
                            }}
                        >
                            * upon availability <br></br>
                            ** the number of complimentary à la carte dinners is
                            adjusted according to the length of your stay
                            (beverages are not included) <br></br>
                            *** for a minimum of 7 nights <br></br>
                            **** available only on Premium All Inclusive{" "}
                        </p>
                    </div>
                )}

                {programLabel === "F4B248B8-9F5B-4B23-8EA8-7BF17283A567" && (
                    <div className="Benefits-tableContainer-Parent">
                        <table className="Benefits-tableContainer">
                            <thead>
                                <tr className="Benefits-headings bg-[#ECE2ED]">
                                    <th
                                        className=" p-2"
                                        style={{ backgroundColor: "#ece2ed" }}
                                    >
                                        Loyalty Benefits
                                    </th>
                                    {FlmngtierColors.map((color, index) => (
                                        <th
                                            key={index}
                                            style={{
                                                backgroundColor: color,
                                                color:
                                                    index < 2
                                                        ? "black"
                                                        : "white",
                                            }}
                                        >
                                            {["White", "Blue", "Pink"][index]}
                                        </th>
                                    ))}
                                </tr>
                            </thead>
                            <tbody>
                                {Object.entries(Flmngbenefits).map(
                                    ([category, rows]) =>
                                        rows.map((row, rowIndex) => (
                                            <tr key={`${category}-${rowIndex}`}>
                                                {row.map((cell, cellIndex) => (
                                                    <td
                                                        key={cellIndex}
                                                        style={{
                                                            backgroundColor:
                                                                cellIndex > 0
                                                                    ? FlmngtierColors[
                                                                          cellIndex -
                                                                              1
                                                                      ]
                                                                    : "#ece2ed",
                                                            color:
                                                                cellIndex < 3
                                                                    ? "black"
                                                                    : "white",
                                                        }}
                                                    >
                                                        {cell}
                                                    </td>
                                                ))}
                                            </tr>
                                        )),
                                )}
                            </tbody>
                        </table>
                        {/*<p className='' style={{*/}
                        {/*    backgroundColor: 'rgb(236, 226, 237)'*/}
                        {/*}}>* upon availability <br></br>*/}
                        {/*    ** the number of complimentary à la carte dinners is adjusted  according to the length of your stay  <br></br>*/}
                        {/*    *** for min 7 nights stay  </p>*/}
                    </div>
                )}

                {/*anatolia*/}
                {programLabel === "320BE49F-9989-4750-A55F-FE5597F6BB17" && (
                    <div className="Benefits-tableContainer-Parent">
                        <table className="Benefits-tableContainer">
                            <thead>
                                <tr className="Benefits-headings bg-[#ffffff]">
                                    <th
                                        className=" p-2"
                                        style={{ backgroundColor: "#ffffff" }}
                                    >
                                        Benefits
                                    </th>
                                    {AnatoliatierColors.map((color, index) => (
                                        <th
                                            key={index}
                                            style={{
                                                backgroundColor: color,
                                                color:
                                                    index < 2
                                                        ? "black"
                                                        : "white",
                                            }}
                                        >
                                            {
                                                [
                                                    "Backpack",
                                                    "Travelbag",
                                                    "Luggage",
                                                ][index]
                                            }
                                        </th>
                                    ))}
                                </tr>
                            </thead>
                            <tbody>
                                {Object.entries(Anatoliabenefits).map(
                                    ([category, rows]) =>
                                        rows.map((row, rowIndex) => (
                                            <tr key={`${category}-${rowIndex}`}>
                                                {row.map((cell, cellIndex) => (
                                                    <td
                                                        key={cellIndex}
                                                        style={{
                                                            backgroundColor:
                                                                cellIndex > 0
                                                                    ? AnatoliatierColors[
                                                                          cellIndex -
                                                                              1
                                                                      ]
                                                                    : "#ffffff",
                                                            color:
                                                                cellIndex < 3
                                                                    ? "black"
                                                                    : "white",
                                                        }}
                                                    >
                                                        {cell}
                                                    </td>
                                                ))}
                                            </tr>
                                        )),
                                )}
                            </tbody>
                        </table>
                        <p
                            className=""
                            style={{
                                backgroundColor: "rgb(236, 226, 237)",
                            }}
                        >
                            * upon availability <br></br>
                            {/*    ** the number of complimentary à la carte dinners is adjusted  according to the length of your stay  <br></br>*/}
                            {/*    *** for min 7 nights stay  </p>*/}
                        </p>
                    </div>
                )}

                {/*louis*/}
                {programLabel === "1677A350-B638-4323-AA59-4F198482D63B" && (
                    <div className="Benefits-tableContainer-Parent">
                        <table className="Benefits-tableContainer">
                            <thead>
                                <tr className="Benefits-headings bg-[#ffffff]">
                                    <th
                                        className=" p-2"
                                        style={{ backgroundColor: "#ffffff" }}
                                    >
                                        Benefits
                                    </th>
                                    {LouistierColors.map((color, index) => (
                                        <th
                                            key={index}
                                            style={{
                                                backgroundColor: color,
                                                color:
                                                    index < 2
                                                        ? "black"
                                                        : "white",
                                            }}
                                        >
                                            {
                                                [
                                                    "Bronze",
                                                    "Silver",
                                                    "Gold",
                                                    "Diamond",
                                                ][index]
                                            }
                                        </th>
                                    ))}
                                </tr>
                            </thead>
                            <tbody>
                                {Object.entries(Louisbenefits).map(
                                    ([category, rows]) =>
                                        rows.map((row, rowIndex) => (
                                            <tr key={`${category}-${rowIndex}`}>
                                                {row.map((cell, cellIndex) => (
                                                    <td
                                                        key={cellIndex}
                                                        style={{
                                                            backgroundColor:
                                                                cellIndex > 0
                                                                    ? LouistierColors[
                                                                          cellIndex -
                                                                              1
                                                                      ]
                                                                    : "#ffffff",
                                                            color:
                                                                cellIndex < 3
                                                                    ? "black"
                                                                    : "white",
                                                        }}
                                                    >
                                                        {cell}
                                                    </td>
                                                ))}
                                            </tr>
                                        )),
                                )}
                            </tbody>
                        </table>
                        <p
                            className=""
                            style={{
                                backgroundColor: "rgb(236, 226, 237)",
                            }}
                        >
                            * subject to availability <br></br>
                            ** once per stay / minimum stay 3 nights <br></br>
                            *** For direct bookings: Earn 10 points for every
                            euro (€) spent.<br></br>
                            For indirect bookings: Please refer to the seperate
                            tables available on the website.
                        </p>
                    </div>
                )}

                {/*fzeen*/}
                {programLabel === "9F3C2A7E-6B84-4D1F-A5C9-2E7180B43D6A" && (
                    <div className="Benefits-tableContainer-Parent">
                        <table className="Benefits-tableContainer">
                            <thead>
                                <tr className="Benefits-headings bg-[#ffffff]">
                                    <th
                                        className=" p-2"
                                        style={{ backgroundColor: "#ffffff" }}
                                    >
                                        Benefits
                                    </th>
                                    {FzeenColors.map((color, index) => (
                                        <th
                                            key={index}
                                            style={{
                                                backgroundColor: color,
                                                color: "black",
                                            }}
                                        >
                                            {
                                                [
                                                    "Bronze (0 points)",
                                                    "Silver (50,000 points)",
                                                    "Gold (250,000 points)",
                                                    "Platinum (460,000 points)",
                                                ][index]
                                            }
                                        </th>
                                    ))}
                                </tr>
                            </thead>
                            <tbody>
                                {Object.entries(Fzeenbenefits).map(
                                    ([category, rows]) =>
                                        rows.map((row, rowIndex) => (
                                            <tr key={`${category}-${rowIndex}`}>
                                                {row.map((cell, cellIndex) => (
                                                    <td
                                                        key={cellIndex}
                                                        style={{
                                                            backgroundColor:
                                                                cellIndex > 0
                                                                    ? FzeenColors[
                                                                          cellIndex -
                                                                              1
                                                                      ]
                                                                    : "#ffffff",
                                                            color: "black",
                                                        }}
                                                    >
                                                        {cell}
                                                    </td>
                                                ))}
                                            </tr>
                                        )),
                                )}
                            </tbody>
                        </table>
                    </div>
                )}

                {/*ella*/}
                {programLabel === "93DEED15-0327-49CA-98DA-8A4AAC84A4E6" && (
                    <div className="Benefits-tableContainer-Parent">
                        <table className="Benefits-tableContainer">
                            <thead>
                                <tr className="Benefits-headings bg-[#ffffff]">
                                    <th
                                        className=" p-2"
                                        style={{ backgroundColor: "#ffffff" }}
                                    >
                                        Benefits
                                    </th>
                                    {EllatierColors.map((color, index) => (
                                        <th
                                            key={index}
                                            style={{
                                                backgroundColor: color,
                                                color:
                                                    index < 2
                                                        ? "black"
                                                        : "white",
                                            }}
                                        >
                                            {
                                                [
                                                    "Expedition",
                                                    "Journey",
                                                    "Quest",
                                                    "Legacy",
                                                ][index]
                                            }
                                        </th>
                                    ))}
                                </tr>
                            </thead>
                            <tbody>
                                {Object.entries(Ellabenefits).map(
                                    ([category, rows]) =>
                                        rows.map((row, rowIndex) => (
                                            <tr key={`${category}-${rowIndex}`}>
                                                {row.map((cell, cellIndex) => (
                                                    <td
                                                        key={cellIndex}
                                                        style={{
                                                            backgroundColor:
                                                                cellIndex > 0
                                                                    ? EllatierColors[
                                                                          cellIndex -
                                                                              1
                                                                      ]
                                                                    : "#ffffff",
                                                            color:
                                                                cellIndex < 3
                                                                    ? "black"
                                                                    : "white",
                                                        }}
                                                    >
                                                        {cell}
                                                    </td>
                                                ))}
                                            </tr>
                                        )),
                                )}
                            </tbody>
                        </table>
                    </div>
                )}

                {programLabel === "1767F481-20F5-4E3B-9877-4D564FD033CB" && (
                    <div className="Benefits-tableContainer-Parent">
                        <table className="Benefits-tableContainer">
                            <thead>
                                <tr className="Benefits-headings bg-[#ECE2ED]">
                                    <th
                                        className=" p-2"
                                        style={{ backgroundColor: "#ece2ed" }}
                                    >
                                        Benefits
                                    </th>
                                    {PillowtierColors.map((color, index) => (
                                        <th
                                            key={index}
                                            style={{
                                                backgroundColor: color,
                                                color:
                                                    index < 2
                                                        ? "black"
                                                        : "white",
                                            }}
                                        >
                                            {
                                                [
                                                    "Silver",
                                                    "Gold",
                                                    "Platinum",
                                                    "Platinum for life",
                                                ][index]
                                            }
                                        </th>
                                    ))}
                                </tr>
                            </thead>
                            <tbody>
                                {Object.entries(Pillowbenefits).map(
                                    ([category, rows]) =>
                                        rows.map((row, rowIndex) => (
                                            <tr key={`${category}-${rowIndex}`}>
                                                {row.map((cell, cellIndex) => (
                                                    <td
                                                        key={cellIndex}
                                                        style={{
                                                            backgroundColor:
                                                                cellIndex > 0
                                                                    ? PillowtierColors[
                                                                          cellIndex -
                                                                              1
                                                                      ]
                                                                    : "#ece2ed",
                                                            color:
                                                                cellIndex < 3
                                                                    ? "black"
                                                                    : "white",
                                                        }}
                                                    >
                                                        {cell}
                                                    </td>
                                                ))}
                                            </tr>
                                        )),
                                )}
                            </tbody>
                        </table>
                        {/*<p className='' style={{*/}
                        {/*    backgroundColor: 'rgb(236, 226, 237)'*/}
                        {/*}}>* upon availability <br></br>*/}
                        {/*    ** the number of complimentary à la carte dinners is adjusted  according to the length of your stay  <br></br>*/}
                        {/*    *** for min 7 nights stay  </p>*/}
                    </div>
                )}

                {programLabel ===
                    "LEPTOS-A3A66E19-00F4-47AF-9303-850AB8413EDC" && (
                    <div className="Benefits-tableContainer-Parent">
                        <table className="Benefits-tableContainer">
                            <thead>
                                <tr className="Benefits-headings bg-[#ECE2ED]">
                                    <th
                                        className=" p-2"
                                        style={{ backgroundColor: "#ece2ed" }}
                                    >
                                        Benefits
                                    </th>
                                    {LeptostierColors.map((color, index) => (
                                        <th
                                            key={index}
                                            style={{
                                                backgroundColor: color,
                                                color:
                                                    index < 2
                                                        ? "black"
                                                        : "white",
                                            }}
                                        >
                                            {
                                                ["Gold", "Platinum", "Diamond"][
                                                    index
                                                ]
                                            }
                                        </th>
                                    ))}
                                </tr>
                            </thead>
                            <tbody>
                                {Object.entries(Leptosbenefits).map(
                                    ([category, rows]) =>
                                        rows.map((row, rowIndex) => (
                                            <tr key={`${category}-${rowIndex}`}>
                                                {row.map((cell, cellIndex) => (
                                                    <td
                                                        key={cellIndex}
                                                        style={{
                                                            backgroundColor:
                                                                cellIndex > 0
                                                                    ? LeptostierColors[
                                                                          cellIndex -
                                                                              1
                                                                      ]
                                                                    : "#ece2ed",
                                                            color:
                                                                cellIndex < 3
                                                                    ? "black"
                                                                    : "white",
                                                        }}
                                                    >
                                                        {cell}
                                                    </td>
                                                ))}
                                            </tr>
                                        )),
                                )}
                            </tbody>
                        </table>
                        {/*<p className='' style={{*/}
                        {/*    backgroundColor: 'rgb(236, 226, 237)'*/}
                        {/*}}>* upon availability <br></br>*/}
                        {/*    ** the number of complimentary à la carte dinners is adjusted  according to the length of your stay  <br></br>*/}
                        {/*    *** for min 7 nights stay  </p>*/}
                    </div>
                )}

                {programLabel ===
                    "STR-E6EA5920-0DA2-4C53-8098-8F28EB81C228" && (
                    <div className="Benefits-tableContainer-Parent">
                        <table className="Benefits-tableContainer">
                            <thead>
                                <tr className="Benefits-headings">
                                    <th
                                        style={{
                                            fontWeight: "600",
                                            textAlign: "center",
                                            width: "40%",
                                        }}
                                    >
                                        Benefits
                                    </th>
                                    <th
                                        style={{
                                            background: `${tiers[0].color}`,
                                            fontWeight: "600",
                                            textAlign: "center",
                                        }}
                                    >
                                        Silver
                                    </th>
                                    <th
                                        style={{
                                            background: `${tiers[1].color}`,
                                            fontWeight: "600",
                                            textAlign: "center",
                                        }}
                                    >
                                        Gold
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td id="Benefits-benefits">
                                        Discount on rates (automatically applied
                                        upon registration)
                                    </td>
                                    <td
                                        style={{
                                            background: `${tiers[0].color}`,
                                            textAlign: "center",
                                        }}
                                    >
                                        10%
                                    </td>
                                    <td
                                        style={{
                                            background: `${tiers[1].color}`,
                                            textAlign: "center",
                                        }}
                                    >
                                        12.5%
                                    </td>
                                </tr>
                                <tr>
                                    <td id="Benefits-benefits">
                                        Exclusive offers for members only
                                    </td>
                                    <td
                                        style={{
                                            background: `${tiers[0].color}`,
                                            textAlign: "center",
                                        }}
                                    >
                                        <VscCircleFilled />
                                    </td>
                                    <td
                                        style={{
                                            background: `${tiers[1].color}`,
                                            textAlign: "center",
                                        }}
                                    >
                                        <VscCircleFilled />
                                    </td>
                                </tr>
                                <tr>
                                    <td id="Benefits-benefits">
                                        Discount on Spa Treatments
                                    </td>
                                    <td
                                        style={{
                                            background: `${tiers[0].color}`,
                                            textAlign: "center",
                                        }}
                                    >
                                        10%
                                    </td>
                                    <td
                                        style={{
                                            background: `${tiers[1].color}`,
                                            textAlign: "center",
                                        }}
                                    >
                                        20%
                                    </td>
                                </tr>
                                <tr>
                                    <td id="Benefits-benefits">
                                        Welcome Drink
                                    </td>
                                    <td
                                        style={{
                                            background: `${tiers[0].color}`,
                                            textAlign: "center",
                                        }}
                                    >
                                        <VscCircleFilled />
                                    </td>
                                    <td
                                        style={{
                                            background: `${tiers[1].color}`,
                                            textAlign: "center",
                                        }}
                                    >
                                        <VscCircleFilled />
                                    </td>
                                </tr>
                                <tr>
                                    <td id="Benefits-benefits">
                                        Early check-in & late check-out (upon
                                        availability)
                                    </td>
                                    <td
                                        style={{
                                            background: `${tiers[0].color}`,
                                            textAlign: "center",
                                        }}
                                    >
                                        <VscCircleFilled />
                                    </td>
                                    <td
                                        style={{
                                            background: `${tiers[1].color}`,
                                            textAlign: "center",
                                        }}
                                    >
                                        <VscCircleFilled />
                                    </td>
                                </tr>
                                <tr>
                                    <td id="Benefits-benefits">
                                        Discount in the a la carte restaurants /
                                        bars
                                    </td>
                                    <td
                                        style={{
                                            background: `${tiers[0].color}`,
                                            textAlign: "center",
                                        }}
                                    >
                                        10%
                                    </td>
                                    <td
                                        style={{
                                            background: `${tiers[1].color}`,
                                            textAlign: "center",
                                        }}
                                    >
                                        20%
                                    </td>
                                </tr>
                                <tr>
                                    <td id="Benefits-benefits">
                                        Complimentary cocktail on Captain’s
                                        Terrace
                                    </td>
                                    <td
                                        style={{
                                            background: `${tiers[0].color}`,
                                            textAlign: "center",
                                        }}
                                    ></td>
                                    <td
                                        style={{
                                            background: `${tiers[1].color}`,
                                            textAlign: "center",
                                        }}
                                    >
                                        <VscCircleFilled />
                                    </td>
                                </tr>
                                <tr>
                                    <td id="Benefits-benefits">
                                        A bottle of local wine and fruit platter
                                        in the room upon arrival
                                    </td>
                                    <td
                                        style={{
                                            background: `${tiers[0].color}`,
                                            textAlign: "center",
                                        }}
                                    ></td>
                                    <td
                                        style={{
                                            background: `${tiers[1].color}`,
                                            textAlign: "center",
                                        }}
                                    >
                                        <VscCircleFilled />
                                    </td>
                                </tr>
                            </tbody>
                        </table>

                        <br />

                        <br />
                    </div>
                )}
                {programLabel === "EF395EDA-A887-4FC8-8FCF-E42AB9B4603C" && (
                    <div className="Benefits-tableContainer-Parent">
                        <table className="Benefits-tableContainer">
                            <thead>
                                <tr className="Benefits-headings">
                                    <th
                                        style={{
                                            fontWeight: "600",
                                            textAlign: "center",
                                            width: "40%",
                                        }}
                                    >
                                        Benefits
                                    </th>
                                    <th
                                        style={{
                                            background: `${tiers[0].color}`,
                                            fontWeight: "600",
                                            textAlign: "center",
                                        }}
                                    >
                                        Silver
                                    </th>
                                    <th
                                        style={{
                                            background: `${tiers[1].color}`,
                                            fontWeight: "600",
                                            textAlign: "center",
                                        }}
                                    >
                                        Gold
                                    </th>
                                    <th
                                        style={{
                                            background: `${tiers[2].color}`,
                                            fontWeight: "600",
                                            textAlign: "center",
                                        }}
                                    >
                                        Diamond
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td id="Benefits-benefits">
                                        Discount on reservations.
                                    </td>
                                    <td
                                        style={{
                                            background: `${tiers[0].color}`,
                                            textAlign: "center",
                                        }}
                                    >
                                        7%
                                    </td>
                                    <td
                                        style={{
                                            background: `${tiers[1].color}`,
                                            textAlign: "center",
                                        }}
                                    >
                                        10%
                                    </td>
                                    <th
                                        style={{
                                            background: `${tiers[2].color}`,
                                            fontWeight: "600",
                                            textAlign: "center",
                                        }}
                                    >
                                        15%
                                    </th>
                                </tr>
                                <tr>
                                    <td id="Benefits-benefits">Welcome gift</td>
                                    <td
                                        style={{
                                            background: `${tiers[0].color}`,
                                            textAlign: "center",
                                        }}
                                    >
                                        <VscCircleFilled />
                                    </td>
                                    <td
                                        style={{
                                            background: `${tiers[1].color}`,
                                            textAlign: "center",
                                        }}
                                    >
                                        <VscCircleFilled />
                                    </td>
                                    <td
                                        style={{
                                            background: `${tiers[2].color}`,
                                            textAlign: "center",
                                        }}
                                    >
                                        <VscCircleFilled />
                                    </td>
                                </tr>
                                <tr>
                                    <td id="Benefits-benefits">
                                        Discount in SPA
                                    </td>
                                    <td
                                        style={{
                                            background: `${tiers[0].color}`,
                                            textAlign: "center",
                                        }}
                                    >
                                        5%
                                    </td>
                                    <td
                                        style={{
                                            background: `${tiers[1].color}`,
                                            textAlign: "center",
                                        }}
                                    >
                                        7%
                                    </td>
                                    <td
                                        style={{
                                            background: `${tiers[2].color}`,
                                            textAlign: "center",
                                        }}
                                    >
                                        12%
                                    </td>
                                </tr>
                                <tr>
                                    <td id="Benefits-benefits">
                                        Complimentary Roundtrip transfer to/from
                                        the airport/port
                                    </td>
                                    <td
                                        style={{
                                            background: `${tiers[0].color}`,
                                            textAlign: "center",
                                        }}
                                    ></td>
                                    <td
                                        style={{
                                            background: `${tiers[1].color}`,
                                            textAlign: "center",
                                        }}
                                    >
                                        <VscCircleFilled />
                                    </td>
                                    <td
                                        style={{
                                            background: `${tiers[2].color}`,
                                            textAlign: "center",
                                        }}
                                    >
                                        <VscCircleFilled />
                                    </td>
                                </tr>
                                <tr>
                                    <td id="Benefits-benefits">
                                        Early check in - late check out upon
                                        availability
                                    </td>
                                    <td
                                        style={{
                                            background: `${tiers[0].color}`,
                                            textAlign: "center",
                                        }}
                                    ></td>
                                    <td
                                        style={{
                                            background: `${tiers[1].color}`,
                                            textAlign: "center",
                                        }}
                                    >
                                        <VscCircleFilled />
                                    </td>
                                    <td
                                        style={{
                                            background: `${tiers[2].color}`,
                                            textAlign: "center",
                                        }}
                                    >
                                        <VscCircleFilled />
                                    </td>
                                </tr>
                                <tr>
                                    <td id="Benefits-benefits">
                                        Discount on new openings
                                    </td>
                                    <td
                                        style={{
                                            background: `${tiers[0].color}`,
                                            textAlign: "center",
                                        }}
                                    ></td>
                                    <td
                                        style={{
                                            background: `${tiers[1].color}`,
                                            textAlign: "center",
                                        }}
                                    >
                                        10%
                                    </td>
                                    <td
                                        style={{
                                            background: `${tiers[2].color}`,
                                            textAlign: "center",
                                        }}
                                    >
                                        15%
                                    </td>
                                </tr>
                                <tr>
                                    <td id="Benefits-benefits">
                                        Complimentary a la carte dinner
                                    </td>
                                    <td
                                        style={{
                                            background: `${tiers[0].color}`,
                                            textAlign: "center",
                                        }}
                                    ></td>
                                    <td
                                        style={{
                                            background: `${tiers[1].color}`,
                                            textAlign: "center",
                                        }}
                                    ></td>
                                    <td
                                        style={{
                                            background: `${tiers[2].color}`,
                                            textAlign: "center",
                                        }}
                                    >
                                        <VscCircleFilled />
                                    </td>
                                </tr>
                                <tr>
                                    <td id="Benefits-benefits">
                                        Free upgrade (upon availability)
                                    </td>
                                    <td
                                        style={{
                                            background: `${tiers[0].color}`,
                                            textAlign: "center",
                                        }}
                                    ></td>
                                    <td
                                        style={{
                                            background: `${tiers[1].color}`,
                                            textAlign: "center",
                                        }}
                                    ></td>
                                    <td
                                        style={{
                                            background: `${tiers[2].color}`,
                                            textAlign: "center",
                                        }}
                                    >
                                        <VscCircleFilled />
                                    </td>
                                </tr>
                                <tr>
                                    <td id="Benefits-benefits">
                                        Free mini-bar refill
                                    </td>
                                    <td
                                        style={{
                                            background: `${tiers[0].color}`,
                                            textAlign: "center",
                                        }}
                                    ></td>
                                    <td
                                        style={{
                                            background: `${tiers[1].color}`,
                                            textAlign: "center",
                                        }}
                                    ></td>
                                    <td
                                        style={{
                                            background: `${tiers[2].color}`,
                                            textAlign: "center",
                                        }}
                                    >
                                        <VscCircleFilled />
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                        <br />
                        <br />
                    </div>
                )}
                {programLabel === "D7238698-8B30-44CC-A818-3D3E28176180" && (
                    <div className="Benefits-tableContainer-Parent">
                        <table className="Benefits-tableContainer">
                            <thead>
                                <tr className="Benefits-headings">
                                    <th
                                        style={{
                                            fontWeight: "600",
                                            textAlign: "center",
                                            width: "40%",
                                        }}
                                    >
                                        Loyalty Benefits
                                    </th>
                                    <th
                                        style={{
                                            background: `${tiers[0].color}`,
                                            fontWeight: "600",
                                            textAlign: "center",
                                        }}
                                    >
                                        Cap Silver 0 – 100,000{" "}
                                    </th>
                                    <th
                                        style={{
                                            background: `${tiers[1].color}`,
                                            fontWeight: "600",
                                            textAlign: "center",
                                        }}
                                    >
                                        Cap Gold 100,001 – 300,000
                                    </th>
                                    <th
                                        style={{
                                            background: `${tiers[2].color}`,
                                            fontWeight: "600",
                                            textAlign: "center",
                                            color: "white",
                                        }}
                                    >
                                        Cap Platinum 300,001
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td id="Benefits-benefits">
                                        Discount for direct bookings
                                    </td>
                                    <td
                                        style={{
                                            background: `${tiers[0].color}`,
                                            textAlign: "center",
                                        }}
                                    >
                                        5%
                                    </td>
                                    <td
                                        style={{
                                            background: `${tiers[1].color}`,
                                            textAlign: "center",
                                        }}
                                    >
                                        7%
                                    </td>
                                    <th
                                        style={{
                                            background: `${tiers[2].color}`,
                                            fontWeight: "600",
                                            textAlign: "center",
                                            color: "white",
                                        }}
                                    >
                                        10%
                                    </th>
                                </tr>
                                <tr>
                                    <td id="Benefits-benefits">
                                        Complimentary Welcome Amenities
                                    </td>
                                    <td
                                        style={{
                                            background: `${tiers[0].color}`,
                                            textAlign: "center",
                                        }}
                                    >
                                        ELITE 3
                                    </td>
                                    <td
                                        style={{
                                            background: `${tiers[1].color}`,
                                            textAlign: "center",
                                        }}
                                    >
                                        ELITE 2
                                    </td>
                                    <th
                                        style={{
                                            background: `${tiers[2].color}`,
                                            fontWeight: "600",
                                            textAlign: "center",
                                            color: "white",
                                        }}
                                    >
                                        ELITE 1
                                    </th>
                                </tr>
                                <tr>
                                    <td id="Benefits-benefits">
                                        Complimentary Late Check-Out
                                    </td>
                                    <td
                                        style={{
                                            background: `${tiers[0].color}`,
                                            textAlign: "center",
                                        }}
                                    >
                                        14:00{" "}
                                    </td>
                                    <td
                                        style={{
                                            background: `${tiers[1].color}`,
                                            textAlign: "center",
                                        }}
                                    >
                                        14:00{" "}
                                    </td>
                                    <td
                                        style={{
                                            background: `${tiers[2].color}`,
                                            textAlign: "center",
                                            color: "white",
                                        }}
                                    >
                                        17.00
                                    </td>
                                </tr>
                                <tr>
                                    <td id="Benefits-benefits">
                                        Farewell Gift /Receive a special gift
                                        upon arrival at participating hotels.
                                        Gifts vary by brand and region. (Olive
                                        Oil)
                                    </td>
                                    <td
                                        style={{
                                            background: `${tiers[0].color}`,
                                            textAlign: "center",
                                        }}
                                    >
                                        <VscCircleFilled />
                                    </td>
                                    <td
                                        style={{
                                            background: `${tiers[1].color}`,
                                            textAlign: "center",
                                        }}
                                    >
                                        <VscCircleFilled />
                                    </td>
                                    <td
                                        style={{
                                            background: `${tiers[2].color}`,
                                            textAlign: "center",
                                            color: "white",
                                        }}
                                    >
                                        <VscCircleFilled />
                                    </td>
                                </tr>
                                <tr>
                                    <td id="Benefits-benefits">
                                        Discount at Restaurants/Bars
                                    </td>
                                    <td
                                        style={{
                                            background: `${tiers[0].color}`,
                                            textAlign: "center",
                                        }}
                                    >
                                        10%
                                    </td>
                                    <td
                                        style={{
                                            background: `${tiers[1].color}`,
                                            textAlign: "center",
                                        }}
                                    >
                                        10%
                                    </td>
                                    <td
                                        style={{
                                            background: `${tiers[2].color}`,
                                            textAlign: "center",
                                            color: "white",
                                        }}
                                    >
                                        10%
                                    </td>
                                </tr>
                                <tr>
                                    <td id="Benefits-benefits">
                                        Discount on Spa Treatments/Retail
                                    </td>
                                    <td
                                        style={{
                                            background: `${tiers[0].color}`,
                                            textAlign: "center",
                                        }}
                                    >
                                        10%
                                    </td>
                                    <td
                                        style={{
                                            background: `${tiers[1].color}`,
                                            textAlign: "center",
                                        }}
                                    >
                                        10%
                                    </td>
                                    <td
                                        style={{
                                            background: `${tiers[2].color}`,
                                            textAlign: "center",
                                            color: "white",
                                        }}
                                    >
                                        10%
                                    </td>
                                </tr>
                                <tr>
                                    <td id="Benefits-benefits">
                                        Discount on Experiences
                                    </td>
                                    <td
                                        style={{
                                            background: `${tiers[0].color}`,
                                            textAlign: "center",
                                        }}
                                    >
                                        10%
                                    </td>
                                    <td
                                        style={{
                                            background: `${tiers[1].color}`,
                                            textAlign: "center",
                                        }}
                                    >
                                        10%
                                    </td>
                                    <td
                                        style={{
                                            background: `${tiers[2].color}`,
                                            textAlign: "center",
                                            color: "white",
                                        }}
                                    >
                                        10%
                                    </td>
                                </tr>
                                <tr>
                                    <td id="Benefits-benefits">
                                        Complimentary Early Check In{" "}
                                    </td>
                                    <td
                                        style={{
                                            background: `${tiers[0].color}`,
                                            textAlign: "center",
                                        }}
                                    ></td>
                                    <td
                                        style={{
                                            background: `${tiers[1].color}`,
                                            textAlign: "center",
                                        }}
                                    >
                                        11.00 am{" "}
                                    </td>
                                    <td
                                        style={{
                                            background: `${tiers[2].color}`,
                                            textAlign: "center",
                                            color: "white",
                                        }}
                                    >
                                        11.00 am{" "}
                                    </td>
                                </tr>
                                <tr>
                                    <td id="Benefits-benefits">
                                        Complimentary Dinner / Lunch Experience
                                        per person in room (max 100€ total)
                                    </td>
                                    <td
                                        style={{
                                            background: `${tiers[0].color}`,
                                            textAlign: "center",
                                        }}
                                    ></td>
                                    <td
                                        style={{
                                            background: `${tiers[1].color}`,
                                            textAlign: "center",
                                        }}
                                    >
                                        <VscCircleFilled />
                                    </td>
                                    <td
                                        style={{
                                            background: `${tiers[2].color}`,
                                            textAlign: "center",
                                            color: "white",
                                        }}
                                    >
                                        <VscCircleFilled />
                                    </td>
                                </tr>
                                {/* <tr>
            <td id='Benefits-benefits'>Free upgrade (upon availability)
</td>
            <td style={{ background: `${tiers[0].color}`, textAlign: 'center' }}></td>
            <td style={{ background: `${tiers[1].color}`, textAlign: 'center' }}></td>
            <td style={{ background: `${tiers[2].color}`, textAlign: 'center',color:'white' }}><VscCircleFilled /></td>

          </tr> */}
                                <tr>
                                    <td id="Benefits-benefits">
                                        Discount /Free Airport Transfer
                                    </td>
                                    <td
                                        style={{
                                            background: `${tiers[0].color}`,
                                            textAlign: "center",
                                        }}
                                    ></td>
                                    <td
                                        style={{
                                            background: `${tiers[1].color}`,
                                            textAlign: "center",
                                        }}
                                    >
                                        50% discount{" "}
                                    </td>
                                    <td
                                        style={{
                                            background: `${tiers[2].color}`,
                                            textAlign: "center",
                                            color: "white",
                                        }}
                                    >
                                        Free transfer
                                    </td>
                                </tr>
                                <tr>
                                    <td id="Benefits-benefits">
                                        Complimentary Spa Treatment per person
                                        in room up to 100EUR per person
                                    </td>
                                    <td
                                        style={{
                                            background: `${tiers[0].color}`,
                                            textAlign: "center",
                                        }}
                                    ></td>
                                    <td
                                        style={{
                                            background: `${tiers[1].color}`,
                                            textAlign: "center",
                                        }}
                                    ></td>
                                    <td
                                        style={{
                                            background: `${tiers[2].color}`,
                                            textAlign: "center",
                                            color: "white",
                                        }}
                                    >
                                        <VscCircleFilled />
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                        <br />
                        <br />
                    </div>
                )}

                {/*Savaidis*/}
                {programLabel === "3CF65E23-BA18-41D1-86C5-4FDAF77801D9" && (
                    <div className="Benefits-tableContainer-Parent">
                        <table className="Benefits-tableContainer">
                            <thead>
                                <tr className="Benefits-headings bg-[#ffffff]">
                                    <th
                                        className=" p-2"
                                        style={{ backgroundColor: "#ffffff" }}
                                    >
                                        Benefits
                                    </th>
                                    {SavaidistierColors.map((color, index) => (
                                        <th
                                            key={index}
                                            style={{
                                                backgroundColor: color,
                                                color: "white",
                                            }}
                                        >
                                            {
                                                [
                                                    "Member",
                                                    "Dreamer",
                                                    "Visionary",
                                                    "Iconic",
                                                ][index]
                                            }
                                        </th>
                                    ))}
                                </tr>
                            </thead>
                            <tbody>
                                {Object.entries(Savaidisbenefits).map(
                                    ([category, rows]) =>
                                        rows.map((row, rowIndex) => (
                                            <tr key={`${category}-${rowIndex}`}>
                                                {row.map((cell, cellIndex) => (
                                                    <td
                                                        key={cellIndex}
                                                        style={{
                                                            borderBottom:
                                                                "1px solid #ddd",
                                                            alignContent:
                                                                "flex-start",
                                                            whiteSpace:
                                                                "pre-line",
                                                            backgroundColor:
                                                                cellIndex > 0
                                                                    ? SavaidistierColors[
                                                                          cellIndex -
                                                                              1
                                                                      ]
                                                                    : "#ffffff",
                                                            color:
                                                                cellIndex < 1
                                                                    ? "black"
                                                                    : "white",
                                                        }}
                                                    >
                                                        {cell}
                                                    </td>
                                                ))}
                                            </tr>
                                        )),
                                )}
                            </tbody>
                        </table>
                        <p
                            className=""
                            style={{
                                backgroundColor: "rgb(236, 226, 237)",
                            }}
                        >
                            * Upon availability
                            {/** once per stay / minimum stay 3 nights <br></br> */}
                            {/*    *** for min 7 nights stay  </p>*/}
                        </p>
                    </div>
                )}

                {/*Master Collection*/}
                {programLabel === "AE17AE1F-5DAD-4EEA-8EDB-587167D492F1" && (
                    <div className="Benefits-tableContainer-Parent">
                        <table className="Benefits-tableContainer">
                            <thead>
                                <tr className="Benefits-headings bg-[#ffffff]">
                                    <th
                                        className=" p-2"
                                        style={{ backgroundColor: "#ffffff" }}
                                    >
                                        Benefits
                                    </th>
                                    {masterCollectionColors.map(
                                        (color, index) => (
                                            <th
                                                key={index}
                                                style={{
                                                    backgroundColor: color,
                                                    color:
                                                        index < 1
                                                            ? "#c33029"
                                                            : "white",
                                                }}
                                            >
                                                {
                                                    [
                                                        "Galactic Traveler",
                                                        "Intergalactic Traveler",
                                                        "Supergalactic Traveler",
                                                    ][index]
                                                }
                                            </th>
                                        ),
                                    )}
                                </tr>
                            </thead>
                            <tbody>
                                {Object.entries(masterCollectionBenefits).map(
                                    ([category, rows]) =>
                                        rows.map((row, rowIndex) => (
                                            <tr key={`${category}-${rowIndex}`}>
                                                {row.map((cell, cellIndex) => (
                                                    <td
                                                        key={cellIndex}
                                                        style={{
                                                            backgroundColor:
                                                                cellIndex > 0
                                                                    ? masterCollectionColors[
                                                                          cellIndex -
                                                                              1
                                                                      ]
                                                                    : "#ffffff",
                                                            color:
                                                                cellIndex < 3
                                                                    ? "#c33029"
                                                                    : "white",
                                                        }}
                                                    >
                                                        {cell}
                                                    </td>
                                                ))}
                                            </tr>
                                        )),
                                )}
                            </tbody>
                        </table>
                        <p
                            className=""
                            style={{
                                backgroundColor: "rgb(236, 226, 237)",
                            }}
                        >
                            * subject to availability <br></br>
                            For indirect bookings: Please refer to the seperate
                            tables available on the website.
                        </p>
                    </div>
                )}
            </div>
        </>
    );
}
